/* Language pack: hy */
export const translationsHy = {
	chatDropFiles: "Բաց թողեք ֆայլերն այստեղ՝ կցելու համար",
	resumeRecording: "Շարունակել",
	chatCallMissed: "Բաց թողնված",
	chatCallDeclined: "Մերժված",
	chatAudioConference: "Ձայնային կոնֆերանս",
	chatVideoConference: "Տեսակոնֆերանս",

	chatHistoryBeginning: "Զրույցի սկիզբը",
	chatHistoryEmpty: "Դեռ հաղորդագրություններ չկան",
	chatHistoryLoadFailed: "Չհաջողվեց բեռնել զրույցի պատմությունը։",
	personalTime: "Ընկերության տրամադրած ժամեր",
	hrPersonalHoursPerYear: "Տրամադրվող ժամեր՝ տարեկան",
	hrPersonalHoursHint: "Տարեկան ժամաքանակ՝ ուշացումների, շուտ ելքերի և բացակայությունների համար։ Չօգտագործված ժամերը հաջորդ տարի չեն փոխանցվում։",
	absenceDays: "Օրեր",
	absenceHours: "Ժամեր",
	absenceUnit: "Բացակայության հաշվառման միավոր",
	absenceRequest: "Բացակայության հայտ",
	absenceRequestHint: "Ընտրեք անցած կամ ապագա ամսաթվերը։ Մնացորդը նվազում է հայտը հաստատվելուց հետո։",
	absenceRequestSaved: "Հայտն ուղարկվել է հաստատման",
	absenceAvailable: "Մնացորդ",
	absenceUsed: "Օգտագործված / ամրագրված",
	sickBalanceDays: "Հիվանդության օրերի մնացորդ",
	personalBalanceHours: "Տրամադրված ժամերի մնացորդ",
	absenceBalanceHint: "Հաստատված ապագա բացակայությունները ներառված են օգտագործվածի մեջ։ Գրառումը չեղարկելիս կամ ջնջելիս մնացորդը վերականգնվում է։",

	chat: "Զրույց",
	IDCardImages: "ID Card փաստաթղթեր",
	IT: "ՏՏ",
	Status: "Կարգավիճակ",
	abbreviation: "Հապավում",
	aboutUsItems: "Մեր մասին տարրեր",
	absent: "Բացակա",
	absentDays: "Բացակայության օրեր",
	accept: "Ընդունել",
	actSendingDate: "Ակտի հանձնման ամսաթիվ",
	actionTimestamp: "Գործողության ժամանակային նշում",
	actionType: "Գործողության տեսակը",
	actions: "Գործողություններ",
	activateStep7_8_9: "ԷՀԳ բաժնին առաջադրանք ( 7, 8, 9 )",
	activateStep8: "Գեոդեզիական բաժնին առաջադրանք ( 8 )",
	activatedProjects: "Ակտիվացված նախագծեր",
	active: "Սկսված",
	activeCarts: "Ակտիվ զամբյուղներ",
	activeClients: "Ակտիվ հաճախորդներ",
	activeCustomers: "Ակտիվ հաճախորդներ",
	activeProjectSteps: "Ակտիվ նախագծային քայլեր",
	activePromos: "Ակտիվ ակցիաներ",
	activeSales: "Ակտիվ վաճառքներ",
	activeSalesEvents: "Ակտիվ վաճառքի իրադարձություններ",
	activeServices: "Ակտիվ ծառայություններ",
	activeSteps: "Ակտիվ քայլեր",
	activeStreams: "Ակտիվ հոսքեր",
	activeTasks: "Ակտիվ առաջադրանքներ",
	activeTime: "Գործող ժամ",
	activity: "Ակտիվություն",
	activityTimes: "Ակտիվության ժամանակներ",
	activityLoadFailed: "Չհաջողվեց բեռնել օգտատիրոջ տվյալ օրվա ակտիվությունը։",
	noActivityForDay: "Այս օրվա համար ակտիվություն չի գրանցվել։",
	currentInactivity: "Ընթացիկ պասիվություն",
	userActivityHistory: "Օգտատիրոջ ակտիվություն (վերջին 7 օրը)",
	actualHours: "Առաջադրանքի իրական ժամեր",
	adInterval: "Գովազդային միջակայք",
	adIntervalOverride: "Ծածկագրման կանոններ",
	adIntervalOverrideDesc: "Ծածկագրման կանոններ",
	adIntervalOverrideValue: "Ծածկագրման կանոններ",
	adPlaylist: "Գովազդային երգացանկ",
	adPlaylists: "Գովազդային նվագարկիչներ",
	adTracks: "Գովազդային երաժշտական գործեր",
	add: "Ավելացնել",
	addAttendance: "Ավելացնել հաճախելիություն",
	addFeature: "Ավելացնել գումարային գծի",
	addFeatureLine: "Ավելացնել գումարային գծի",
	addFiles: "Ավելացնել ֆայլեր",
	addMoreFiles: "Ավելացնել ավելի քան մեկ ֆայլ",
	addNew: "Ավելացնել նորը",
	addPriceLine: "Ավելացնել արժույթ",
	addRule: "Ավելացնել կանոն",
	startChat: "Սկսել զրույց",
	addToList: "Ավելացնել ցուցակում",
	addVacationInterval: "Ավելացնել արձակուրդի հատված",
	added: "Ավելացված է",
	additionalDetails: "Լրացուցիչ տեղեկություն",
	address: "Հասցե",
	addressData: "Հասցեային տվյալներ",
	advanceDeductions: "Կանխավճարի պահումներ",
	advertisement: "Գովազդ",
	age: "Տարիք",
	ageGroups: "Տարիքային խմբեր",
	ago: "Առաջ",
	agreedProjects: "Համաձայնեցված նախագծեր",
	agreementAquipment: "Շահագրգիռների համաձայնեցում",
	aiConversations: "Զրույցներ",
	album: "Ալբոմ",
	allArtists: "Բոլոր արտիստները",
	allAudioTracks: "Բոլոր աուդիո գործերը",
	allContentItems: "Բոլոր բովանդակության տարրերը",
	allFilesDeleted: "Բոլոր ֆայլերը անվերադարձ ջնջվել են",
	allFilesWillBeDeleted: "Բոլոր ֆայլերը անվերադարձ կջնջվեն",
	allPlaylists: "Բոլոր նվագարկիչները",
	allRegisteredClients: "Բոլոր գրանցված հաճախորդները",
	allTickets: "Բոլոր տոմսերը",
	amount: "Միավոր",
	analytics: "Վերլուծություն",
	answer: "Պատասխան",
	apartment: "Բնակարան",
	apply: "Կիրառել",
	appsMenu: "Հավելվածների ընտրացանկ",
	approved: "Հաստատված",
	approvedInterval: "Հաստատված ժամանակային հատված",
	archive: "Արխիվ",
	archived: "Արխիվացված",
	areYouSure: "Դուք համոզվա՞ծ եք",
	areYouSureToDelete: "Դուք վստա՞հ եք, որ ուզում եք ջնջել սա",
	arrived: "Ժամանեցին",
	artist: "Կատարող",
	artistObject: "Կատարողի օբյեկտ",
	assignedTo: "Նշանակված է",
	assignedToUser: "Նշանակված",
	assignmentToTheConstructionDepartment: "Շինարարական բաժնին առաջադրանքի տրամադրում",
	attach: "Կցել",
	attachFile: "Կցել ֆայլ",
	attachments: "Կից ֆայլեր",
	automationCenterAction: "Գործողություն",
	automationCenterActionResults: "Գործողությունների արդյունքներ",
	automationCenterActions: "Գործողություններ",
	automationCenterActionsCount: "{count} գործողություն",
	automationCenterActiveRules: "Ակտիվ կանոններ ({count})",
	automationCenterAddAction: "Ավելացնել գործողություն",
	automationCenterAddCondition: "Ավելացնել պայման",
	automationCenterAvailableFields: "Հասանելի դաշտեր՝ {fields}",
	automationCenterCancel: "Չեղարկել",
	automationCenterClearFilters: "Մաքրել զտիչները",
	automationCenterColActions: "Գործողություններ",
	automationCenterColDuration: "Տևողություն",
	automationCenterColEvent: "Իրադարձություն",
	automationCenterColLastRun: "Վերջին գործարկում",
	automationCenterColManage: "Կառավարում",
	automationCenterColName: "Անուն",
	automationCenterColRule: "Կանոն",
	automationCenterColRuleActions: "Կանոնի գործողություններ",
	automationCenterColRuleName: "Կանոնի անուն",
	automationCenterColStatus: "Կարգավիճակ",
	automationCenterColTimestamp: "Ժամանակ",
	automationCenterColTriggeredAt: "Գործարկման ժամ",
	automationCenterColTrigger: "Տրիգեր",
	automationCenterConditionsOptional: "Պայմաններ (ընտրովի)",
	automationCenterCreateRule: "Ստեղծել կանոն",
	automationCenterCreateRuleButton: "Ստեղծել կանոն",
	automationCenterDeleted: "Ջնջված",
	automationCenterDescription: "Նկարագրություն",
	automationCenterDescriptionPlaceholder: "Ի՞նչ է անում այս կանոնը",
	automationCenterDisabled: "Անջատված",
	automationCenterDomain: "Ոլորտ",
	automationCenterDomainFinance: "Ֆինանսներ",
	automationCenterDomainHr: "HR",
	automationCenterDomainIt: "IT",
	automationCenterDomainTicket: "Թիկետ",
	automationCenterEdit: "Խմբագրել",
	automationCenterEditRule: "Խմբագրել կանոն",
	automationCenterEnabled: "Միացված",
	automationCenterError: "Սխալ",
	automationCenterEvent: "Իրադարձություն",
	automationCenterExecutionLogs: "Կատարման մատյաններ",
	automationCenterFailed: "Ձախողված",
	automationCenterFailedDeleteRule: "Չհաջողվեց ջնջել կանոնը",
	automationCenterField: "Դաշտ",
	automationCenterFillRequiredFields:
		"Լրացրեք բոլոր պարտադիր դաշտերը և ավելացրեք առնվազն մեկ գործողություն",
	automationCenterFilterByStatus: "Զտել ըստ կարգավիճակի",
	automationCenterLogTitle: "Մատյան՝ {name}",
	automationCenterNewRule: "Նոր կանոն",
	automationCenterNoExecutionLogsYet: "Կատարման մատյաններ դեռ չկան։",
	automationCenterNone: "Չկա",
	automationCenterNoLogsFound: "Մատյաններ չեն գտնվել։",
	automationCenterNoRulesYet: "Ավտոմատացման կանոններ դեռ չկան։ Ստեղծեք ձեր առաջին կանոնը։",
	automationCenterNoUsersFound: "Օգտատերեր չեն գտնվել",
	automationCenterNoDepartmentsFound: "Բաժիններ չեն գտնվել",
	automationCenterSearchSelectDepartments: "Որոնել և ընտրել բաժիններ",
	automationCenterOperator: "Օպերատոր",
	automationCenterOperatorContains: "պարունակում է",
	automationCenterOperatorIn: "ներսում",
	automationCenterParameters: "Պարամետրեր",
	automationCenterPartial: "Մասնակի",
	automationCenterPriorityCritical: "Կրիտիկական",
	automationCenterPriorityHigh: "Բարձր",
	automationCenterPriorityLow: "Ցածր",
	automationCenterPriorityMedium: "Միջին",
	automationCenterRecentExecutions: "Վերջին կատարումներ",
	automationCenterRefresh: "Թարմացնել",
	automationCenterRuleDeletedSuccess: "Կանոնը հաջողությամբ ջնջվել է",
	automationCenterRuleName: "Կանոնի անուն",
	automationCenterRuleNamePlaceholder: "օր.՝ Աշխատակից արձակուրքում",
	automationCenterRuleSavedSuccess: "Կանոնը հաջողությամբ պահպանվել է։",
	automationCenterSearchSelectUsers: "Որոնել և ընտրել օգտատերեր",
	automationCenterSelectAction: "Ընտրել գործողություն",
	automationCenterSelectActionToExecute: "Ընտրել կատարման գործողությունը",
	automationCenterSelectDomain: "Ընտրել ոլորտ",
	automationCenterSelectEvent: "Ընտրել իրադարձություն",
	automationCenterSelectTriggerEvent: "Ընտրեք այս կանոնը գործարկող իրադարձությունը",
	automationCenterStatus: "Կարգավիճակ",
	automationCenterStatusFailed: "Ձախողված",
	automationCenterStatusPartial: "Մասնակի",
	automationCenterStatusSuccess: "Հաջողված",
	automationCenterSuccess: "Հաջողված",
	automationCenterThen: "Ապա...",
	automationCenterTitle: "Ավտոմատացման կենտրոն",
	automationCenterTotalExecutions: "Ընդամենը կատարումներ",
	automationCenterTriggerEvent: "Տրիգերի իրադարձություն",
	automationCenterTriggerPayload: "Տրիգերի բեռ",
	automationCenterUpdateRule: "Թարմացնել կանոն",
	automationCenterValue: "Արժեք",
	automationCenterView: "Դիտել",
	automationCenterWhen: "Երբ...",
	attendance: "Հաճախելիություն",
	attendanceFlag: "Հաճախելիության կարգավիճակ",
	attendanceRequiringAttention: "Ուշադրություն պահանջող աշխատակիցներ",
	attendanceNoAttentionItems: "Ուշադրություն պահանջող աշխատակիցներ չկան",
	attendanceMissingCheckIn: "Մուտքի նշում չկա",
	attendanceMissingCheckOut: "Ելքի նշում չկա",
	attendanceEarlyLeave: "Վաղաժամ հեռացում",
	attendanceEarlyMissings: "Վաղաժամ հեռացումներ",
	attendanceEarlyMissingHours: "Վաղաժամ բացակայության ժամեր",
	attendanceLateHours: "Ուշացման ժամեր",
	attendanceShowWorkedHours: "Ցույց տալ աշխատած ժամերը",
	attendanceUnapprovedAbsence: "Չհաստատված բացակայություն",
	attendanceDeptAttendance: "Հաճախելիությունը ըստ բաժինների",
	attendanceDeviceHealth: "Սարքերի վիճակ և համաժամացում",
	attendanceLastSync: "Վերջին համաժամացում",
	attendanceLiveFeed: "Հաճախելիության ուղիղ հոսք",
	attendanceLiveUsers: "Ակտիվ օգտատերեր",
	attendanceLiveTab: "Առցանց",
	attendanceInOffice: "Գրասենյակում",
	attendanceLiveInApit: "Առցանց APIT-ում",
	attendanceUsersInOfficeNow: "աշխատակից հիմա գրասենյակում է",
	attendanceLiveInApitNow: "օգտատեր հիմա առցանց է APIT-ում",
	attendanceNoOneInOffice: "Այս պահին ոչ ոք գրասենյակում չէ",
	attendanceNoLiveInApit: "Այս պահին ոչ ոք առցանց չէ APIT-ում",
	attendanceNoRecentPunches: "Վերջին նշումներ չկան",
	attendanceManualEntryTag: "Ձեռքով",
	attendanceUnmappedPunch: "Չմիացված",
	attendancePendingItems: "սպասման մեջ",
	flexCardTotal: "Flex քարտեր",
	attendanceCards: "Հաճախելիության քարտեր",
	flexCardTotalSubtitle: "Նշանակված կամ անտեսված Flex ID-ներ",
	flexCardsAttached: "Կցված",
	flexCardsAttachedSubtitle: "Օգտատերերին կցված եզակի ID-ներ",
	flexCardsIgnored: "Անտեսված",
	flexCardsIgnoredSubtitle: "Անտեսված է HR կարգավորումներում",
	flexCardsDuplicateAttached: "Կրկնակի կցված",
	flexCardIds: "քարտի ID-ներ",
	noDuplicateFlexCards: "Կրկնօրինակներ չկան",
	attendanceTrendPctOfEmployeesPresent: "Աշխատակիցների ներկայության %",
	yesterday: "Երեկ",
	attendanceFilterThisWeek: "Այս շաբաթ",
	attendanceFilterThisMonth: "Այս ամիս",
	attendanceFilterCustom: "Հատուկ ժամանակահատված",
	attendanceSelectRange: "Ընտրել ժամանակահատվածը",
	attendanceCustomRangeCapped: "Հատուկ ժամանակահատվածը սահմանափակված է 90 օրով",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "Այսօրվա ներկայություն",
	attendanceTitleYesterday: "Երեկվա ներկայություն",
	attendanceTitleThisWeek: "Այս շաբաթվա ներկայություն",
	attendanceTitleThisMonth: "Այս ամսվա ներկայություն",
	attendanceTitleCustom: "Ընտրված ժամանակահատվածի ներկայություն",
	attendanceTitleTodayKpis: "Այսօրվա ներկայության ցուցանիշներ",
	attendanceTitleYesterdayKpis: "Երեկվա ներկայության ցուցանիշներ",
	attendanceTitleThisWeekKpis: "Այս շաբաթվա ներկայության ցուցանիշներ",
	attendanceTitleThisMonthKpis: "Այս ամսվա ներկայության ցուցանիշներ",
	attendanceTitleCustomKpis: "Ընտրված ժամանակահատվածի ցուցանիշներ",
	attendanceTrendDays: "Ներկայության միտում — վերջին {n} օրերը",
	attendanceNotAttendedYet: "Դեռ չեն ներկայացել",
	attendanceUpcomingAbsences: "Առաջիկա բացակայություններ",
	attendanceUpcomingAbsencesEmpty: "Առաջիկա բացակայություններ չկան",
	attendanceUpcomingAbsencesTomorrow: "Վաղը",
	attendanceUpcomingAbsencesInDays: "{days} օրից",
	attendanceExceptions: "Ներկայության բացառություններ",
	attendanceExceptionsMissingCheckIn: "Բացակայող մուտքեր",
	attendanceExceptionsMissingCheckOut: "Բացակայող ելքեր",
	attendanceExceptionsEarlyLeaves: "Վաղաժամ հեռացումներ",
	attendanceExceptionsUnapprovedAbsences: "Չհաստատված բացակայություններ",
	attendanceExceptionsDuplicatePunches: "Կրկնվող նշումներ",
	attendanceMonthlyKpis: "Ամսական ներկայության ցուցանիշներ",
	attendanceKpiRate: "Ներկայության մակարդակ",
	attendanceKpiAvgArrival: "Միջին ժամանման ժամ",
	attendanceKpiLateArrivals: "Ուշացումներ",
	attendanceKpiAbsentDays: "Բացակայության օրեր",
	attendanceKpiOvertimeHours: "Արտաժամյա ժամեր",
	attendanceLeaveBalanceOverview: "Արձակուրդի մնացորդի ակնարկ",
	attendanceLeaveBalanceVacationRemaining: "Արձակուրդի մնացորդ",
	attendanceLeaveBalanceSickUsed: "Օգտագործված հիվանդության արձակուրդ",
	attendanceLeaveBalanceBusinessTrips: "Գործուղումներ",
	attendanceLeaveBalancePendingRequests: "Սպասող հայտեր",
	attendanceLeaveBalanceCoverage: "{covered}-ը {total} աշխատակիցներից",
	attendanceTopInsights: "Ներկայության հիմնական պատկերացումներ",
	attendanceInsightNoData: "Դեռ տվյալներ չկան",
	attendanceInsightHighestLateness: "{dept}-ն ունի ամենաբարձր ուշացումը այս շաբաթ ({delta})",
	attendanceInsightFullAttendanceToday: "{dept}-ն ունի 100% ներկայություն",
	attendanceInsightTrendImproved: "Ներկայությունը բարելավվել է {pct}%-ով նախորդ ժամանակահատվածի համեմատ",
	attendanceInsightTrendDeclined: "Ներկայությունը վատացել է {pct}%-ով նախորդ ժամանակահատվածի համեմատ",
	attendanceInsightApproachingOvertime: "{count} աշխատակից մոտենում է արտաժամյա սահմանին",
	attendancePreviousWeek: "Անցյալ շաբաթ",
	attendanceCurrentWeek: "Այս շաբաթ",
	attendanceAddInterval: "Ավելացնել միջակայք",
	attendanceBreakLabel: "Դադար",
	attendanceCorrectionMode: "Ուղղման ռեժիմ",
	attendanceCoveredLabel: "Ծածկված",
	attendanceCustomIntervals: "Անհատական միջակայքեր",
	attendanceDashboard: "Հաճախելիության վահանակ",
	attendanceReports: "Հաշվետվություններ",
	attendanceCalendarTab: "Օրացույց",
	reports: "Հաշվետվություններ",
	shiftCoverage: "Հերթափոխերի ծածկույթ",
	previousPeriod: "Նախորդ ժամանակահատված",
	nextPeriod: "Հաջորդ ժամանակահատված",
	failedToSave: "Չհաջողվեց պահպանել արտաժամյա աշխատանքի մեկնաբանությունը",
	expandForDailyDetail: "Բացեք տողը՝ օրական մանրամասները տեսնելու համար",
	noDataForPeriod: "Այս ժամանակահատվածի համար տվյալներ չկան",
	attendanceHistory: "Հաճախելիության պատմություն",
	attendanceDayOffTab: "Հանգստյան օր",
	attendanceDayType: "Օրվա տեսակ",
	attendanceDetectedIntervals: "Հայտնաբերված միջակայքեր",
	attendanceEditDay: "Խմբագրել օրը",
	attendanceHrsTotal: "Ընդհանուր ժամ",
	attendanceViewWeek: "Շաբաթ",
	attendanceViewMonth: "Ամիս",
	attendanceViewDay: "Օր",
	day: "Օր",
	attendanceOpenFrom: "Բաց է {time}-ից",
	attendanceFromStillActive: "{time}-ից → դեռ ակտիվ է",
	attendanceTotalWorked: "Ընդամենը աշխատած",
	attendanceMissingUncovered: "Բացակա / չընդգրկված",
	attendanceNoData: "Տվյալներ չկան",
	attendanceNoDataForDay: "Այս օրվա համար հաճախելիության տվյալներ չկան։",
	attendanceIntervalApprovedOk: "Հաստատված / OK",
	attendanceIntervalEachRowInvalid: "Յուրաքանչյուր միջակայքի համար նշեք վավեր սկիզբ և ավարտ",
	attendanceIntervalTimesInvalid: "Նշեք վավեր սկզբի և ավարտի ժամ",
	attendanceIntervalsMode: "Միջակայքեր",
	attendanceIntervalsReviewHint:
		"Ստուգեք իրական աշխատածը, արձակուրդը և բացակա միջակայքերը։ Ներքևում ավելացրեք ձեռքով ուղղման միջակայքերը՝ հաստատված, աշխատանք, հեռավար, հիվանդաձակուրդ, արձակուրդ, չվճարվող կամ այլ։",
	attendanceLogSubtitle: "Ներկայության ձեռքով մուտք — աշխատանք, հիվանդության օրեր, արձակուրդ",
	attendanceLogTitle: "Ներկայության մատյան",
	attendanceManualResolutionIntervals: "Ձեռքով լուծման միջակայքեր",
	attendanceMissingLabel: "Բացակայում է",
	attendanceNoManualIntervalsYet: "Ձեռքով միջակայքեր դեռ չեն ավելացվել",
	attendanceNoUncovered: "Չընդգրկված միջակայքեր չեն հայտնաբերվել",
	attendanceOptionalNotePlaceholder: "Ընտրովի նշում…",
	attendancePtoLeaveSection: "Արձակուրդ / բացակայություն",
	attendanceReport: "Հաճախելիության հաշվետվություն",
	attendanceResolveInterval: "Լուծել այս միջակայքը",
	attendanceResyncTooltip: "Վերասինխրոնացնել այս աշխատակցի հաճախելիությունը",
	attendanceResyncSuccess: "Հաճախելիության վերասինխրոնացումը սկսվեց",
	attendanceResyncFailed: "Հաճախելիության վերասինխրոնացումը ձախողվեց",
	attendanceSavedSuccess: "Ներկայությունը հաջողությամբ պահպանվեց",
	attendanceStatusOnTime: "Ժամանակին",
	attendanceStatusLate: "Ուշացում",
	attendanceStatusAbsent: "Բացակա",
	attendanceStatusUpcoming: "Առաջիկա",
	attendanceStatusPto: "Արձակուրդ / ԱՌ",
	attendanceStatusPartial: "Մասնակի",
	attendanceStatusOpen: "Բաց",
	attendanceStatusWeekend: "Հանգստյան օր",
	attendanceStatusHoliday: "Տոն",
	attendanceStatusNonWorking: "Ոչ աշխատանքային",
	attendanceSelectEmployeePrompt: "Ընտրեք աշխատակից՝ ներկայությունը տեսնելու համար",
	attendanceTrend: "Ներկայության միտում",
	attendanceTrendPctPresent: "% ներկա",
	attendanceUncoveredMissing: "Չընդգրկված / բացակա",
	attendanceUnsavedChanges: "Չպահպանված փոփոխություններ",
	attendanceWholeDayStatus: "Ամբողջ օրվա կարգավիճակ",
	shiftWorker: "Հերթափոխի աշխատող",
	attendanceStatusShift: "Հերթափոխ",
	attendanceIgnoreMode: "Անտեսել",
	attendanceIgnoreScopeWeekdays: "Շաբաթվա օրեր",
	attendanceIgnoreScopeDateRange: "Ամսաթվերի միջակայք",
	attendanceIgnoreScopeWeekdaysHint: "Կիրառվում է միայն ընտրված շաբաթվա օրերին այս ժամանակահատվածում։",
	attendanceIgnoreScopeDateRangeHint: "Կիրառվում է այս ժամանակահատվածի բոլոր օրերին։",
	attendanceIgnoreAppliesTo: "Կիրառվում է",
	attendanceIgnoreLateArrival: "Ուշացում",
	attendanceIgnoreEarlyLeave: "Շուտ ելք",
	attendanceIgnoreWindowStart: "Անտեսման միջակայքի սկիզբ",
	attendanceIgnoreWindowEnd: "Անտեսման միջակայքի ավարտ",
	attendanceIgnoreRulesList: "Անտեսման կանոններ",
	attendanceIgnoreRulesEmpty: "Անտեսման կանոններ դեռ չկան",
	attendanceIgnoreDaysOfWeekRequired: "Ընտրեք առնվազն մեկ օր",
	attendanceIgnoredLabel: "Անտեսված",
	attendanceNoCardLabel: "Քարտ չկա",
	attendanceWork: "Աշխատանք",
	attendanceWorked: "Աշխատած",
	attendanceWorkedIntervals: "Աշխատած միջակայքեր",
	attendanceMissingIntervals: "Բացակա միջակայքեր",
	attendanceStillInOffice: "Դեռ գրասենյակում է",
	attendanceAddEvent: "Ավելացնել իրադարձություն",
	attendanceAutoClosed: "Ավտոմատ փակված",
	attendanceAutoClosedAt: "Ավտոմատ փակվել է {time}-ին",
	automaticEvent: "Ավտոմատ իրադարձություն",
	attendanceAddAttendanceEvent: "Ավելացնել ներկայության իրադարձություն",
	attendanceDeleteEventTitle: "Ջնջե՞լ ներկայության իրադարձությունը",
	attendanceDeleteEventText: "Սա հեռացնում է միայն այս ձեռքով ավելացված մուտք/ելք իրադարձությունը։",
	attendanceNoMissingIntervals: "Այս օրվա համար բացակա միջակայքեր չկան",
	attendanceOfficeSince: "{time}-ից",
	attendanceLastOutAt: "Վերջին ելք {time}",
	attendanceEventSingular: "իրադարձություն",
	attendanceEventPlural: "իրադարձություն",
	attendancePunchIn: "Մուտք",
	attendancePunchOut: "Ելք",
	solveThis: "Լուծել",
	editSolvedStatus: "Խմբագրել լուծված կարգավիճակը",
	officeStatus: "Գրասենյակի կարգավիճակ",
	outOfOffice: "Գրասենյակից դուրս",
	noPunches: "Մուտք/ելք չկա",
	lastActionWasCheckIn: "Վերջին գործողությունը մուտք էր",
	lastActionWasCheckOut: "Վերջին գործողությունը ելք էր",
	noCheckInYet: "Դեռ մուտք չկա",
	manual: "Ձեռքով",
	resolved: "Լուծված",
	attendanceManualStatusApplyTicketTimeTo: "Կիրառել տոմսի ժամը՝",
	attendanceManualStatusColumnAttendanceType: "Ներկայության տեսակ",
	attendanceManualStatusColumnTimeAction: "Ժամի գործողություն",
	attendanceManualStatusMapsToType: "Համապատասխանում է ներկայության տեսակին",
	attendanceManualStatusTicketTimeAction: "Տոմսի ավտոմատացման ժամանակի գործողություն",
	attendanceTicketTimePhraseAdd: "Ավելացնել {type} ժամ",
	attendanceTicketTimePhraseSubtract: "Պակասեցնել {type} ժամ",
	attendanceTimeOpAdd: "Ավելացնել տոմսի ժամ",
	attendanceTimeOpNone: "Ժամային հաշվեկշռի փոփոխություն չկա",
	attendanceTimeOpSubtract: "Պակասեցնել տոմսի ժամ",
	attendanceTypeOptionAbsent: "Բացակա",
	attendanceTypeOptionBusinessTrip: "Գործուղում",
	attendanceTypeOptionHolidayNonWorking: "Տոնական / ոչ աշխատանքային",
	attendanceTypeOptionJustifiedAbsence: "Հիմնավորված բացակայություն (ներումով)",
	attendanceTypeOptionMaternity: "Ֆիզարձակուրդ / Մայրության արձակուրդ",
	attendanceTypeOptionPaidVacation: "Վճարովի արձակուրդ",
	attendanceTypeOptionRemote: "Հեռավար աշխատանք",
	attendanceTypeOptionSickLeave: "Հիվանդության թերթիկ",
	attendanceTypeOptionUnjustifiedAbsence: "Չհիմնավորված բացակայություն (առանց հարգելի պատճառի)",
	attendanceTypeOptionUnpaidLeave: "Անվճար արձակուրդ",
	attendanceTypeOptionWork: "Աշխատանք",
	audio: "Աուդիո",
	autoDeletion: "Ինքնաջնջում",
	averageDailyHours: "Միջին ժամեր օրական",
	avgDaily: "Օրական միջին",
	avgDailyHours: "Օրական միջին ժամեր",
	avgHoursPerWorkingDay: "Միջին ժամերը մեկ աշխատանքային օրվա համար",
	avgOrderValue: "Միջին պատվերի արժեք",
	avgResolutionTime: "Միջին լուծման ժամանակ",
	avgResponseTime: "Միջին պատասխանի ժամանակ",
	avgTracksPerPlaylist: "Միջին երաժշտական գործեր/նվագարկիչ",
	back: "Հետ",
	bank: "Բանկ",
	bankAccount: "Բանկային հաշիվ",
	bankCart: "Բանկային քարտ",
	bankEmitet: "Թողարկող բանկ",
	banner: "Բաններ",
	baseSalary: "Հիմնական աշխատավարձ",
	baseSalaryHourlyLinked: "Թարմացնում է ժամավճարը՝ հիմք ÷ սովորական ժամեր (երբ ժամերը > 0)։",
	basicInformation: "Հիմնական տեղեկատվություն",
	beginningOfAcquaintance: "Ծանոթության սկիզբ",
	beginningOfContract: "Պայմանագրի սկիզբ",
	beginningOfTraining: "Ուսուցման սկիզբ",
	benefits: "Նպաստներ",
	bestSeller: "Ամենավաճառված",
	bestSellers: "Լավագույն վաճառքներ",
	bestSellingItemsByRevenue: "Լավագույն վաճառվող ապրանքներ ըստ եկամտի",
	bitrate: "Բիթրեյթ",
	biweekly: "Երկշաբաթյա",
	blogItems: "Բլոգի տարրեր",
	blogs: "Բլոգներ",
	bonuses: "Բոնուսներ",
	bpm: "BPM",
	branch: "Էլեկտրական ցանց և մասնաճուղ",
	storeBranches: "Մասնաճյուղեր",
	storeBranchName: "Մասնաճյուղի անվանում",
	storeBranchLatitude: "Լայնություն",
	storeBranchLongitude: "Երկայնություն",
	storeBranchLoadError: "Չհաջողվեց բեռնել մասնաճյուղը։",
	branches: "Ֆիլիալների ցանկ",
	branchesCitiesVillages: "Պահեստներ, Քաղաքներ, Գյուղեր",
	brand: "Բրենդ",
	brands: "Բրենդներ",
	building: "Շենք",
	businessTrip: "Գործուղում",
	buttonText: "Կոճակի տեքստ",
	bypassSteps: "Քայլերի բաց թողնում",
	calAddCalendarTooltip: "Ստեղծել օրացույց և կիսվել թիմի հետ",
	calAddEvent: "Ավելացնել իրադարձություն",
	calAddReminder: "Ավելացնել հիշեցում",
	calAlarm15m: "15 րոպե առաջ",
	calAlarm1d: "1 օր առաջ",
	calAlarm1h: "1 ժամ առաջ",
	calAlarm1w: "1 շաբաթ առաջ",
	calAlarm2d: "2 օր առաջ",
	calAlarm2h: "2 ժամ առաջ",
	calAlarm30m: "30 րոպե առաջ",
	calAlarm5m: "5 րոպե առաջ",
	calAlarmAtEvent: "Իրադարձության պահին",
	calAllDay: "Ամբողջ օր",
	calApiNotConfigured: "Օրացույցի API-ը կարգավորված չէ։",
	calCalendarColorLabel: "Օրացույցի գույն",
	calCalendarCreateFailed: "Օրացույցը չստեղծվեց",
	calCalendarCreated: "Օրացույցը ստեղծվեց",
	calCalendarDeleted: "Օրացույցը ջնջված է",
	calCalendarNameLabel: "Օրացույցի անուն",
	calCalendarNamePh: "օր. Թիմային պլանավորում",
	calCalendarNameRequired: "Մուտքագրեք օրացույցի անունը",
	calCalendarSelect: "Օրացույց",
	calCalendarUpdateFailed: "Օրացույցը չթարմացվեց",
	calCalendarUpdated: "Օրացույցը թարմացվեց",
	calCalendarsLabel: "Օրացույցներ՝",
	calGoogleCalendarLabel: "Google Calendar՝",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "Հանդիպումներ՝",
	calCancel: "Չեղարկել",
	calCheckAll: "Նշել բոլորը",
	calColor: "Գույն",
	calCreateCalendar: "Ստեղծել օրացույց",
	calDay: "Օր",
	calDayOverviewTitle: "Օր",
	calDefaultCalendarName: "Օրացույց",
	calDelete: "Ջնջել",
	calDeleteCalendarHasEvents: "Այս օրացույցն ունի {count} իրադարձություն։ Ի՞նչ անել դրանց հետ։",
	calDeleteCalendarNoEvents: "Այս գործողությունը հնարավոր չէ վերացնել։",
	calDeleteCalendarOnly: "Ջնջել միայն օրացույցը",
	calDeleteCalendarTitle: "Ջնջե՞լ օրացույցը",
	calDeleteCalendarWithEvents: "Ջնջել իրադարձություններով",
	calDeleteEventText: "Գործողությունը հնարավոր չէ հետ շրջել։",
	calDeleteEventTitle: "Ջնջե՞լ իրադարձությունը",
	calDeleteFailed: "Ջնջման սխալ",
	calDescription: "Նկարագրություն",
	calDescriptionPh: "Ըստ ցանկության նկարագրություն",
	calEditCalendarTitle: "Խմբագրել օրացույցը",
	calEditCalendarTooltip: "Խմբագրել օրացույցը",
	calEditEvent: "Խմբագրել իրադարձությունը",
	calEditTooltip: "Խմբագրել",
	calEnd: "Ավարտ",
	calEndBeforeStart: "Ավարտը չի կարող նախորդել սկզբին",
	calEndTime: "Ավարտի ժամ",
	calEvent: "Իրադարձություն",
	calEventCreated: "Իրադարձությունը ստեղծվեց",
	calEventDeleted: "Իրադարձությունը ջնջվեց",
	calEventDetails: "Իրադարձության մանրամասներ",
	calEventTarget: "Թիրախ",
	calEventTitle: "Վերնագիր",
	calEventTitlePh: "Իրադարձության վերնագիր",
	calEventUpdated: "Իրադարձությունը թարմացվեց",
	calEventsPlural: "իրադարձություններ",
	calExportIcs: "Արտահանել .ics",
	calFailedLoadEvents: "Չհաջողվեց բեռնել իրադարձությունները",
	calHrBirthdayEvent: "Ծննդյան օր",
	calHrBirthdays: "Ծննդյան օրեր",
	calHrContractEnd: "Պայմանագրի ավարտ",
	calHrContractEndEvent: "Պայմանագրի վերջ",
	calHrContractStart: "Պայմանագրի սկիզբ",
	calHrContractStartEvent: "Պայմանագրի մեկնարկ",
	calHrIdEvent: "Նույնականացման վերջ",
	calHrIdExpiry: "Նույնականացման ժամկետ",
	calHrPassportEvent: "Անձնագրի ժամկետ",
	calHrPassportExpiry: "Անձնագրի վերջ",
	calHrPositionReview: "Պաշտոնի վերանայում",
	calHrPositionReviewEvent: "Պաշտոնի վերանայում",
	calHrSalaryReview: "Աշխատավարձի վերանայում",
	calHrSalaryReviewEvent: "Աշխատավարձի վերանայում",
	calImportButton: "Ներմուծել",
	calImportEventsTitle: "Իրադարձությունների ներմուծում",
	calImportFoundInFile: "գտնվեցին ֆայլում։ Ընտրեք օրացույց՝ ներմուծելու համար՝",
	calImportIcs: "Ներմուծել .ics",
	calImportedEventTitle: "Ներմուծված իրադարձություն",
	calItLabel: "ՏՏ՝",
	calItWarrantyEnd: "Երաշխիքի ավարտ",
	calItWarrantyEndEvent: "Երաշխիքի ավարտի իրադարձություն",
	calLinkedTo: "Կապված է",
	calLocation: "Վայր",
	calMonth: "Ամիս",
	calNewCalendarTitle: "Նոր օրացույց",
	calNewEvent: "Նոր իրադարձություն",
	calNoCalendar: "Առանց օրացույցի",
	calNoCalendarUncategorised: "Առանց օրացույցի (կատեգորիա չկա)",
	calNoEventsInIcs: ".ics ֆայլում իրադարձություններ չկան",
	calNoEventsThisDay: "Այս օրը իրադարձություններ չկան։",
	calNoRemindersThisDay: "Այս օրը հիշեցումներ չկան։",
	calDayWeatherMap: "Եղանակի քարտեզ",
	calDayHourlyForecast: "Ժամային կանխատեսում",
	calDayWeatherUnavailable: "Կանխատեսումը հասանելի չէ այս ամսաթվի համար",
	calDayEventsSection: "Իրադարձություններ",
	calDayRemindersSection: "Հիշեցումներ",
	calOpenAttendance: "Բացել ներկայությունը",
	calOpenEventLink: "Բացել հղումը",
	calOpenMeeting: "Բացել հանդիպումը",
	calOpenPc: "Բացել համակարգիչը",
	calOpenProfile: "Բացել պրոֆիլը",
	calOpenRelatedItem: "Բացել կապված էջը",
	calOpenReminderTarget: "Բացել հիշեցման թիրախը",
	calOpenTask: "Բացել առաջադրանքը",
	calOpenTicket: "Բացել տոմսը",
	calOpenUser: "Բացել օգտվողին",
	calPeopleLabel: "Անձինք՝",
	calReminders: "Հիշեցումներ",
	calRemindersLabel: "Հիշեցումներ՝",
	calAttendanceLabel: "Ներկայություն՝",
	calSecurityLabel: "Անվտանգություն՝",
	calSecurityAlerts: "Ահազանգեր",
	calSecuritySessions: "Սեսիաներ",
	calSecurityTokenExpiry: "Տոկենի ժամկետ",
	calRemindersToggle: "Ակտիվ հիշեցումներ",
	calSave: "Պահպանել",
	calSaveFailed: "Պահպանման սխալ",
	calShareWithUsers: "Կիսվել օգտատերերի հետ",
	calShareWithUsersPh: "Փնտրեք և ընտրեք մարդկանց",
	calStart: "Սկիզբ",
	calStartEndRequired: "Պահանջվում են սկիզբ և ավարտ",
	calStartTime: "Սկզբի ժամ",
	calSwalDelete: "Ջնջել",
	calTaskHigh: "Բարձր առաջնահերթություն",
	calTaskLow: "Ցածր առաջնահերթություն",
	calTaskMedium: "Միջին առաջնահերթություն",
	calTaskUrgent: "Հրատապ առաջադրանք",
	calTasksLabel: "Առաջադրանքներ՝",
	calTicketsLabel: "Տոմսեր՝",
	calToday: "Այսօր",
	calUserFallback: "Օգտվող",
	calWeek: "Շաբաթ",
	calculatePayroll: "Հաշվել աշխատավարձը",
	calculated: "Հաշվարկված",
	calculations: "Հաշվարկներ",
	calendarEventType: "Օրացույցի իրադարձություն",
	calling: "Զանգել",
	cancel: "Չեղարկել",
	clearText: "Մաքրել տեքստը",
	cancelAction: "Չեղարկել գործողությունը",
	cancelBack: "Հետ",
	cancelled: "Չեղարկված",
	cannotBeUndone: "Այս գործողությունը հնարավոր չէ հետարկել։",
	cannotPayOnline: "Հնարավոր չէ վճարել առցանց",
	cart: "Աշխատակիցներ",
	categories: "Կատեգորիաներ",
	category: "Կատեգորիա",
	categoryPerformance: "Կատեգորիաների արդյունավետություն",
	certificate: "Սերտիֆիկատ",
	certificateImages: "Վկայագրերի պատկերներ",
	certificates: "Վկայագրեր",
	changedDate: "Փոփոխության ամսաթիվը",
	channel: "Ալիք",
	channelWritePermissionDescription: "Միայն չատի ադմինները կարող են գրել հաղորդագրություններ",
	channels: "Ալիքներ",
	charts: "Գծապատկերներ",
	chatActions: "Չատի գործողություններ",
	chatActiveLabel: "Ակտիվ...",
	chatAddOption: "Ավելացնել տարբերակ",
	chatAddUsers: "Ավելացնել օգտատերեր",
	chatAddedToGroupNotification: "Ավելացվել եք խմբային չատում",
	chatAddedYouToGroup: "Ավելացրել է ձեզ",
	chatAudioCall: "Ձայնային զանգ",
	chatBulkDeleteFailed: "Խմբային ջնջումը ձախողվեց։",
	chatBulkForwardFailed: "Խմբային փոխանցումը ձախողվեց։",
	chatCallMessage: "Զանգի հաղորդագրություն",
	chatChoosingEmoji: "Ընտրում են էմոջի...",
	chatClickMapToChoosePoint: "Սեղմեք քարտեզի վրա՝ հատուկ կետ ընտրելու համար։",
	chatCoordinatesUnavailable: "Կոորդինատները հասանելի չեն",
	chatCopyCoordinates: "Պատճենել կոորդինատները",
	chatCopyCoordinatesFailed: "Չհաջողվեց պատճենել կոորդինատները։",
	chatCreatePoll: "Ստեղծել հարցում",
	chatCurrent: "Ընթացիկ",
	chatCurrentLocation: "Ընթացիկ տեղադրություն",
	chatDashboard: "Զրույցի վահանակ",
	chatDeleteFailed: "Ջնջումը ձախողվեց",
	chatDeleteForMe: "Ջնջել չատը",
	chatDeleteForMeConfirm:
		"Ջնջե՞լ այս չատը միայն ձեզ համար։ Ձեր տեսանելի պատմությունը կմաքրվի, և չատը կվերանա կողային ցանկից։",
	chatDeleteForMeOnly: "Ջնջել միայն ինձ համար",
	chatDeleteForParticipants: "Ջնջել նաև մասնակիցների համար",
	chatDeleteLocation: "Ջնջել տեղադրությունը",
	chatDeleteSelectedMessagesDescription:
		"Այս գործողությունը հեռացնում է ընտրված հաղորդագրությունները ձեր չատի տեսքից։ Այլ իրավունքներով չջնջվող հաղորդագրությունները կնշվեն որպես չհաջողված։",
	chatDeleteSelectedMessagesTitle: "Ջնջել ընտրված հաղորդագրությունները",
	chatDeletionPartialWarning:
		"Ջնջման արդյունքները կարող են մասնակի լինել, եթե որոշ հաղորդագրություններ արդեն ջնջված են կամ իրավունքների ստուգումը ձախողվի։",
	chatDepartmentSaveFailed: "Չհաջողվեց թարմացնել բաժինը",
	chatDepartmentSaveFailedTryAgain: "Խնդրում ենք նորից փորձել թարմացնել բաժինը։",
	chatDeselectAllMessages: "Չեղարկել ընտրությունը",
	chatDestinationChatsLabel: "Նպատակային չատեր",
	chatDestinationChatsPlaceholder: "Ընտրեք մեկ կամ մի քանի չատ",
	chatDirect: "Անմիջապես խոսք",
	chatDirectChat: "Անձնական չատ",
	chatBlockUser: "Արգելափակել օգտատիրոջը",
	chatBlockedContacts: "Արգելափակված կոնտակտներ",
	chatClearHistory: "Մաքրել պատմությունը",
	chatClearHistoryConfirm: "Մաքրե՞լ այս չատի պատմությունը միայն ձեզ համար։",
	chatEditFailed: "Չհաջողվեց խմբագրել հաղորդագրությունը",
	chatEditFailedTryAgain: "Խնդրում ենք նորից փորձել խմբագրել։",
	chatEditMessagePlaceholder: "Խմբագրել հաղորդագրությունը...",
	writeMessage: "Գրեք հաղորդագրություն...",
	chatEditingMessage: "Խմբագրվում է հաղորդագրությունը",
	chatMuteNotifications: "Անջատել ծանուցումները",
	chatMuteFor8Hours: "8 ժամով",
	chatMuteFor1Day: "1 օրով",
	chatMuteFor1Week: "1 շաբաթով",
	chatMuteForever: "Ընդմիշտ",
	chatPinChat: "Ամրացնել չատը",
	chatArchiveChat: "Արխիվացնել չատը",
	chatUnarchiveChat: "Վերադարձնել արխիվից",
	chatArchivedSection: "Արխիվ",
	chatPinnedSection: "Ամրացված",
	chatAllSection: "Բոլորը",
	chatMarkUnread: "Նշել որպես չկարդացված",
	chatMarkRead: "Նշել որպես կարդացված",
	chatBadgeDirect: "Անձնական",
	chatBadgeGroup: "Խումբ",
	chatBadgeChannel: "Ալիք",
	chatUnblockUser: "Հանել արգելափակումը",
	chatUnmuteNotifications: "Միացնել ծանուցումները",
	chatUnpinChat: "Հանել ամրացումը",
	chatUsers: "Օգտատերեր",
	chatExitSelectionMode: "Դուրս գալ ընտրության ռեժիմից",
	chatExpired: "Ժամկետն անցել է",
	chatForwardFailed: "Փոխանցումը ձախողվեց",
	chatForwardSelectedMessagesTitle: "Փոխանցել ընտրված հաղորդագրությունները",
	chatForwardableLabel: "Փոխանցվող",
	chatGeolocationUnavailable: "Գեոլոկացիան հասանելի չէ այս բրաուզերում։",
	chatGroupChat: "Խմբային չատ",
	chatGroupInfo: "Խմբի տվյալներ",
	chatGroupMembers: "Խմբի անդամներ",
	chatGroupSettings: "Խմբի կարգավորումներ",
	chatGroupSettingsDescription: "Սահմանեք խմբի նկարը և կապված HR բաժինը",
	chatID: "Չատի ID",
	chatImageUploadFailed: "Նկարի վերբեռնումը ձախողվեց",
	chatImageUploadFailedTryAgain: "Խնդրում ենք փորձել վերբեռնել այլ նկար։",
	chatIncludeLabel: "Ներառել",
	chatIsChoosingEmoji: "Ընտրում է էմոջի...",
	chatIsTyping: "Գրում է...",
	chatLastUpdated: "Վերջին թարմացում",
	chatLatitude: "Լայնություն",
	chatLive: "Ուղիղ",
	chatLiveFor: "Ակտիվ է",
	chatLiveLocation: "Ուղիղ տեղադրություն",
	chatLiveLocationOptInWarning:
		"Ուղիղ տեղադրության փոխանցումը միացվում է միայն ձեր համաձայնությամբ և կարելի է դադարեցնել ցանկացած պահի։",
	chatLiveLocationSharingActive: "Ուղիղ տեղադրության փոխանցումը ակտիվ է",
	chatLoadingLocation: "Տեղադրության բեռնում...",
	chatLoadingPoll: "Հարցման բեռնում...",
	chatLongitude: "Երկայնություն",
	chatMessagesCannotBeForwarded: "Հաղորդագրություն(ներ) չի կարելի փոխանցել և կբաց թողնվեն։",
	chatMessagesDeleted: "Հաղորդագրությունները ջնջված են",
	chatMessagesForwarded: "Հաղորդագրությունները փոխանցված են",
	chatMoreActions: "Լրացուցիչ գործողություններ",
	chatNoAvailableUsersToAdd: "Բոլոր հասանելի օգտատերերն արդեն այս խմբում են։",
	chatNoBackground: "Առանց պաստառի",
	chatNoChatsFound: "Չատեր չեն գտնվել",
	chatNoMessagesForwarded: "Ոչ մի հաղորդագրություն չի փոխանցվել։",
	chatNoSelectedMessagesDeleted: "Ընտրված հաղորդագրություններից ոչ մեկը չջնջվեց։",
	chatOpenDepartmentPage: "Բացել բաժնի էջը",
	chatOpenMap: "Բացել քարտեզը",
	chatOptionalAddressLabel: "Լրացուցիչ հասցեի պիտակ",
	chatOwnMessagesLabel: "Սեփական",
	chatPartialDelete: "Մասնակի ջնջում",
	chatPartialForward: "Մասնակի փոխանցում",
	chatPattern: "Նախշ",
	chatPickOnMap: "Ընտրել քարտեզից",
	chatPickPointOnMap: "Ընտրեք կետ քարտեզի վրա։",
	chatPinnedLocation: "Ամրացված տեղադրություն",
	chatPollAddAnotherOption: "Ավելացնել ևս մեկ տարբերակ",
	chatPollAddOptionFailed: "Չհաջողվեց ավելացնել տարբերակը։",
	chatPollAllowAddingOptions: "Թույլ տալ տարբերակների ավելացում",
	chatPollAllowMultipleAnswers: "Թույլ տալ մի քանի պատասխան",
	chatPollAllowRevote: "Թույլ տալ վերաքվեարկություն",
	chatPollAnonymous: "Անանուն հարցում",
	chatPollAnonymousCannotAddOptions: "Անանուն թեստը չի կարող թույլ տալ տարբերակների ավելացում։",
	chatPollAtLeastOptions: "Նվազագույն տարբերակներ՝",
	chatPollAutoClose: "Ինքնափակում",
	chatPollChangeVote: "Փոխել քվեն",
	chatPollChooseCorrectAnswer: "Ընտրեք առավելագույնը մեկ ճիշտ պատասխան։",
	chatPollCloseDate: "Փակման ամսաթիվ",
	chatPollCloseDateOrOpenPeriod:
		"Օգտագործեք կամ փակման ամսաթիվը, կամ ժամանակահատվածը, ոչ երկուսը միասին։",
	chatPollCloseFailed: "Չհաջողվեց փակել հարցումը։",
	chatPollClosePoll: "Փակել հարցումը",
	chatPollCorrectAnswer: "Ճիշտ պատասխան",
	chatPollCorrectAnswers: "Ճիշտ պատասխաններ",
	chatPollCreateFailed: "Չհաջողվեց ստեղծել հարցում։",
	chatPollDeletePoll: "Ջնջել հարցումը",
	chatPollDescriptionMax: "Նկարագրությունը առավելագույնը",
	chatPollExplanationMax: "Բացատրությունը առավելագույնը",
	chatPollHideResultsUntilClosed: "Թաքցնել արդյունքները մինչև փակվելը",
	chatPollIncorrectAnswer: "Սխալ պատասխան",
	chatPollLeaveEmptyKeepOpen: "Թողեք դատարկ՝ բաց պահելու համար",
	chatPollLeaveEmptyNoTimer: "Թողեք դատարկ՝ առանց ժմչփի",
	chatPollLoadVotersFailed: "Չհաջողվեց բեռնել քվեարկածներին։",
	chatPollMultipleChoice: "Բազմակի ընտրություն",
	chatPollNewOption: "Նոր տարբերակ",
	chatPollNoVoteYet: "Դեռ քվե չկա",
	chatPollNoVotersForOption: "Այս տարբերակի համար քվեարկող չի գտնվել։",
	chatPollOpenPeriod: "Բաց լինելու ժամանակ",
	chatPollOptionMax: "Տարբերակը առավելագույնը",
	chatPollOptionRequired: "Տարբերակը պարտադիր է։",
	chatPollOptionsUnique: "Տարբերակները պետք է եզակի լինեն։",
	chatPollPublic: "Հանրային",
	chatPollQuestionMax: "Հարցի երկարությունը առավելագույնը",
	chatPollQuestionRequired: "Հարցը պարտադիր է։",
	chatPollQuiz: "Թեստ",
	chatPollQuizExplanation: "Թեստի բացատրություն",
	chatPollRegular: "Սովորական",
	chatPollResultsHiddenUntilClosed: "Արդյունքները թաքցված են մինչև հարցման փակվելը։",
	chatPollSearchVoters: "Որոնել քվեարկածներին",
	chatPollShuffleOptions: "Խառնել տարբերակները",
	chatPollSingleChoice: "Մեկ ընտրություն",
	chatPollSingleChoiceOneCorrect: "Մի ընտրությամբ թեստում կարող է լինել միայն մեկ ճիշտ պատասխան։",
	chatPollSubmitVoteFailed: "Չհաջողվեց ուղարկել ձեր ձայնը։",
	chatPollViewVoters: "Դիտել քվեարկածներին",
	chatPollVoteRecorded: "Քվեն գրանցվել է",
	chatPollVotersLabel: "Քվեարկող",
	chatPollVotersTitle: "Քվեարկածներ",
	chatPollYouVoted: "Դուք քվեարկել եք։",
	chatPollYouVotedCanChange: "Դուք քվեարկել եք և կարող եք փոխել պատասխանը։",
	chatPreviewChronological: "Նախադիտում (ժամանակագրական)",
	chatProvider: "Մատակարար",
	chatReadCurrentLocationFailed: "Չհաջողվեց կարդալ ձեր ընթացիկ տեղադրությունը։",
	chatRefreshCurrentLocation: "Թարմացնել ընթացիկ տեղադրությունը",
	chatRuleAllow: "Այո",
	chatRuleDeny: "Ոչ",
	chatRuleTimed: "Այո, բայց սահմանափակ ժամանակով",
	chatRuleTimerDescription:
		"Օրինակ` նշեք 1, որպեսզի գործողությունը թույլատրվի միայն ուղարկելուց հետո առաջին րոպեի ընթացքում։",
	chatRuleTimerMinutes: "Ժամաչափը րոպեներով",
	chatSearchMessage: "Հաղորդագրության որոնում",
	chatSelectAllMessages: "Ընտրել բոլորը",
	chatSelectDepartment: "Ընտրեք HR բաժինը",
	chatSelectOrLoadLocationFirst: "Նախ ընտրեք կամ բեռնեք տեղադրություն։",
	chatSelectRepeatingBackground: "Ընտրեք կրկնվող պաստառ",
	chatSelectUsersToAdd: "Ընտրեք ավելացվող օգտատերերին",
	chatSelectedLabel: "Ընտրված",
	chatSelectionMode: "Ընտրության ռեժիմ",
	chatSendCurrentLocation: "Ուղարկել ընթացիկ տեղադրությունը",
	chatSendLocationFailed: "Չհաջողվեց ուղարկել տեղադրությունը։",
	chatSendPinnedLocation: "Ուղարկել ամրացված տեղադրությունը",
	chatSendVenue: "Ուղարկել վայրը",
	chatSentAt: "Ուղարկվել է",
	chatSettings: "Չատի կարգավորումներ",
	chatSettingsEditRule: "Խմբագրել հաղորդագրությունները",
	chatSettingsEditRuleDescription:
		"Ընտրեք` արդյոք ուղարկված հաղորդագրությունները կարող են խմբագրվել միշտ, երբեք կամ միայն սահմանափակ ժամանակով։",
	chatSettingsForwardRule: "Հաղորդագրությունների փոխանցում",
	chatSettingsForwardRuleDescription:
		"Թույլատրել փոխանցումը միշտ, երբեք կամ միայն հաղորդագրությունն ուղարկվելուց հետո սահմանափակ ժամանակով։",
	chatSettingsGlobalPageSubtitle:
		"Անձնական չատերի կանոնները կարգավորեք մեկ անգամ այստեղ։ Ընդհանուր խմբերի կանոնները սահմանում են միայն դրանց ադմինները։",
	chatSettingsGlobalPageTitle: "Չատի գլոբալ կարգավորումներ",
	chatSettingsGlobalRulesDescription:
		"Այս կանոնները կիրառվում են բոլոր անձնական չատերում։",
	chatSettingsGlobalSavedSuccess: "Չատի գլոբալ կարգավորումները հաջողությամբ թարմացվել են",
	chatSettingsCompactMode: "Կոմպակտ ռեժիմ",
	chatSettingsCompactModeDescription:
		"Փոքրացնել բացատներն ու ավատարների չափը՝ կողագոտում ավելի շատ չատեր տեղավորելու համար։",
	chatSettingsSidebarDescription: "Կառավարեք, թե ինչպես են չատերը ցուցադրվում ձախ կողագոտում։",
	chatSettingsSidebarTitle: "Չատի կողագոտի",
	chatSettingsShowLastMessage: "Ցուցադրել վերջին հաղորդագրությունը",
	chatSettingsShowLastMessageDescription:
		"Չատի կողագոտում ցուցադրել վերջին հաղորդագրության նախադիտումը և դրա ամսաթիվը կամ ժամը։",
	chatSettingsReplyRule: "Պատասխանել հաղորդագրություններին",
	chatSettingsReplyRuleDescription:
		"Կառավարեք պատասխանները` միշտ, երբեք կամ միայն հաղորդագրությունն ուղարկվելուց հետո որոշ ժամանակահատվածում։",
	chatSettingsResetToGlobal: "Վերականգնել խմբի լռելյայն կանոնները",
	chatSettingsRulesAdminOnly: "Միայն չատի ադմինները կարող են փոխել այս կանոնները։",
	chatSettingsRulesDescription:
		"Կարգավորեք հաղորդագրությունների փոխանցումը, պատասխանը և խմբագրումը, անհրաժեշտության դեպքում` ժամանակային սահմանափակումով։",
	chatSettingsRulesTitle: "Չատի կանոններ",
	chatSettingsSaveFailed: "Չհաջողվեց պահպանել չատի կարգավորումները",
	chatSettingsSaveFailedTryAgain: "Խնդրում ենք կրկին փորձել։",
	chatSettingsUsingCustomRules:
		"Այս խումբը օգտագործում է ադմինի սահմանած կանոնները։",
	chatSettingsUsingGlobalRules: "Այս խմբում գործում են լռելյայն կանոնները։",
	chatShareLocation: "Կիսվել տեղադրությամբ",
	chatSkipLabel: "Բաց թողնել",
	chatSkippedLabel: "Բաց թողնված",
	chatStartCall: "Սկսել զանգը",
	chatStartLiveSharing: "Սկսել ուղիղ կիսումը",
	chatStopLiveSharing: "Դադարեցնել ուղիղ կիսումը",
	chatType: "Չատի տեսակ",
	chatTypeToSearch: "Գրեք որոնելու համար",
	chatTyping: "Գրում են...",
	chatUnnamedChat: "Անանուն չատ",
	chatUpdatingSharedLocationFor: "Թարմացվում է այս տեղադրությունը",
	chatUploadGroupImage: "Վերբեռնել խմբի նկարը",
	chatUserInfo: "Օգտատիրոջ տվյալներ",
	chatUsersSaveFailed: "Չհաջողվեց ավելացնել օգտատերերին",
	chatUsersSaveFailedTryAgain: "Խնդրում ենք նորից փորձել ավելացնել ընտրված օգտատերերին։",
	chatVenue: "Վայր",
	chatVenueTitle: "Վայրի վերնագիր",
	chatVideoCall: "Տեսազանգ",
	chatViewReportedMessages: "Դիտել հաղորդված հաղորդագրությունները",
	chatWaitingDeviceCoordinates: "Սպասում ենք սարքի կոորդինատներին...",
	childcarePayment: "Մանկապարտեզի/խնամքի վճար",
	chooseBoard: "Ընտրեք տախտակը դիտելու համար դրա կատեգորիաները և առաջադրանքները",
	cities: "Քաղաքներ",
	city: "Քաղաք",
	clear: "Մաքրել",
	clearFilters: "Մաքրել ֆիլտրները",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"Սեղմեք ստորև բերված կոճակը՝ ձեր ճանապարհին հաջորդ քայլը կատարելու համար",
	contact: "Կոնտակտ",
	contactEngagement: "Կոնտակտների ներգրավվածություն",
	contactGroup: "Կոնտակտների խումբ",
	contactGroups: "Կոնտակտների խմբեր",
	contactPlaylist: "Կոնտակտի երգացանկ",
	contactProfile: "Կոնտակտի պրոֆիլ",
	contacts: "Կոնտակտներ",
	contactsByGender: "Կոնտակտներ ըստ սեռի",
	contactsByGroup: "Կոնտակտներ ըստ խմբի",
	contactsUsing: "Կոնտակտներ օգտագործում են",
	contactsWithCarts: "Կոնտակտներ զամբյուղներով",
	contactsWithFavorites: "Կոնտակտներ նախընտրածներով",
	clockInOut: "Ժամանում / Հեռացում",
	close: "Փակել",
	closeNavigation: "Փակել նավիգացիան",
	closeTicket: "Փակել տոմսը",
	closed: "Փակված է",
	closed_late: "Փակված է ժամկետից հետո",
	closedDate: "Փակման ամսաթիվ",
	closedTickets: "Փակված տոմսեր",
	cmDashboard: "Բովանդակության կառավարման վահանակ",
	code: "Կոդ",
	coin: "Մետաղադրամ",
	coinBurnTime: "Մետաղադրամների արտահանման ժամանակը",
	coinCount: "Մետաղադրամների քանակ",
	color: "Գույն",
	comment: "Մեկնաբանություն",
	commentTicket: "Մեկնաբանություն տոմսի մասին",
	commissions: "Կոմիսիոն վճարներ",
	communicationPreferences: "Հաղորդակցության նախապատվություններ",
	community: "Համայնք",
	company: "Ընկերություն",
	completed: "Ավարտված է",
	completedDate: "Առաջադրանքի ավարտի ամսաթիվ",
	completedTasks: "Ավարտված առաջադրանքներ",
	completionRate: "Ավարտման տոկոս",
	confirm: "Հաստատել",
	confirmAction: "Հաստատել գործողությունը",
	contactForm: "Կապվելու ձև",
	contactForms: "Կոնտակտային ձևեր",
	contactType: "Կապի տեսակ",
	contacts: "Կոնտակտներ",
	contentByType: "Բովանդակություն ըստ տեսակի",
	contentItems: "Բովանդակության տարրեր",
	contentManagementOverview: "Բովանդակության կառավարման համակարգի ակնարկ",
	contentOverTime: "Ժամանակի ընթացքում ստեղծված բովանդակություն (վերջին 30 օր)",
	continue: "Շարունակել",
	contract: "Պայմանագիր",
	contractEndDate: "Պայմանագրի ավարտի ամսաթիվ",
	contractStartDate: "Պայմանագրի սկզբի ամսաթիվ",
	contractor: "Կապալառու",
	copy: "Պատճենել",
	costOfBuildingPart: "Շինարարական մասի արժեք",
	costOfBuildingPermit: "Շին թույլտվության արժեք",
	country: "Երկիր",
	cpu: "Պրոցեսոր",
	create: "Ստեղծել պատվեր",
	createBoard: "Ստեղծել նոր տախտակ",
	createChat: "Ստեղծել չատ",
	createGroupChat: "Ստեղծել խմբային չատ",
	createGroupSubmit: "Ստեղծել խումբ",
	addNewCategory: "Ավելացնել նոր կատեգորիա",
	createNewCategory: "Ստեղծել նոր կատեգորիա",
	created: "Ստեղծվել է",
	createdAt: "Ստեղծվել է",
	createdBy: "Ստեղծված է",
	createdByUser: "Ստեղծված է օգտվողի կողմից",
	critical: "Կրիտիկական",
	crmDashboard: "CRM Վահանակ",
	cta1: "Կոչ գործողության բաժին 1 (CTA 1)",
	cta2: "Կոչ գործողության բաժին 2 (CTA 2)",
	cta3: "Կոչ գործողության բաժին 3 (CTA 3)",
	currency: "Արժույթ",
	currentMonth: "Ընթացիկ ամիս",
	currentWeek: "Ընթացիկ շաբաթ",
	currentlyStreaming: "Ներկայումս հեռարձակվում է",
	currentlyWorking: "Այժմ աշխատում է",
	custom: "Հատուկ",
	customerAcquisition: "Հաճախորդների ներգրավում",
	customerBaseOverview: "Հաճախորդների բազայի ակնարկ",
	customerInsights: "Հաճախորդների վերլուծություն",
	customerRelationshipOverview: "Հաճախորդների հետ հարաբերությունների կառավարման ակնարկ",
	dashboard: "Վահանակ",
	dashboardSubtitle: "Վահանակի ենթագիր",
	database: "Տվյալների բազա",
	date: "Ամսաթիվ",
	dateOfBirth: "Ծննդյան ամսաթիվ",
	dates: "Ամսաթվեր",
	datingAttendance: "Ծանոթության հաճախելիություն",
	dayOff: "Հանգստյան օր",
	meeting: "Հանդիպում",
	dayOffForAllEmployees: "Հանգստյան օր բոլոր աշխատակիցների համար",
	dayOffRemoved: "Հանգստյան օրը հեռացվեց",
	dayOffSavedForAllEmployees: "Հանգստյան օրը պահպանվեց բոլոր աշխատակիցների համար",
	days: "Օրեր",
	daysLeft: "Մնացած օրեր",
	daysOfWeek: "Շաբաթվա օրեր",
	daysWorked: "Աշխատած օրեր",
	deadLine: "Վերջնաժամկետ",
	deadline: "Ժամկետ",
	debt: "Պարտք",
	decline: "Մերժել",
	deductions: "Պահումներ",
	defaultEnergyMax: "Գործածված էներգիայի առավելագույն մակարդակ",
	defaultEnergyMin: "Գործածված էներգիայի նվազագույն մակարդակ",
	defaultStream: "Ստանդարտ հոսք",
	defaultStreams: "Լռելյայն հոսքեր",
	defaultStreamsDesc: "Լռելյայն հոսքեր",
	delays: "Ուշացումներ",
	delete: "Ջնջել",
	deleteForEveryone: "Ջնջել բոլորի համար",
	deletePermanently: "Ջնջել անվերադարձ",
	deleteRule: "Ջնջել կանոնը",
	deleteSelected: "Ջնջել ընտրվածները",
	deleted: "Ջնջված է",
	delivery: "Հանձնում",
	deliveryAddress: "Առաքման հասցե",
	deliveryMethod: "Առաքման եղանակը",
	density: "Խտություն",
	department: "Բաժին",
	departmentChatsHelp:
		"Կապեք խմբային և ալիքային զրույցները այս բաժնի հետ։ Ցանկը համաժամացվում է յուրաքանչյուր զրույցի բաժնի դաշտի հետ։",
	departmentLinkedChats: "Բաժնի զրույցներ",
	departments: "Բաժիններ",
	desc: "Նկարագրություն",
	description: "Նկարագրություն",
	designer: "Նախագծող",
	detailedFilters: "Մանրամասն ֆիլտրներ",
	detailedSteps: "Մանրամասն քայլերը",
	details: "Մանրամասներ",
	developed: "Ստեղծված է",
	developedBy: "Մշակված է",
	difference: "Տարբերություն",
	diplomaImages: "Դիպլոմի նկարներ",
	directMessages: "Ուղիղ նամակներ",
	disableSteps: "Անջատել քայլերը",
	disabledSteps: "Անաշխատ քայլեր",
	disk: "Սկավառակ",
	distributionByPaymentType: "Բաշխում վճարման տեսակով",
	domainFacility: "Կառույց",
	domainFinance: "Ֆինանսներ",
	domainHR: "HR",
	domainIT: "ՏՏ",
	domainKey: "Դոմենի բանալի",
	domainOther: "Այլ",
	domainSecurity: "Անվտանգություն",
	done: "Ավարտված է",
	download: "Ներբեռնել",
	downloadAsContact: "Ներբեռնել որպես կոնտակտ",
	draft: "Սևագիր",
	dragToReorder: "Վերադասավորել",
	dropFilesHere: "Ֆայլերը այստեղ տեղադրեք",
	dropFilesHereOrClick: "Ֆայլերը այստեղ տեղադրեք կամ սեղմեք, որ ավելացնեք բազմաթիվ",
	dropzoneText: "Քաշեք նկարները այստեղ կամ սեղմեք, որ ընտրեք ֆայլերը",
	dueDate: "Առաջադրանքի մարման ամսաթիվ",
	duration: "Տևողություն",
	ecommerceDashboard: "Էլեկտրոնային առևտրի վահանակ",
	edit: "Խմբագրել",
	editComment: "Խմբագրել մեկնաբանությունը",
	editItem: "Խմբագրել տարրը",
	editProject: "Խմբագրել նախագիծը",
	editRule: "Խմբագրել կանոնը",
	edited: "Խմբագրված է",
	editingRule: "Խմբագրել կանոնը",
	email: "Էլ. հասցե",
	sendEmail: "Ուղարկել էլ. նամակ",
	employee: "Աշխատակից",
	employees: "Աշխատակիցներ",
	employeesPerDepartment: "Աշխատակիցներ ըստ բաժինների",
	employeesWithOT: "Արտաժամյա աշխատանք ունեցող աշխատակիցներ",
	employerExpenses: "Աշխատատուի ծախսեր",
	employmentStatus: "Աշխատակիցների կարգավիճակ",
	emptyTrash: "Մաքրել աղբամանը",
	end: "Ավարտ",
	endDate: "Ավարտի ամսաթիվ",
	endDateMustBeLaterThanStartDate: "Ավարտի ամսաթիվը պետք է լինի սկզբի ամսաթվից հետո",
	endDateShort: "Ավարտ",
	endOfTraining: "Ուսուցման ավարտ",
	endTime: "Ավարտի ժամը",
	ends: "Վերջանում է",
	energyLevel: "Էներգետիկ մակարդակ",
	energyScheduling: "Էներգետիկ ծածկագրում",
	enterAmount: "Մուտքագրեք միավորը",
	enterFeatureSuffix: "Մուտքագրեք սուֆիքսի տեքստ",
	enterFeatureText: "Մուտքագրեք գումարային գծի տեքստ",
	enterGroupName: "Մուտքագրեք խմբի անվանումը...",
	enterLabel: "Մուտքագրեք անվանումը",
	enterPersons: "Մուտքագրեք մարդկանց քանակը",
	enterRuleName: "Մուտքագրեք ծածկագրման անունը",
	entityTypeLabel: "Տեսակ",
	entry: "Մուտք",
	error: "Սխալ",
	errorMessage: "Պատահեց սխալ, խնդրում ենք փորձել նորից:",
	errorOccurred: "Պատահեց սխալ",
	errorPageButton: "Վերադառնալ գլխավոր էջ",
	errorPageHelpText: "Օգնության կարիք ունե՞ք։ Կապվեք մեր աջակցության թիմի հետ",
	errorPageSecondaryButton: "Հաղորդել այս խնդրի մասին",
	errorPageSubtitle: "Էջը, որը որոնում եք, գոյություն չունի",
	errorPageText:
		"Մի անհանգստացեք, դա պատահում է ամենալավների հետ! Էջը կարող էր տեղափոխվել, ջնջվել, կամ դուք կարող էիք սխալ URL մուտքագրել: Եկեք ձեզ վերադարձնենք ճիշտ ուղու վրա:",
	errorPageTitle: "Ուփս! Ինչ-որ բան սխալ է",
	errorUserNotFound: "Օգտատերը չի գտնվել",
	estOTPay: "Արտաժամյայի (OT) մոտավոր վճար",
	estimatedHours: "Առաջադրանքի գնահատված ժամեր",
	eventType: "Իրադարձության տեսակ",
	exit: "Ելք",
	expectedSalary: "Ակնկալվող աշխատավարձ",
	expireDate: "Ավարտի ամսաթիվ",
	expired: "Ավարտվել է",
	expiresOn: "Ավարտվում է",
	expiringIdCards: "Ժամկետանց ID քարտեր",
	expiringPassports: "Ժամկետանց անձնագրեր",
	export: "Արտահանում",
	exportData: "Տվյալների արտահանում",
	exportToExcel: "Արտահանել Excel",
	extraLarge: "Շատ մեծ",
	extraSmall: "Շատ փոքր",
	faqQuestions: "ՀՏՀ հարցեր",
	favorites: "Նախընտրելի",
	features: "Ֆունկցիաներ",
	female: "Իգական",
	fields: "Դաշտեր",
	file: "Ֆայլ",
	fileHasBeenRemoved: "Ֆայլը ջնջվել է",
	fileMovedToTrash: "Ֆայլը տեղադրվել է աղբամանի մեջ",
	fileRestored: "Ֆայլը վերականգնվել է",
	fileWillBeMovedToTrash: "Ֆայլը կտեղադրվի աղբամանի մեջ",
	files: "Ֆայլեր",
	filesRestored: "Ֆայլերը վերականգնվել են",
	filesWillBePermanentlyDeleted: "ֆայլեր անվերադարձ կջնջվեն։",
	filter: "Ֆիլտր",
	filterBy: "Ֆիլտրել ըստ",
	filters: "Ֆիլտրներ",
	finish: "Ավարտել",
	firstIn: "Առաջին մուտք",
	firstName: "Անուն",
	forgotPassword: "Մոռացել եմ գաղտնաբառը",
	forward: "Փոխանցել",
	forwardMessage: "Փոխանցել նամակը",
	forwarded: "Փոխանցված",
	forwardedFrom: "Փոխանցված է՝",
	fri: "Ուրբաթ",
	from: "Ումից / Ինչից",
	fromAttendanceLogs:
		"Լրացվում է աշխատակցի և ժամանակաշրջանի ներկայության մատյաններից։ Կարող եք փոփոխել։",
	fromDb: "Տվյալների բազայից",
	fromHrSettings: "HR կարգավորումներ",
	gallery: "Պատկերասրահ",
	gender: "Սեռ",
	genderDistribution: "Սեռի բաշխում",
	globalFilter: "Ընդհանուր ֆիլտր",
	globalSearchClose: "Փակել",
	globalSearchCmd_goCalendar_desc: "Օրացույցի իրադարձություններ",
	globalSearchCmd_goCalendar_label: "Գնալ օրացույց",
	globalSearchCmd_goChat_desc: "Բացել հաղորդագրությունները",
	globalSearchCmd_goChat_label: "Գնալ զրույց",
	globalSearchCmd_goCrm_desc: "Հաճախորդների կառավարում",
	globalSearchCmd_goCrm_label: "Գնալ CRM",
	globalSearchCmd_goFinance_desc: "Ֆինանսների մոդուլ",
	globalSearchCmd_goFinance_label: "Գնալ ֆինանսներ",
	globalSearchCmd_goHr_desc: "Անձնակազմի մոդուլ",
	globalSearchCmd_goHr_label: "Գնալ ԱՀԿ (HR)",
	globalSearchCmd_goIt_desc: "IT սարքավորում",
	globalSearchCmd_goIt_label: "Գնալ IT",
	globalSearchCmd_goProjects_desc: "Նախագծերի բազա",
	globalSearchCmd_goProjects_label: "Գնալ նախագծեր",
	globalSearchCmd_goRadio_desc: "Երաժշտություն և նվագացանկեր",
	globalSearchCmd_goRadio_label: "Գնալ ռադիո",
	globalSearchCmd_goTickets_desc: "Աջակցության համակարգ",
	globalSearchCmd_goTickets_label: "Գնալ թիկետներ",
	globalSearchCmd_goTodo_desc: "Վահանակներ և առաջադրանքներ",
	globalSearchCmd_goTodo_label: "Գնալ Todo",
	globalSearchCmd_messageUser_desc: "Բացել զրույցը հաղորդագրության համար",
	globalSearchCmd_messageUser_label: "Հաղորդագրություն օգտվողին",
	globalSearchCmd_newClient_desc: "Ավելացնել CRM հաճախորդ",
	globalSearchCmd_newClient_label: "Նոր հաճախորդ",
	globalSearchCmd_newOrder_desc: "Ստեղծել պատվեր",
	globalSearchCmd_newOrder_label: "Նոր պատվեր",
	globalSearchCmd_newProject_desc: "Ստեղծել նախագիծ",
	globalSearchCmd_newProject_label: "Նոր նախագիծ",
	globalSearchCmd_newTask_desc: "Ստեղծել առաջադրանք",
	globalSearchCmd_newTask_label: "Նոր առաջադրանք",
	globalSearchCmd_newTicket_desc: "Ստեղծել աջակցության տոմս",
	globalSearchCmd_newTicket_label: "Նոր տոմս",
	globalSearchCommandBadge: "Հրաման",
	globalSearchCommands: "Հրամաններ",
	globalSearchCopied: "Պատճենվեց!",
	globalSearchCopyLink: "Պատճենել հղումը",
	globalSearchDirectMessage: "Անձնական հաղորդագրություն",
	globalSearchFilterAll: "Բոլորը",
	globalSearchFilterCalendar: "Օրացույց",
	globalSearchFilterChats: "Զրույցներ",
	globalSearchFilterDevices: "Սարքեր",
	globalSearchFilterEcom: "Էլեկտրոնային առևուր",
	globalSearchFilterFinance: "Ֆինանսներ",
	globalSearchFilterPeople: "Մարդիկ",
	globalSearchFilterProjects: "Նախագծեր",
	globalSearchFilterRadio: "Ռադիո",
	globalSearchFilterTickets: "Տոմսեր",
	globalSearchFilterTodo: "Առաջադրանքներ",
	globalSearchHidePreview: "Թաքցնել նախադիտումը",
	globalSearchNavigate: "Նավարկում",
	globalSearchOpen: "Բացել",
	globalSearchOpenInNewTab: "Բացել նոր ներդիրում",
	globalSearchPageBadge: "Էջ",
	globalSearchPlaceholder: "Որոնել APIT-ում՝ օգտատերեր, տոմսեր, զրույցներ, սարքեր…",
	globalSearchPreviewAddress: "Հասցե",
	globalSearchPreviewArtist: "Կատարող",
	globalSearchPreviewChat: "Զրույց",
	globalSearchPreviewCompany: "Ընկերություն",
	globalSearchPreviewCreated: "Ստեղծված",
	globalSearchPreviewDeviceId: "Սարքի ID",
	globalSearchPreviewEmail: "Էլ. փոստ",
	globalSearchPreviewEmployeeNumber: "Աշխատակցի №",
	globalSearchPreviewEnd: "Ավարտ",
	globalSearchPreviewInfo: "Տեղեկություն",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "Վայր",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "Համար",
	globalSearchPreviewOrderNumber: "Պատվեր №",
	globalSearchPreviewPhone: "Հեռախոս",
	globalSearchPreviewSent: "Ուղարկված",
	globalSearchPreviewStart: "Սկիզբ",
	globalSearchPreviewUsername: "Օգտանուն",
	globalSearchPreviewVendor: "Մատակարար",
	globalSearchPreviewVersion: "Տարբերակ",
	globalSearchRecentSearches: "Վերջին որոնումներ",
	globalSearchRecentlyOpened: "Վերջին բացվածները",
	globalSearchSectionArtists: "Կատարողներ",
	globalSearchSectionAttendanceDevices: "Հաճախման սարքեր",
	globalSearchSectionBrands: "Բրենդներ",
	globalSearchSectionCalendarEvents: "Օրացույցի իրադարձություններ",
	globalSearchSectionCameras: "Տեսախցիկներ",
	globalSearchSectionChats: "Զրույցներ",
	globalSearchSectionClientGroups: "Հաճախորդների խմբեր",
	globalSearchSectionClients: "Հաճախորդներ",
	globalSearchSectionCpus: "Պրոցեսորներ",
	globalSearchSectionDepartments: "Բաժիններ",
	globalSearchSectionEcomCategories: "Կատեգորիաներ",
	globalSearchSectionFinanceCardIssuers: "Քարտերի թողարկողներ",
	globalSearchSectionFinanceCards: "Քարտեր",
	globalSearchSectionFinanceCategories: "Ֆինանսական կատեգորիաներ",
	globalSearchSectionFinanceTransactions: "Գործարքներ",
	globalSearchSectionGpus: "Գրաֆիկական քարտեր",
	globalSearchSectionKeyboards: "Ստեղնաշարեր",
	globalSearchSectionLaptops: "Դյուրակիրներ",
	globalSearchSectionMessages: "Հաղորդագրություններ",
	globalSearchSectionMice: "Մկներ",
	globalSearchSectionMonitors: "Մոնիտորներ",
	globalSearchSectionOrders: "Պատվերներ",
	globalSearchSectionPcs: "Անհատական համակարգիչներ (PC)",
	globalSearchSectionPlaylists: "Նվագացանկեր",
	globalSearchSectionPositions: "Պաշտոններ",
	globalSearchSectionPrinters: "Տպիչներ",
	globalSearchSectionProblems: "Խնդիրներ",
	globalSearchSectionProducts: "Ապրանքներ",
	globalSearchSectionProjects: "Նախագծեր",
	globalSearchSectionRams: "ՕՀՊ (RAM)",
	globalSearchSectionRoms: "Կոշտ սկավառակ (ROM)",
	globalSearchSectionRooms: "Սենյակներ",
	globalSearchSectionRouters: "Երթուղիչներ (Routers)",
	globalSearchSectionSmbs: "SMB պանակներ",
	globalSearchSectionSoftware: "Ծրագրային ապահովում",
	globalSearchSectionSwitches: "Անջատիչներ (Switches)",
	globalSearchSectionTelephones: "Հեռախոսներ",
	globalSearchSectionTickets: "Տոմսեր",
	globalSearchSectionTodoBoards: "Վահանակներ",
	globalSearchSectionTodoCategories: "Կատեգորիաներ",
	globalSearchSectionTodoTasks: "Առաջադրանքներ",
	globalSearchSectionTracks: "Երգեր",
	globalSearchSectionUsers: "Մարդիկ",
	globalSearchSectionWarrantyProviders: "Երաշխիքի մատակարարներ",
	globalSearchSelectPreview: "Ընտրեք տարր նախադիտման համար",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "Ցուցադրել նախադիտումը",
	globalSearchSubtitle: "Որոնում բոլոր մոդուլներում",
	globalSearchSuggest1: "Որոնել ինձ հանձնարարված թիկետները",
	globalSearchSuggest2: "Գտնել աշխատակցի էլ. փոստով",
	globalSearchSuggest3: "Որոնել զրույցի հաղորդագրություններում",
	globalSearchSuggest4: "Գտնել սարք IP-ով",
	globalSearchSuggest5: "Որոնել հաճախորդի հեռախոսով",
	globalSearchSuggest6: "Գնալ նախագծեր",
	globalSearchTrySearchingFor: "Փորձեք որոնել",
	goBack: "Վերադառնալ",
	goToMessage: "Գնալ հաղորդագրությանը",
	goToUserAttendanceTab: "Օգտվողներ → Ներկայություն",
	goToUserAttendanceTabTooltip: "Բացել այս աշխատակցին HR օգտատերերում՝ Ներկայություն ներդիրով",
	gpu: "Տեսաքարտ",
	grossSalary: "Համախառն աշխատավարձ (Gross)",
	group: "Խումբ",
	groupChat: "Խմբային չատ",
	groupChatWritePermissionDescription: "Չատի բոլոր մասնակիցները կարող են գրել հաղորդագրություններ",
	groupChats: "Խմբային չատեր",
	groupName: "Խմբի անվանում (ըստ ցանկության)",
	healthInsurance: "Առողջապահական ապահովագրություն",
	healthInsuranceBenefit: "Առողջապահական ապահովագրություն (նպաստ)",
	help: "Օգնություն",
	hideAllSteps: "Թաքցնել բոլոր քայլերը",
	hideHistory: "Թաքցնել պատմությունը",
	hideProjectDetails: "Թաքցնել նախագծի մանրամասները",
	hideTableColumnFilters: "Թաքցնել սյունակների ֆիլտրերը",
	hideTimeline: "Թաքցնել ժամանակագրությունը",
	high: "Բարձր",
	highestSpendingCustomers: "Ամենաշատ ծախսող հաճախորդներ",
	highlight: "Առանձնացնել",
	highlightFeature: "Առանձնացնել տողը",
	history: "Պատմություն",
	historyTable: "Պատմության աղյուսակ",
	holiday: "Տոն",
	holidayNonWorking: "Ոչ աշխատանքային/տոնական օր",
	hourlyRate: "Ժամավճար",
	hourlyRateBaseLinked:
		"Թարմացնում է հիմնական աշխատավարձը՝ ժամավճար × սովորական ժամեր (երբ ժամերը > 0)։",
	hr2025RateReferenceTables: "2025 դրույքների տեղեկատու աղյուսակներ",
	hrAccrualAnnualTotal: "Տարեկան ընդամենը՝ {amount} օր",
	hrAccrualDaily: "Օրական (÷ 365)",
	hrAccrualEachDay: "Ամեն օր՝ +{amount} արձակուրդի օր",
	hrAccrualEachMonthFirst: "Ամսի 1-ին՝ +{amount} արձակուրդի օր",
	hrAccrualMethod: "Կուտակման եղանակ",
	hrAccrualMethodDesc: "Ինչպես է կուտակվում արձակուրդը",
	hrAccrualMonthly: "Ամսական (÷ 12, ամսի 1-ին)",
	hrAccrualMonthlyEquivalent: "Ամսական համարժեք՝ ~{amount} օր",
	hrAccrualPreview: "Կուտակման նախադիտում",
	hrArmeniaIncomeTaxCalculator: "Հայաստանի եկամտային հարկի հաշվիչ",
	hrArmeniaTaxRates: "Հայաստանի հարկային դրույքներ",
	hrCalcSummaryGrossToNet:
		"Գրանցված {gross} AMD աշխատավարձի դեպքում դուք կստանաք {net} AMD ձեռքին՝ հանելով {deductions} AMD հարկեր և ներդրումներ։",
	hrCalcSummaryNetToGross:
		"Ձեռքին {net} AMD ստանալու համար պայմանագրում պետք է նշված լինի {gross} AMD համախառն աշխատավարձ։",
	hrCalculationBreakdown: "Հաշվարկի մանրամասնում",
	hrCalculationDirection: "Հաշվարկի ուղղություն",
	hrDefaultBenefitsDescription:
		"Այս լռելյայն արժեքները կիրառվում են բոլոր աշխատավարձի հաշվարկներում, եթե աշխատակցի համար այլ բան չի սահմանված։",
	hrDefaultMonthlyBenefits: "Լռելյայն ամսական նպաստներ (AMD)",
	hrDesiredNetSalaryLabel: "Ցանկալի զուտ աշխատավարձ (ձեռքին)",
	hrEmployeePensionLabel: "Աշխատակցի թոշակային վճար՝",
	hrEmployeePensionRate: "Աշխատակցի թոշակային դրույք",
	hrEmployeePensionRateDesc: "Պարտադիր 1973-ից հետո ծնվածների համար (2,5%)",
	hrEmployerPensionRate: "Աշխատատուի թոշակային դրույք",
	hrEmployerPensionRateDesc: "Աշխատատուի թոշակային ներդրում (2,5%)",
	hrFailedToSaveSettings: "Կարգավորումները պահպանել չհաջողվեց",
	hrGrossSalaryAMD: "Համախառն աշխատավարձ (AMD)",
	hrGrossSalaryDescription: "Մուտքագրեք աշխատանքային պայմանագրում նշված գումարը",
	hrGrossSalaryLabel: "Համախառն աշխատավարձ (գրանցված / պայմանագրային)",
	hrGrossSalaryRegistered: "Համախառն աշխատավարձ (գրանցված)",
	hrGrossToNet: "Համախառն → Զուտ (Gross to Net)",
	hrHealthInsuranceAges: "Առողջապահական ապահովագրություն (18–65 տարեկան)",
	hrHealthInsuranceBenefit: "Առողջապահական ապահովագրություն",
	hrHealthInsuranceBenefitDesc: "Ամսական աշխատատուի ներդրում առողջապահական ապահովագրությանը (AMD)",
	hrHealthInsuranceEmployeeColumn: "Աշխատակից",
	hrHealthInsuranceEmployeeShare: "Առողջապահական ապահովագրություն (աշխատակցի բաժին)",
	hrHealthInsuranceStateColumn: "Պետություն",
	hrITSector: "ՏՏ ոլորտ (եկամտային հարկ 10%)",
	hrITSectorDesc: "Լիցենզավորված ՏՏ ընկերության աշխատակից",
	hrIncomeTax: "Եկամտային հարկ",
	hrIncomeTaxLabel: "Եկամտային հարկ՝",
	hrIncomeTaxRate: "Եկամտային հարկի դրույք",
	hrIncomeTaxRateDesc: "Հարթ 20% Հայաստանում 2020 թվականից",
	hrLeaveAccrualConfiguration: "Արձակուրդի կուտակման կարգավորում",
	hrLiveRates: "Գործող դրույքներ",
	hrLunchCoverage: "Ճաշի փոխհատուցում",
	hrLunchCoverageDesc: "Ամսական ճաշի/սննդի նպաստ (AMD)",
	hrMandatoryHealthInsurance: "Պարտադիր առողջապահական ապահովագրություն (18–65)",
	hrMandatoryHealthInsuranceDesc: "Ներառել 2025 առողջապահական աստիճանները",
	hrMilitaryStampRate: "Զինվորական տուրքի դրույք",
	hrMilitaryStampRateDesc: "Թողեք 0, եթե չի կիրառվում",
	hrMonthlyFee: "Ամսական վճար",
	hrNetSalaryDescription: "Մուտքագրեք, որքան եք ցանկանում ստանալ ձեռքին",
	hrNetSalaryLabel: "Զուտ աշխատավարձ՝",
	hrNetSalaryTakeHome: "Զուտ աշխատավարձ (ձեռքին)",
	hrNetToGross: "Զուտ → Համախառն (Net to Gross)",
	hrOvertimeRateMultiplier: "Արտաժամյա դրույքի գործակից",
	hrOvertimeRateMultiplierDesc: "օր. 1,5× նշանակում է արտաժամյայի 50% հավելում",
	hrOvertimeRules: "Արտաժամյա աշխատանքի կանոններ",
	hrBreakIntervals: "Դադարներ",
	hrBreakIntervalsDesc:
		"Ամենօրյա ֆիքսված ժամային միջակայքեր (օրինակ՝ ճաշի ընդմիջում), որոնք բացառվում են աշխատանքային ժամերից բոլորի համար։ Կարող եք ավելացնել մեկից ավելի։",
	hrBreakIntervalsEmpty: "Դադարներ սահմանված չեն",
	hrBreakIntervalStart: "Դադարի սկիզբ",
	hrBreakIntervalEnd: "Դադարի ավարտ",
	hrAddBreakInterval: "Ավելացնել դադար",
	hrOvertimeThreshold: "Արտաժամյայի շեմ (ժամ/օր)",
	hrOvertimeThresholdDesc: "Այս շեմից ավելի աշխատած ժամերը հաշվարկվում են արտաժամյա դրույքով",
	hrPensionMandatory: "Պարտադիր / կամավոր մինչև 07/2018 (5%)",
	hrPensionNone: "Չմասնակից (0%)",
	hrPensionPost2018: "Կամավոր 07/2018-ից հետո (5%)",
	hrPensionSystem: "Թոշակային համակարգ",
	hrPensionSystemDesc: "Ձեր ֆինանսավորվող թոշակային մասնակցության կարգավիճակը",
	hrSettingsPageSubtitle: "Կարգավորեք աշխատավարձը, արձակուրդը և ներկայության կանոնները",
	hrSettingsPageTitle: "HR կարգավորումներ",
	hrSettingsUpdatedSuccessfully: "HR կարգավորումները հաջողությամբ թարմացվեցին",
	hrSickDaysPerYear: "Տարեկան հիվանդության օրեր",
	hrSickDaysPerYearDesc: "Վճարովի հիվանդության օրեր տարեկան",
	hrSocialPaymentPension: "Սոցիալական վճար (թոշակ)",
	hrSocialTaxRate: "Սոցիալական հարկի դրույք",
	hrSocialTaxRateDesc: "Այժմ Հայաստանում 0% (փոխարինվել է թոշակային վճարներով)",
	hrStampFee: "Դրոշմանիշային վճար (Զինվորական ապահովագրության հիմնադրամ)",
	hrStampFeeTooltip:
		"Զինվորական ապահովագրության հիմնադրամ՝ աստիճանավոր ֆիքսված վճար համախառն աշխատավարձի միջակայքով",
	hrStandardWorkSchedule: "Ստանդարտ աշխատանքային գրաֆիկ",
	hrStateHealthContribution: "Պետական առողջապահական ներդրում",
	hrStateHealthContributionNote:
		"ավելացվում է պետության կողմից ձեր առողջապահական փաթեթին (չի պահվում աշխատավարձից)։",
	hrSuffixDays: "օր",
	hrSuffixHours: "ժ",
	hrSuffixTimes: "×",
	hrSummary: "Ամփոփում",
	hrTabDefaultBenefits: "Լռելյայն նպաստներ",
	hrTabLeaveAccrual: "Արձակուրդի կուտակում",
	hrTabTaxCalculator: "Հարկային հաշվիչ",
	hrTabTaxesArmenia: "Հարկեր (Հայաստան)",
	hrTabWorkSchedule: "Աշխատանքի գրաֆիկ",
	hrTaxPreviewTitle: "Հարկի նախադիտում (500 000 AMD համախառն)",
	hrTaxRatesDescription:
		"Դրույքները կիրառվում են համախառն աշխատավարձի վրա։ Մուտքագրեք տոկոսներով (օր. 20 = 20%):",
	hrTaxRatesDisclaimer:
		"Դրույքները՝ հիմնված 2025–2026 Հայաստանի օրենսդրության վրա։ Եկամտային հարկ՝ 20% ստանդարտ, 10% լիցենզավորված ՏՏ ընկերությունների համար։ Թոշակ՝ 5% (պարտադիր/մինչև 2018 կամավոր) կամ հարթ 5% (2018-ից հետո կամավոր)։ 10% ավելցուկային դրույքը՝ պարտադիր/մինչև 2018 մասնակիցների համար 500 000 AMD-ից բարձր։ Հաստատեք հավաստված հաշվապահի հետ։",
	hrThresholdWarning: "Շեմի զգուշացում",
	hrThresholdWarningText:
		"Ձեր աշխատավարձը մոտ է աստիճանի սահմանին (100k / 200k / 500k / 1M AMD)։ Այս կետերում տուրքը և առողջապահությունը անցնում են բարձր աստիճանի, այնպես որ փոքր աճը կարող է նվազեցնել զուտը։ Հաշվիչը միշտ ցույց է տալիս նվազագույն համախառնը՝ պահանջված զուտի համար։",
	hrTickets: "HR տոմսեր",
	hrTotalDeductions: "Ընդհանուր պահումներ",
	hrTotalEmployeeDeductionsLabel: "Աշխատակցի ընդհանուր պահումներ՝",
	hrTransportAllowance: "Տրանսպորտի նպաստ",
	hrTransportAllowanceDesc: "Ամսական տրանսպորտային նպաստ (AMD)",
	hrVacationDaysPerYear: "Տարեկան արձակուրդի օրեր",
	hrVacationDaysPerYearDesc: "Տարեկան ամբողջական իրավունք (Հայաստանի նվազագույնը՝ 20 օր)",
	hrWorkingDayEnd: "Աշխատանքային օրվա ավարտ",
	hrWorkingDayEndDesc: "Սպասվող հերթափոխի ավարտը։ Օրական ժամերը հաշվարկվում են սկզբից և ավարտից",
	hrWorkingDayStart: "Աշխատանքային օրվա սկիզբ",
	hrWorkingDayStartDesc: "Սպասվող մուտքի ժամը՝ ներկայության և ուշացման հաշվարկի համար",
	hrAttendanceAutoCloseTime: "Ավտոմատ ելքի ժամ",
	hrAttendanceAutoCloseTimeDesc: "Այս ժամին նախորդ օրվա չփակված մուտքերը ավտոմատ կերպով փակվում են",
	hrWeekendDays: "Հանգստյան օրեր",
	hrWeekendDaysDesc: "Ընտրեք շաբաթվա այն օրերը, որոնք ոչ աշխատանքային հանգստյան օրեր են",
	hrAttendanceDeviceSync: "Ներկայության սարքերի սինխրոնիզացում",
	hrIgnoredAttendanceDevicePins: "Անտեսվող սարքի PIN-ներ",
	hrIgnoredAttendanceDevicePinsDesc:
		"Այս ZKTeco PIN-երի գրանցումները բաց են թողնվում համաժամացման ժամանակ։ Դրանց օգտատերերը չեն ներառվում հաճախումների ընդհանուր վահանակներում և վիճակագրությունում, բայց օգտատիրոջ հաճախումների էջում երևում են որպես «Անտեսված»։",
	hrIgnoredAttendanceDevicePinsInputDesc:
		"Մուտքագրեք սարքի PIN-ը և սեղմեք Enter։ Պահվում է 5 նիշով (օր. 1104 → 01104)։ Հեռացնելու համար սեղմեք ×-ը բեյջի վրա։",
	hrIgnoredAttendanceDevicePinsPlaceholder: "PIN, ապա Enter",
	hrIgnoredAttendanceUsers: "Անտեսվող օգտատերեր",
	hrIgnoredAttendanceUsersDesc: "Այս օգտատերերը մնում են օգտատերերի ցանկերում և իրենց հաճախումների էջում, բայց չեն ներառվում հաճախումների ընդհանուր վահանակներում ու վիճակագրությունում։",
	hrIgnoredAttendanceUsersPlaceholder: "Ընտրեք օգտատիրոջը և սեղմեք Enter",
	hrWorkingDaysPerWeek: "Աշխատանքային օրեր շաբաթական",
	hrWorkingDaysPerWeekDesc: "Երկ–Ուր = 5, Երկ–Շբ = 6",
	hrWorkingHoursPerDay: "Աշխատանքային ժամեր օրական",
	hrWorkingHoursPerDayDesc: "Ստանդարտ ժամեր՝ մինչև արտաժամյայի հաշվարկը",
	href: "Հղում (URL)",
	humanResources: "Անձնակազմ (HR)",
	id: "ID",
	idCard: "ID քարտ",
	idCardEndDate: "ID քարտի ավարտի ամսաթիվ",
	idCardNo: "ID քարտի №",
	idCardStartDate: "ID քարտի սկզբի ամսաթիվ",
	idCart: "ID քարտ",
	image: "Նկար",
	immediateSupervisor: "Անմիջական ղեկավար",
	importance: "Կարևորություն",
	important: "Կարևոր",
	inProgress: "Ընթացքի մեջ",
	inSelectedPeriod: "Ընտրված ժամանակահատվածում",
	inStock: "Առկա է պահեստում",
	in_progress: "Մեկնարկված",
	inactive: "Անգործուն",
	inactiveTime: "Չգործող ժամ",
	incident: "Միջադեպ",
	incomeTaxAmount: "Եկամտային հարկի գումար",
	incomeTaxRate: "Եկամտային հարկի դրույք (%)",
	incomingCall: "Մուտքային զանգ",
	incomingVideoCall: "Մուտքային տեսազանգ",
	incorrectLogin: "Դուք մուտքագրել եք սխալ օգտվողի անուն կամ գաղտնաբառ",
	index: "#",
	inputInArmenian: "Մուտքագրում հայերեն",
	inputInLatin: "Մուտքագրում լատինատառ",
	inputInNumbers: "Մուտքագրեք թվերով",
	inputInRussian: "Մուտքագրում ռուսերեն",
	inputNumber: "Համարի մուտքագրում",
	inputNumbers: "Մուտքագրեք թվեր",
	instagramPosts: "Instagram գրառումներ",
	insufficientVacationBalance: "Արձակուրդի մնացորդը բավարար չէ",
	interview1: "Հարցազրույց",
	interview2: "Ծանոթություն",
	interview3: "Ուսուցում",
	interview4: "Փորձաշրջան",
	interviewDate: "Հարցազրույցի ամսաթիվ",
	interviewTime: "Հարցազրույցի ժամ",
	introSection: "Ներածական բաժին",
	invalidDate: "Անվավեր տեղափոխման ամսաթիվ",
	inventorySummary: "Պահեստի ամփոփում",
	ip: "IP",
	ipAddress: "IP հասցե",
	isActive: "Ակտիվ է",
	isColor: "Գույն է",
	isPrivateOffice: "Ունի անվանական գործածություն",
	isPublic: "Հանրային է",
	isSystem: "Համակարգային է",
	itHierarchyAddCatalogCpu: "Ավելացնել պրոցեսոր (կատալոգ)",
	itHierarchyAddCatalogGpu: "Ավելացնել տեսաքարտ (կատալոգ)",
	itHierarchyAddCatalogRam: "Ավելացնել RAM (կատալոգ)",
	itHierarchyAddCatalogRom: "Ավելացնել պահեստ/սկավառակ (կատալոգ)",
	itHierarchyAddMonitor: "Ավելացնել մոնիտոր",
	itHierarchyAddLaptop: "Ավելացնել նոութբուք",
	itHierarchyAttachedPc: "Կցված համակարգիչ",
	itHierarchyAddPc: "Ավելացնել համակարգիչ",
	itHierarchyAddPrinter: "Ավելացնել տպիչ",
	itHierarchyAddRoom: "Ավելացնել սենյակ",
	itHierarchyAddRouter: "Ավելացնել երթուղիչ (Router)",
	itHierarchyAddSwitch: "Ավելացնել անջատիչ (Switch)",
	itHierarchyAddWarrantyProvider: "Ավելացնել երաշխիքի մատակարար",
	itHierarchyMonitorsOnPc: "Այս համակարգչի մոնիտորները",
	itHierarchyPcsInRoom: "Համակարգիչներ այս սենյակում",
	itHierarchyPcsUsingPart: "Համակարգիչներ, որոնք օգտագործում են այս մասը",
	itHierarchyLaptopsUsingPart: "Նոութբուքեր, որոնք օգտագործում են այս մասը",
	itHierarchyPcsWithWarranty: "Համակարգիչներ այս երաշխիքի մատակարարով",
	itHierarchyPrintersOnPc: "Այս համակարգչի տպիչները",
	itHierarchyRoutersInRoom: "Երթուղիչներ այս սենյակում",
	itHierarchySwitchesInRoom: "Անջատիչներ այս սենյակում",
	itUsedInOtherPlaces: "Օգտագործվում է այլ վայրերում",
	itTickets: "ՏՏ (IT) տոմսեր",
	items: "Տարրեր",
	justifiedAbsence: "Հարգելի բացակայություն",
	keyText: "Բանալի",
	keyboards: "Ստեղնաշարեր",
	label: "Պիտակ / Անվանում",
	language: "Լեզու",
	languagePickerLabel: "Լեզու",
	large: "Մեծ",
	last7Days: "Մուտք են գործել վերջին 7 օրվա ընթացքում",
	lastAction: "Վերջին գործողություն",
	lastLogin: "Վերջին մուտք",
	lastName: "Ազգանուն",
	lastOut: "Վերջին ելք",
	lastPunch: "Վերջին նշումը (Punch)",
	lasts: "Տևողություն",
	late: "Ուշացած",
	lateDeparture: "Ուշ ելք",
	latestCustomerOrders: "Հաճախորդների վերջին պատվերները",
	leader: "Ղեկավար",
	attendanceManagersFilter: "Ղեկավարներ",
	attendanceLeadersFilter: "Ղեկավարներ",
	leaveBalance: "Արձակուրդի մնացորդ",
	userLeaveBalanceSubtitle:
		"Խմբագրել {year} թվականի ընթացիկ արձակուրդային օրերը։ Հաճախումը և արձակուրդի օգտագործումը շարունակում են թարմացնել օգտագործվածի քանակը։",
	userLeaveBalanceSave: "Պահպանել արձակուրդային օրերը",
	userLeaveBalanceVacationDays: "Արձակուրդային օրեր",
	userLeaveBalanceBaselineHint:
		"Սա սահմանում է աշխատակցի ընթացիկ արձակուրդի բազային արժեքը։ Հետագա հաճախման վերահաշվարկները պահպանում են այս արժեքը՝ շարունակելով հաշվել նոր օգտագործված արձակուրդային օրերը։",
	userLeaveBalanceLoadFailed: "Արձակուրդի մնացորդի բեռնումը ձախողվեց",
	userLeaveBalanceUpdatedTitle: "Արձակուրդային օրերը թարմացվել են",
	userLeaveBalanceUpdatedMessage: "Աշխատակցի արձակուրդի մնացորդը պահպանվել է։",
	userLeaveBalanceUpdateFailedTitle: "Արձակուրդի թարմացումը ձախողվեց",
	legacyRelatedList: "Հին դաշտ",
	list: "Ցանկ",
	linkCopied: "Հղումը պատճենվել է",
	listeners: "Լսողներ",
	livingAddress: "Բնակության հասցե",
	loading: "Բեռնում...",
	loanDeductions: "Վարկի պահումներ",
	localCode: "Տեղական կոդ",
	logOut: "Ելք",
	login: "Մուտք",
	loginButton: "Մուտք գործել",
	loginFailed: "Մուտքը ձախողվեց",
	loginFailedMessage: "Խնդրում ենք ստուգել ձեր մուտքի տվյալները",
	loginSuccess: "Մուտքն հաջող է",
	loginSuccessMessage: "Դուք հաջողությամբ մուտք եք գործել",
	loginToStartSession: "Մուտք գործեք՝ սեսիան սկսելու համար",
	logout: "Դուրս գալ",
	low: "Ցածր",
	lunchCoverage: "Ճաշի փոխհատուցում",
	mac: "MAC",
	macAddress: "MAC հասցե",
	main: "Գլխավոր",
	mainInformation: "Հիմնական տեղեկատվություն",
	mainInfo: "Հիմնական տեղեկություն",
	contactInfo: "Կոնտակտային տեղեկություն",
	personalInfo: "Անձնական տեղեկություն",
	workingInfo: "Աշխատանքային տեղեկություն",
	probation: "Փորձաշրջան",
	educationInfo: "Կրթական տեղեկություն",
	male: "Արական",
	manualAdjustments: "Ձեռքով ճշգրտումներ",
	manualAttendanceEntry: "Ձեռքով մուտքագրում",
	manualOptions: "Տարբերակներ",
	maps: "Քարտեզներ",
	maritalStatus: "Ընտանեկան կարգավիճակ",
	markAllAsRead: "Նշել բոլորը կարդացված",
	markSelectedAsRead: "Նշել ընտրվածները կարդացված",
	maternityLeave: "Մայրության արձակուրդ (Ֆիզարձակուրդ)",
	maxEnergy: "Գործածված էներգիայի առավելագույն մակարդակ",
	maxFilesReached: "Ֆայլերի առավելագույն քանակը սպառված է",
	maxSize: "Առավելագույն չափ",
	mediaGallery: "Մեդիա պատկերասրահ",
	mediaGalleryDescription: "Մեդիա պատկերասրահի նկարագրություն",
	mediator: "Միջնորդ",
	medium: "Միջին",
	members: "Մասնակիցներ",
	menu: "Մենյու / Ընտրացանկ",
	message: "Հաղորդագրություն",
	messages: "Հաղորդագրություններ",
	messagesByType: "Հաղորդագրություններ ըստ տեսակի",
	messagesOverTime: "Հաղորդագրություններ ժամանակի ընթացքում (Վերջին 30 օր)",
	militaryStampAmount: "Զինվորական տուրքի գումար",
	militaryStampRate: "Զինվորական տուրքի դրույք",
	minimap: "Մինի քարտեզ",
	minEnergy: "Գործածված էներգիայի նվազագույն մակարդակ",
	minute: "Րոպե",
	minutes: "Րոպեներ",
	missingInterval: "Բացակայող ժամանակային հատված",
	mon: "Երկուշաբթի",
	monitor: "Մոնիտոր",
	monitors: "Մոնիտորներ",
	month: "Ամիս",
	monthly: "Ամսական",
	mood: "Տրամադրություն",
	more: "Ավելին",
	moreDetailed: "Ավելի մանրամասն",
	moreThan: "Ավելի քան",
	motherProject: "Մայր նախագիծ",
	mounted: "Տեղադրված է",
	mouses: "Մկնիկներ",
	moveToTrash: "Տեղափոխել աղբաման",
	movedToTrash: "Տեղափոխվեց աղբաման",
	myActiveSteps: "Իմ ակտիվ քայլերը",
	myInvolvement: "Իմ ներգրավվածությունը",
	myProjects: "Իմ նախագծերը",
	myRole: "Իմ դերը",
	mySteps: "Իմ փուլերը",
	myTickets: "Իմ տոմսերը",
	na: "Հ/Ա (N/A)",
	name: "Անուն",
	netCash: "Զուտ կանխիկ",
	netOfficial: "Զուտ պաշտոնական",
	netSalary: "Զուտ աշխատավարձ (Ձեռքին)",
	newClients: "Նոր հաճախորդներ",
	newClientsOverTime: "Նոր հաճախորդներ ժամանակի ընթացքում (վերջին 30 օր)",
	newMessage: "Նոր հաղորդագրություն",
	newProducts: "Նոր ապրանքներ",
	newProject: "Նոր նախագիծ",
	newProjects: "Նոր նախագծեր",
	newThisPeriod: "Նոր է այս ժամանակաշրջանում",
	newTicket: "Նոր տոմս",
	newTicketCreatedBy: "Նոր տոմսը ստեղծվել է՝",
	newTracks: "Նոր երաժշտական գործեր",
	newTracksOverTime: "Նոր երաժշտական գործեր ժամանակի ընթացքում (վերջին 30 օր)",
	next: "Հաջորդը",
	nextComposition: "Հաջորդ կազմը",
	nextStep: "Հաջորդ քայլ",
	noAccess: "Մուտք չկա",
	noActiveSteps: "Ակտիվ քայլեր չկան",
	noBoardsFound: "Տախտակներ չեն գտնվել",
	noCategoriesFound: "Կատեգորիաներ չեն գտնվել",
	noCategoryDataAvailable: "Կատեգորիաների տվյալներ չկան",
	noContent: "Բովանդակություն չկա",
	noCustomerDataAvailable: "Հաճախորդների տվյալներ չկան",
	noData: "Տվյալներ չկան",
	noDataAvailable: "Չկան հասանելի տվյալներ",
	noDataAvailableForSelectedPeriod: "Տվյալներ չկան ընտրված ժամանակաշրջանի համար",
	noDepartment: "Բաժին չկա",
	noDepartments: "Բաժիններ չկան",
	noDescription: "Նկարագրություն չկա",
	noEmail: "Էլ. փոստ չկա",
	noExpiringIdCards: "Չկան ժամկետանցող ID քարտեր",
	noExpiringPassports: "Չկան ժամկետանցող անձնագրեր",
	noGroup: "Առանց խմբի",
	noMediaDescription: "Մեդիայի նկարագրություն չկա",
	noMediaFound: "Մեդիա ֆայլեր չեն գտնվել",
	noMoreItems: "Ավելին չկա",
	noName: "Առանց անունի",
	noNeedStep45: "Չի պահանջվում 4-5 քայլերը",
	noNotifications: "Ոչ մի ծանուցում",
	noOrdersInSelectedPeriod: "Պատվերներ չկան ընտրված ժամանակաշրջանում",
	noOvertimeRecords: "Արտաժամյա գրառումներ չեն գտնվել",
	noPaymentDataAvailable: "Վճարման տվյալներ չկան",
	noProjectsAssigned: "Չկան հանձնված նախագծեր",
	noProjectsAssignedOrInvolved: "Չկան նշանակված կամ ներգրավված նախագծեր",
	noRecentClients: "Վերջին հաճախորդներ չկան",
	noRecentContent: "Վերջին բովանդակություն չկա",
	noRecentTickets: "Վերջին տոմսեր չկան",
	noRecentTracks: "Վերջին երաժշտական գործեր չկան",
	noRecipientInformation: "Չկա ստացողի տեղեկատվություն",
	noResponsible: "Պատասխանատու չկա",
	noResult: "Արդյունք չկա",
	noResults: "Արդյունքներ չկան",
	noResultsFound: "Արդյունքներ չեն գտնվել",
	noRulesAdded: "Ծածկագրման կանոններ չեն ավելացվել",
	noStatusData: "Կարգավիճակի տվյալներ չկան",
	noSystemDaysOffThisMonth: "Այս ամսում ընդհանուր հանգստյան օրեր չկան",
	noTaskDataAvailable: "Չկա հասանելի տվյալներ",
	noTasksYet: "Առաջադրանքներ դեռ չկան",
	noTasksYetDescription: "Առաջադրանքներ դեռ չկան",
	noUpcomingBirthdays: "Առաջիկա ծննդյան օրեր չկան",
	noUsersFound: "Օգտատերեր չեն գտնվել",
	noUsersInDepartment: "Այս բաժնում չկան օգտատերեր",
	noWorkHourData: "Առաջադրանքային ժամերի տվյալներ չկան",
	no_priority: "Առանց առաջնահերթության",
	nonWorking: "Ոչ աշխատանքային օր",
	none: "Չկա",
	notAvailable: "Ապրանքը հասանելի չէ",
	notCorrectLoginCredentials: "Սխալ մուտքանուն կամ գաղտնաբառ",
	notLoggedInToday: "Այսօր չի մուտք գործել",
	notPlaced: "Չի տեղադրվել",
	notPresent: "Բացակա",
	notResponded: "Պատասխանված չէ",
	notWorking: "Չի աշխատում",
	deviceProblems: "Սարքերի խնդիրներ",
	openTickets: "Բաց տոմսեր",
	note: "Նշում",
	nothingFound: "Ոչինչ չի գտնվել",
	notifications: "Ծանուցումներ",
	notificationsBellAria: "Բացել ծանուցումները",
	similarTicketNotifications: "Նմանատիպ տոմսեր",
	number: "Թիվ / Համար",
	"office-map": "Գրասենյակի քարտեզ",
	officeMapActivatePlacement: "Միացնել տեղադրումը",
	officeMapAgent: "Գործակալ",
	officeMapAll: "Բոլորը",
	officeMapAttendanceDevice: "Հաճախման սարք",
	officeMapAttendanceDevices: "Հաճախում",
	officeMapCable: "Մալուխ",
	officeMapCableLinePlaced: "Մալուխի գիծը տեղադրվեց",
	officeMapCableRemovedFromMap: "Մալուխը հեռացվեց քարտեզից",
	officeMapCables: "Մալուխներ",
	officeMapCamera: "Տեսախցիկ",
	officeMapCameras: "Տեսախցիկներ",
	officeMapNvr: "Ցանցային տեսագրիչ (NVR)",
	officeMapChat: "Չատ",
	officeMapChatWasNotCreated: "Չատը չի ստեղծվել",
	officeMapConnectToCamera: "Միանալ տեսախցիկին",
	officeMapCpu: "CPU",
	officeMapDeactivate: "Անջատել",
	officeMapDeviceDetails: "Սարքի տվյալներ",
	officeMapDeviceId: "Սարքի ID",
	officeMapDisableDragging: "Անջատել քաշելը",
	officeMapEnableDragging: "Միացնել քաշելը",
	officeMapEndDeviceOptional: "Վերջնական սարք (ըստ ցանկության)",
	officeMapFailedToMoveCable: "Չհաջողվեց տեղափոխել մալուխը",
	officeMapFailedToMoveItem: "Չհաջողվեց տեղափոխել տարրը",
	officeMapFailedToMoveRoomArea: "Չհաջողվեց տեղափոխել սենյակի տարածքը",
	officeMapFailedToOpenChat: "Չհաջողվեց բացել չատը",
	officeMapFailedToPlaceItem: "Չհաջողվեց տեղադրել տարրը",
	officeMapFailedToPlaceUser: "Չհաջողվեց տեղադրել օգտատիրոջը",
	officeMapFailedToRemoveCable: "Չհաջողվեց հեռացնել մալուխը",
	officeMapFailedToRemoveItem: "Չհաջողվեց հեռացնել տարրը",
	officeMapFailedToRemoveRoomArea: "Չհաջողվեց հեռացնել սենյակի տարածքը",
	officeMapFailedToSaveCableLine: "Չհաջողվեց պահպանել մալուխի գիծը",
	officeMapFailedToSaveRoomArea: "Չհաջողվեց պահպանել սենյակի տարածքը",
	officeMapFinishArea: "Ավարտել տարածքը",
	officeMapFinishCable: "Ավարտել մալուխի գիծը",
	officeMapForbidden: "Արգելված է",
	officeMapIp: "IP",
	officeMapItem: "Տարր",
	officeMapItemPlaced: "Տարրը տեղադրվեց",
	officeMapItemRemovedFromMap: "Տարրը հեռացվեց քարտեզից",
	officeMapLaptop: "Դյուրակիր համակարգիչ",
	officeMapLaptops: "Դյուրակիր համակարգիչներ",
	officeMapLayers: "Շերտեր",
	officeMapLinkedItRoom: "Կապակցված IT սենյակ",
	officeMapLive: "Ուղիղ միացում",
	officeMapMac: "MAC",
	officeMapMin: "Նվազագույն",
	officeMapMonitors: "Մոնիտորներ",
	officeMapNetworkCable: "Ցանցային մալուխ",
	officeMapNoDevicesInArea: "Այս տարածքում տեղադրված սարքեր կամ օգտատերեր չկան։",
	officeMapNoPermissionToPlaceItem: "Դուք իրավասություն չունեք այս տարրը տեղադրելու։",
	officeMapNoPermissionToPlaceNetworkCable: "Դուք իրավասություն չունեք ցանցային մալուխ տեղադրելու։",
	officeMapNoPermissionToPlaceRoomArea: "Դուք իրավասություն չունեք սենյակի տարածք սահմանելու։",
	officeMapNoPermissionToRemoveItem: "Դուք իրավասություն չունեք այս տարրը քարտեզից հեռացնելու։",
	officeMapNoPermissionToRemoveNetworkCable:
		"Դուք իրավասություն չունեք ցանցային մալուխը քարտեզից հեռացնելու։",
	officeMapNoPermissionToRemoveRoomArea:
		"Դուք իրավասություն չունեք սենյակի տարածքը քարտեզից հեռացնելու։",
	officeMapNotAvailable: "Անհասանելի է",
	officeMapNotConnected: "Միացված չէ",
	officeMapPc: "Համակարգիչ (PC)",
	officeMapPcs: "Համակարգիչներ (PCs)",
	officeMapPlacement: "Տեղադրում",
	officeMapPleaseSelectItemFirst: "Խնդրում ենք նախ ընտրել տարրը",
	officeMapPleaseSelectRoomFirst: "Խնդրում ենք նախ ընտրել սենյակը",
	officeMapPoints: "Կետեր",
	officeMapPorts: "Պորտեր",
	officeMapPrinted: "Տպագրված",
	officeMapPrinters: "Տպիչներ",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "Հեռացնել քարտեզից",
	officeMapRom: "ROM",
	officeMapRoomArea: "Սենյակի տարածք",
	officeMapRoomAreaPlaced: "Սենյակի տարածքը տեղադրվեց",
	officeMapRoomAreaRemovedFromMap: "Սենյակի տարածքը հեռացվեց քարտեզից",
	officeMapRoomAreas: "Սենյակներ",
	officeMapRoomContents: "Սենյակի պարունակություն",
	officeMapRouter: "Երթուղիչ (Router)",
	officeMapRouters: "Երթուղիչներ (Routers)",
	officeMapSelectItem: "Ընտրեք տարրը",
	officeMapSelectRoom: "Ընտրեք սենյակը",
	officeMapSpeed: "Արագություն",
	officeMapStartDeviceOptional: "Սկզբնական սարք (ըստ ցանկության)",
	officeMapSwitches: "Սվիչներ (Switches)",
	officeMapTelephone: "Հեռախոս",
	officeMapTelephones: "Հեռախոսներ",
	officeMapUnknown: "Անհայտ",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "Օգտատերը տեղադրվեց քարտեզի վրա",
	officeMapUsers: "Օգտատերեր",
	officeMapViewContents: "Բացել պարունակությունը",
	officeMapViewFullDetails: "Բացել ամբողջական տվյալները",
	offline: "Անցանց",
	offlinePaymentOnly: "Միայն արտաքին վճարում",
	oldProject: "Հին նախագիծ",
	onSale: "Վաճառվում է",
	onSecond: "Երկրորդում",
	onTime: "Ժամանակին",
	onTimeRate: "Ժամանակին ներկայության տոկոս",
	oneOf: "Մեկը",
	open: "Բացել",
	openBoard: "Բացել տախտակը",
	openDate: "Ստեղծման ամսաթիվը",
	openInModal: "Բացել մոդալ պատուհանով",
	openInNewTab: "Բացել նոր պատուհանում",
	openNavigation: "Բացել նավիգացիան",
	openedDate: "Բացման ամսաթիվը",
	optional: "Ընտրովի (ոչ պարտադիր)",
	orClickToSelect: "կամ սեղմեք՝ ֆայլեր ընտրելու համար",
	order: "Պատվեր",
	orderNumber: "Պատվերի համար",
	orders: "Պատվերներ",
	ordersCart: "Պատվերների գծապատկեր",
	otAfterWork: "Արտաժամյա աշխատանք՝ աշխատանքից հետո",
	otBeforeWork: "Արտաժամյա աշխատանք՝ աշխատանքից առաջ",
	otHours: "Արտաժամյա ժամեր (OT)",
	otRate: "Արտաժամյա դրույք",
	otherBenefits: "Այլ նպաստներ",
	otherDeductions: "Այլ պահումներ",
	otherInsurance: "Այլ ապահովագրություն",
	outOfStock: "Սպառված է / Առկա չէ",
	overdue: "Ժամկետանց",
	overtime: "Արտաժամյա աշխատանք",
	overtimeComment: "Արտաժամյա աշխատանքի մեկնաբանություն",
	overtimeDays: "Արտաժամյա աշխատանքի օրեր",
	overtimeHours: "Ավելաժամի ժամեր",
	overtimeRate: "Ավելաժամի դրույք",
	overtimeSummary: "Արտաժամյա աշխատանքի ամփոփագիր",
	overtimeTotal: "Արտաժամյա ընդամենը",
	overview: "Ակնարկ",
	owner: "Սեփականատեր",
	ownership: "Սեփականատիրություն",
	pageNotFound: "Էջը չի գտնվել",
	pageNotFoundDescription:
		"Ուփս! Էջը, որը դուք փնտրում եք, գոյություն չունի կամ տեղափոխվել է: Այն կարող է հեռացված, անվանափոխված կամ ժամանակավորապես անհասանելի լինել:",
	pages: "Էջեր",
	paid: "Վճարված",
	paidStatus: "Վճարման կարգավիճակ",
	paidTimeOff: "Վճարովի արձակուրդ (PTO)",
	paidTimeOffDays: "Վճարովի արձակուրդի օրեր",
	parent: "Գլխավոր / Մայր",
	parentCategory: "Ծնող կատեգորիա",
	parentDepartment: "Գլխավոր բաժին",
	parentTask: "Վերադաս առաջադրանք",
	parentType: "Ծնողի տեսակ",
	parentUser: "Գլխավոր օգտատեր",
	participant: "Մասնակից",
	passportEndDate: "Անձնագրի ավարտի ամսաթիվ",
	passportImages: "Անձնագրի նկարներ",
	passportNo: "Անձնագրի №",
	passportStartDate: "Անձնագրի տրման ամսաթիվ",
	password: "Գաղտնաբառ",
	pause: "Դադարեցնել",
	paused: "Դադարեցված է",
	payDate: "Աշխատավարձի վճարման ամսաթիվ",
	paymentMethod: "Վճարման եղանակ",
	paymentMethods: "Վճարման եղանակներ",
	paymentSystem: "Վճարային համակարգ",
	payrollBreakdown: "Աշխատավարձի մանրամասներ",
	payrollCalcError: "Աշխատավարձի հաշվարկը ձախողվեց։",
	payrollCalcHint:
		"Աշխատակիցն ու ժամանակահատվածը պարտադիր են։ Սեղմեք՝ հաշվարկելու և պահպանելու համար։",
	payrollCalcMissingFields: "Խնդրում ենք ընտրել աշխատակցին, շրջանի սկիզբն ու ավարտը։",
	payrollCommentsForEmployee: "Մեկնաբանություններ աշխատակցի համար",
	payrollGeneratedFromAttendance: "Աշխատավարձը ձևավորվել է հաճախումներից",
	payrollHealthInsurancePremium: "Առողջապահական ապահովագրություն (ապահովագրավճար)",
	payrollIndexLabel: "Համար",
	payrollIndexPlaceholder: "Համար",
	payrollInternalNotes: "Ներքին նշումներ",
	payrollNotesSection: "Նշումներ",
	payrollType: "Աշխատավարձի տեսակ",
	payrollUsesHrSettings:
		"Ավելաժամը, հարկային դրույքները և լռելյայն նպաստները (ճաշ, տրանսպորտ, առողջություն) հետևում են HR կարգավորումներին (Համակարգ → HR կարգավորումներ)։",
	pc: "Համակարգիչ",
	pcHealth: "Համակարգչի վիճակ",
	pcs: "Համակարգիչներ",
	pdf: "PDF",
	penalties: "Տուգանքներ",
	pending: "Սպասման մեջ",
	pensionAmount: "Թոշակային վճարի գումար",
	pensionRate: "Թոշակային դրույք",
	period: "Ժամանակաշրջան",
	periodEnd: "Ժամանակաշրջանի ավարտ",
	periodStart: "Ժամանակաշրջանի սկիզբ",
	periud: "Ժամանակաշրջան",
	permInput_calendarEvent_overlayCustomCalendars: "Գործող օրացույցներ (զտիչներ)",
	permInput_calendarEvent_overlayIt: "IT օրացույցներ (ՀԿ երաշխիք)",
	permInput_calendarEvent_overlayPeople: "Անձնական օրացույցներ (HR)",
	permInput_calendarEvent_overlayReminders: "Հիշեցումների շերտ",
	permInput_calendarEvent_overlayTasks: "Առաջադրանքներ (առաջնահերթություն)",
	permInput_calendarEvent_overlayTickets: "Տոմսեր (վերջնաժամկետներ ըստ դոմեյնի)",
	permInput_chat_attachFile: "Կցել ֆայլեր",
	permInput_chat_calling: "Ձայնային զանգեր",
	permInput_chat_pin: "Ամրացնել հաղորդագրությունները",
	permInput_chat_searchFiles: "Փնտրել ֆայլերում",
	permInput_chat_searchMessages: "Փնտրել հաղորդագրություններում",
	permInput_chat_sendMessage: "Ուղարկել հաղորդագրություններ",
	permInput_chat_star: "Աստղանշել հաղորդագրությունները",
	permInput_chat_videoCalling: "Տեսազանգեր",
	permModuleCrud_download: "Օրացույցի ներբեռնում (.ics ներմուծում)",
	permModuleCrud_upload: "Օրացույցի վերբեռնում (.ics արտահանում)",
	permanentDelete: "Անվերադարձ ջնջե՞լ",
	permission: "Թույլտվություն",
	permissions: "Թույլտվություններ",
	persons: "Մարդիկ",
	phone: "Հեռախոս",
	photo: "Նկար",
	photos: "Նկարներ",
	pickEmoji: "Ընտրեք էմոջի",
	pinnedMessages: "Ամրացված հաղորդագրություններ",
	placed: "Տեղադրված է",
	placedState: "Տեղադրված կարգավիճակ",
	placeholder: "Մուտքագրում հայատառ",
	platformDashboard: "Ընդհանուր վահանակ",
	platformSpecificSettings: "Համակարգի հատուկ կարգավորումներ",
	platforms: "Պլատֆորմներ",
	audioPlaybackSpeed: "Նվագարկման արագություն՝ {rate}։ Սեղմեք՝ փոխելու համար։",
	playbackMute: "Անջատել ձայնը",
	playbackUnmute: "Միացնել ձայնը",
	playbackVoiceMessage: "Ձայնային հաղորդագրություն",
	playbackVideoMessage: "Տեսահաղորդագրություն",
	previewVoiceMessage: "Նախապես լսել ձայնային հաղորդագրությունը",
	play: "Նվագարկել",
	playStatus: "Ընթացիկ կարգավիճակ",
	playing: "Մեկնարկված է",
	playingComposition: "Նվագարկվող կոմպոզիցիա",
	playingHistory: "Պատմություն",
	playlist: "Երգացանկ / Նվագացանկ",
	playlistStatistics: "Նվագարկիչների վիճակագրություն",
	playlistsWithAds: "նվագարկիչներ գովազդներով",
	playlistsWithoutAds: "նվագարկիչներ առանց գովազդների",
	podcast: "Պոդքասթ",
	podcastStreams: "Պոդքասթների հոսքեր",
	podcasts: "Պոդքասթներ",
	ports: "Պորտեր (Ports)",
	position: "Հաստիք / Պաշտոն",
	positionReviewDate: "Պաշտոնի վերանայման ամսաթիվ",
	preDefinedFilters: "Նախապահված ֆիլտրներ",
	present: "Ներկա",
	preview: "Նախադիտում",
	previous: "Նախորդը",
	previousStep: "Նախորդ քայլ",
	price: "Գին",
	priceB2b: "Գին Կորպորատիվ (B2B)",
	priceBasic: "Հիմնական գինը",
	priceGroup1: "Գնային խումբ 1",
	priceGroup2: "Գնային խումբ 2",
	priceGroup3: "Գնային խումբ 3",
	priceLists: "Գնացուցակներ",
	printedCount: "Տպագրված քանակ",
	printer: "Տպիչ",
	printers: "Տպիչներ",
	priority: "Առաջնահերթություն",
	priorityDescription: "Կարևորության նկարագրություն",
	private: "Մասնավոր / Անհատական",
	privateChat: "Անձնական չատ",
	privateChatDescription: "Միայն ընտրված օգտվողները կարող են տեսնել և միանալ այս չատին",
	problem: "Խնդիր",
	problemDescription: "Խնդրի նկարագիր",
	problemGroup: "Խնդիրների խումբ",
	problemGroupSupervisorsPlaceholder:
		"Օգտատերեր, ովքեր պատասխանատու են այս խնդիրների խմբի տոմսերի մշակման համար",
	problemGroupSupervisorsTab: "Վերահսկողներ",
	processTime: "Մշակման ժամանակը",
	processing: "Մշակում...",
	progress: "Առաջընթաց",
	product: "Ապրանք",
	productCare: "Ապրանքի խնամք",
	products: "Ապրանքներ",
	productsLinked: "Համակարգված ապրանքներ",
	project: "Նախագիծ",
	projectChanges: "Նախագծի փոփոխություններ",
	projectDeadline: "Նախագծի վերջնաժամկետ",
	projectDetails: "Նախագծի մանրամասներ",
	projectEndDate: "Նախագծի ավարտի ամսաթիվ",
	projectID: "Նախագծի ID",
	projectPartition: "Նախագծի մաս",
	projectPrice: "Նախագծի արժեք",
	projectPrice2: "Նախահաշվային արժեք",
	projectStartDate: "Նախագծի սկզբի ամսաթիվ",
	projectType: "Նախագծի տեսակ",
	projectTypes: "Նախագծի տեսակներ",
	projects: "Նախագծեր",
	promoCode: "Պրոմո կոդ",
	promoCodes: "Պրոմո կոդեր",
	promoCodesAndCertificates: "Պրոմո կոդեր և վկայագրեր",
	promotions: "Ակցիաներ",
	propertyNumber: "Գույքահամար",
	providing: "Տրամադրում",
	punchActivity: "Մուտքի/ելքի ակտիվություն (Punch)",
	pto: "Վճարովի արձակուրդ (PTO)",
	partial: "Մասնակի",
	fired: "Պայմանագրի լուծում",
	quantity: "Քանակ",
	radioDashboard: "Ռադիո վահանակ",
	radioManagementOverview: "Ռադիո հոսքերի կառավարման ակնարկ",
	radioStatistics: "Ռադիոյի վիճակագրություն",
	raises: "Բարձրացումներ (Աշխատավարձի)",
	ram: "Օպերատիվ հիշողություն (RAM)",
	rate: "Գործակից / Դրույք",
	rating: "Վարկանիշ",
	readOnly: "Միայն կարդալու համար",
	readOnlyChatNotice:
		"Այս չատը մասնակիցների համար միայն ընթերցման ռեժիմում է. Հաղորդագրություններ կարող են գրել միայն ադմինները։",
	readyToGetStarted: "Պատրա՞ստ եք սկսել",
	recalculatePayroll: "Վերահաշվել աշխատավարձը",
	recentClients: "Վերջին հաճախորդներ",
	recentContent: "Վերջին բովանդակություն",
	recentMessages: "Վերջին հաղորդագրություններ",
	recentOrders: "Վերջին պատվերներ",
	recentTickets: "Վերջին տոմսեր",
	recentTracks: "Վերջին երաժշտական գործեր",
	refresh: "Թարմացնել",
	registeredAddress: "Գրանցման հասցե",
	regularHours: "Սովորական ժամեր",
	regularHoursHrScheduleHint:
		"Ինքնալրացվում է HR կարգավորումներից՝ ժամանակաշրջանի աշխատանքային օրեր × ժամեր օրական։ Խմբագրելի է։",
	regularPlaylists: "Սովորական նվագարկիչներ",
	relatedList: "Կապակցված ցուցակ",
	relatedObjects: "Կապակցված օբյեկտներ",
	relatedProducts: "Համակարգված ապրանքներ",
	relatedTasks: "Կախված առաջադրանքներ",
	relations: "Հարաբերություններ / Հարցումներ",
	remainingVacation: "Արձակուրդի մնացորդ",
	remote: "Հեռավար (Remote)",
	remoteWorkDays: "Հեռավար աշխատանքի օրեր",
	remove: "Հեռացնել",
	removeFromList: "Ջնջել ցուցակից",
	removeItem: "Հեռացնել տարրը",
	removed: "Հեռացված է",
	reopen: "Վերաբացել",
	replaceableProduct: "Փոխարինելի ապրանք",
	replaceableProducts: "Փոխարինվող ապրանքներ",
	replied: "Պատասխանված",
	reply: "Պատասխանել",
	request: "Հարցում / Հայց",
	requestedForUser: "Հայցված է օգտատիրոջ համար",
	reset: "Վերակայել / Չեղարկել",
	responseTimeDistribution: "Պատասխանի ժամանակի բաշխում",
	responsible: "Պատասխանատու",
	responsibleAndUsers: "Պատասխանատուներ և օգտատերեր",
	restoreSelected: "Վերականգնել ընտրվածները",
	restored: "Վերականգնվել է",
	returning: "Վերադարձող",
	revenue: "Եկամուտ",
	revenueOverview: "Եկամուտների ակնարկ",
	review: "Վերանայում",
	rightNow: "Հենց հիմա",
	role: "Դեր",
	rom: "Հիշողություն (ROM)",
	room: "Սենյակ",
	routers: "Մոդեմներ / Երթուղիչներ",
	rpaPrice: "ՌՊԱ (RPA) բաժնի առաջադրանքի արժեք",
	ruleName: "Կանոնի անուն",
	salary: "Աշխատավարձ",
	salaryReviewDate: "Աշխատավարձի վերանայման ամսաթիվ",
	sale: "Վաճառք",
	forSale: "Վաճառքի համար",
	forBuying: "Գնման համար",
	productsForBuying: "Գնման ապրանքներ",
	productsForSelling: "Վաճառքի ապրանքներ",
	supplier: "Մատակարար",
	customers: "Հաճախորդներ",
	store: "Խանութներ",
	stores: "Խանութներ",
	shopping: "Գնումներ",
	salePrice: "Վաճառքի գին",
	salesBreakdownByCategory: "Վաճառքների բաշխում ըստ կատեգորիայի",
	salesPerformanceOverTime: "Վաճառքների արդյունավետությունը ժամանակի ընթացքում",
	sat: "Շաբաթ",
	save: "Պահպանել",
	saveChanges: "Պահպանել փոփոխությունները",
	saveComment: "Պահպանել մեկնաբանությունը",
	saved: "Պահպանվել է",
	schedulingDisabled: "Պլանավորումն անջատված է",
	schedulingEnabled: "Պլանավորումն ակտիվ է",
	schedulingRules: "Ժամանակային համակարգեր",
	search: "Որոնել",
	searchByNameOrId: "Փնտրել անունով կամ ID-ով…",
	searchChat: "Որոնել չատը...",
	searchChatGroups: "Որոնել խմբային չատերը...",
	searchConversations: "Չատերի որոնում...",
	searchResults: "Որոնման արդյունքներ",
	searchUsers: "Որոնել օգտատերեր...",
	secondary: "Երկրորդական",
	seconds: "Վայրկյան",
	securityAcknowledge: "Հաստատել",
	securityActions: "Գործողություններ",
	securityActiveBadge: "Ակտիվ",
	securityActiveSessions: "Ակտիվ սեսիաներ",
	securityActivityStatClicks: "Սեղմումներ",
	securityActivityStatKeys: "Ստեղներ",
	securityActivityStatMoves: "Շարժումներ",
	securityActivityTimeline: "Գործունեության ժամանակագիծ",
	securityAdminNotes: "Ադմինի նշումներ",
	securityAdminNotesDevice: "Ներքին նշումներ այս սարքի մասին...",
	securityAgentHeartbeat: "Ագենտի հարցում (Heartbeat)",
	securityAlertClipPlural: "ծանուցման հատվածներ այս էջում",
	securityAlertClipSingular: "ծանուցման հատված այս էջում",
	securityAlertCount: "ծանուցում",
	securityAlertCountPlural: "ծանուցումներ",
	securityAlertDrawerNoMedia:
		"Այս ծանուցմանը դեռ մեդիա չի կապակցված։ Ագենտին FFmpeg է պետք։ Windows-ում PATH կամ FFMPEG_PATH։ Ստուգեք ագենտի մատյանը։",
	securityAlertDrawerVideoFailed:
		"Տեսագրության հրաման է տրվել, բայց նյութ չի վերբեռնվել։ Հնարավոր է ագենտի սխալ՝ ստուգեք սարքի մատյանը։",
	securityAlertDrawerVideoPending:
		"Տեսանյութը ձայնագրվում է և շուտով կհայտնվի այստեղ։ Ագենտը սարքում նկարահանում և վերբեռնում է։",
	securityAlertRecordings: "Ծանուցման ձայնագրություններ",
	securityAlertRecordingsOnly: "Միայն ծանուցման ձայնագրություններ",
	securityAlertSt_acknowledged: "Հաստատված",
	securityAlertSt_false_positive: "Կեղծ ազդանշան",
	securityAlertSt_open: "Բաց",
	securityAlertSt_resolved: "Լուծված",
	securityAlertsTitle: "Անվտանգության ծանուցումներ",
	securityAllDevices: "Բոլոր սարքերը",
	securityAllEventTypes: "Բոլոր տեսակները",
	securityAllRules: "Բոլոր կանոնները",
	securityAllSeverities: "Բոլոր մակարդակները",
	securityAllStatuses: "Բոլոր կարգավիճակները",
	securityAppProcessTracking: "Ծրագրեր / Գործընթացներ",
	securityAppTracking: "Ծրագրերի հետևում",
	securityAppUsageToday: "Ծրագրերի օգտագործում այսօր (րոպե)",
	securityAssignedUser: "Նշանակված օգտվող",
	securityBadgeAlertText: "ԾԱՆՈՒՑՈՒՄ",
	securityBadgeApp: "Ծրագիր",
	securityBadgeApps: "Ծրագրեր",
	securityBadgeCapture: "Ֆիքսում",
	securityBadgeFiles: "Ֆայլեր",
	securityBadgeOff: "Անջատված",
	securityBadgeScr: "Էկրան",
	securityBadgeScreenshot: "Էկրանապատկեր",
	securityBadgeVideo: "Տեսանյութ",
	securityBadgeWeb: "Վեբ",
	securityCapture: "Ֆիքսում",
	securityCaptureEnabledMaster: "Ֆիքսումը միացված է (Գլխավոր)",
	securityCaptureEverySeconds: "Ֆիքսել ամեն (վրկ)",
	securityCaptureMasterSwitch: "Ֆիքսումը միացված է (Գլխավոր անջատիչ)",
	securityCaptureModes: "Ֆիքսման ռեժիմներ",
	securityCaptureOffAlertBody:
		"Ֆիքսումը հստակ անջատված է սարքի մակարդակում՝ գերակայելով քաղաքականությունը։ Ծանուցումները աշխատում են, բայց էկրանապատկեր և տեսանյութ չեն գրանցվում։",
	securityCaptureOffAlertTitle: "Ֆիքսման գերակայում՝ ԱՆՋԱՏՎԱԾ",
	securityCaptureRecorded: "Ֆիքսումը գրանցվել է",
	securityCaptureWhenOnDesc:
		"Միացված լինելիս՝ էկրանապատկեր և տեսագրում. Անջատումը կանջատի երկուսն էլ",
	securityChartMinutes: "րոպե",
	securityChartVisits: "այցելություններ",
	securityClearFilters: "Մաքրել զտիչները",
	securityClickLeft: "Ձախ սեղմում",
	securityClickMiddle: "Միջին սեղմում",
	securityClickPlain: "Սովորական սեղմում",
	securityClickRight: "Աջ սեղմում",
	securityClientsAccuracyApproximateOnly: "Ճշգրտություն՝ միայն մոտավոր",
	securityClientsActions: "Գործողություններ",
	securityClientsActivity: "Ակտիվություն",
	securityClientsAny: "Ցանկացած",
	securityClientsApproximateGeo: "Մոտավոր աշխարհագրական դիրք",
	securityClientsApproximateGeoOnly: "Միայն մոտավոր գեոլոկացիա",
	securityClientsApproximateLocationUnavailable: "Մոտավոր տեղակայումը հասանելի չէ",
	securityClientsApproximateOriginsOnly:
		"Միայն մոտավոր ծագում։ Նշիչները խմբավորված են գաղտնիության և արտադրողականության համար։",
	securityClientsBlocked: "Արգելափակված",
	securityClientsBlockedIp: "Արգելափակված IP",
	securityClientsBlockedRequestPressure: "Արգելափակված հարցումների ծանրաբեռնվածություն",
	securityClientsBrowser: "Բրաուզեր",
	securityClientsDeviceBrowserOnOs: "{browser} ({os})",
	securityClientsDevices: "Սարքեր",
	securityClientsDisconnectAll: "Անջատել բոլորը",
	securityClientsDisconnectAllSessionsForCurrentUserText:
		"Ձեր հաշվի բոլոր մյուս սեսիաները կփակվեն։ Ընթացիկ սեսիան կմնա ակտիվ։",
	securityClientsDisconnectAllSessionsForTargetUserText:
		"Այս օգտատիրոջ բոլոր ակտիվ սեսիաները անմիջապես կփակվեն։",
	securityClientsDisconnectAllSessionsForUserTitle: "Անջատե՞լ այս օգտատիրոջ բոլոր սեսիաները",
	securityClientsDisconnectAllUserSessions: "Անջատել օգտատիրոջ բոլոր սեսիաները",
	securityClientsDisconnectSession: "Անջատել սեսիան",
	securityClientsDisconnectThisSessionText:
		"Ընտրված հաճախորդի սեսիան անմիջապես կկտրվի և կպահանջի նոր մուտք։",
	securityClientsDisconnectThisSessionTitle: "Անջատե՞լ այս սեսիան",
	securityClientsExpires: "Լրանում է",
	securityClientsFailedToLoadDataTitle: "Չհաջողվեց բեռնել հաճախորդների տվյալները",
	securityClientsFilterActiveAndRecent: "Ակտիվ + վերջին",
	securityClientsFiltersDescription:
		"Զտեք ակտիվությամբ, աշխարհագրությամբ, սարքային միջավայրով, արգելափակված ցանցի կարգավիճակով կամ թեթև ռիսկային ազդակներով։",
	securityClientsFiltersTitle: "Զտիչներ և որոնում",
	securityClientsFirstSeen: "Առաջին անգամ",
	securityClientsLastActive: "Վերջին ակտիվությունը",
	securityClientsLastDenied: "Վերջին մերժում",
	securityClientsLiveInventoryDescription:
		"Օգտագործեք խմբավորված սարքերի տեսքը արագ պատկերի համար կամ սեսիաների տեսքը՝ օգտատիրոջ և IP-ի ճշգրիտ գործողությունների համար։",
	securityClientsLiveInventoryTitle: "Հաճախորդների կենդանի ցուցակ",
	securityClientsLiveMonitoring: "Կենդանի մոնիթորինգ",
	securityClientsLiveSocketUpdates: "Կենդանի socket թարմացումներ",
	securityClientsLocationPrivacyNote:
		"Տեղադրության նշիչներն օգտագործում են IP հասցեով մոտավոր գեոլոկացիա և կարող են արտացոլել ցանցային դարպասը, ինտերնետ մատակարարին, VPN-ը կամ գրասենյակի ելքային կետը՝ սարքի ճշգրիտ դիրքի փոխարեն։",
	securityClientsMapFailedToLoad: "Չհաջողվեց բեռնել քարտեզը",
	securityClientsMapProviderNotConfigured: "Քարտեզի մատակարարը կարգավորված չէ",
	securityClientsMostActiveUsers: "Ամենաակտիվ օգտատերեր",
	securityClientsNetworkAndLocation: "Ցանց և տեղակայում",
	securityClientsNoActiveUsersForFilters: "Այս ֆիլտրերի համար ակտիվ օգտատերեր չեն գտնվել։",
	securityClientsNoApproximateGeoPoints:
		"Ընթացիկ ֆիլտրերի համար դեռ մոտավոր աշխարհագրական կետեր չկան։",
	securityClientsNoBlockedRequestActivity:
		"Վերջին 24 ժամում արգելափակված հարցումների ակտիվություն չի գրանցվել։",
	securityClientsNoDataYet: "Տվյալներ դեռ չկան։",
	securityClientsNoEmail: "Էլ. փոստ չկա",
	securityClientsNoMatchingResults: "Ընթացիկ ֆիլտրերին համապատասխան սեսիաներ կամ սարքեր չկան։",
	securityClientsNoSuspiciousPatterns:
		"Թեթև հևրիստիկաները այս պահին կասկածելի օրինաչափություններ չեն գտել։",
	securityClientsNoUsersAcrossMultipleDevices: "Այս պահին մի քանի սարքերից օգտվող օգտատերեր չկան։",
	securityClientsNotBlocked: "Արգելափակված չէ",
	securityClientsOf: "-ից",
	securityClientsOn: "Համակարգում՝",
	securityClientsOperatingSystem: "Օպերացիոն համակարգ",
	securityClientsPrimaryUser: "Հիմնական օգտատեր",
	securityClientsRecentActivityWindow: "Վերջին ակտիվության պատուհան՝",
	securityClientsRefreshLiveData: "Թարմացնել կենդանի տվյալները",
	securityClientsReset: "Վերակայել",
	securityClientsRetryLoading: "Կրկին բեռնել",
	securityClientsRisk: "Ռիսկ",
	securityClientsRiskHigh: "Բարձր",
	securityClientsRiskLow: "Ցածր",
	securityClientsRiskMedium: "Միջին",
	securityClientsRiskNormal: "Նորմալ",
	securityClientsRiskSignals: "Ռիսկի ազդակներ",
	securityClientsSignalBlockedAttemptsDescription:
		"{count} հարցում մերժվել է IP քաղաքականության կիրառման արդյունքում։",
	securityClientsSignalBlockedAttemptsTitle: "Արգելափակված IP հարցումներ վերջին 24 ժամում",
	securityClientsSignalBlockedIpSessionsDescription:
		"{count} մոնիտորինգային սեսիա կապված է ակտիվ արգելափակված IP քաղաքականության գրառման հետ։",
	securityClientsSignalBlockedIpSessionsTitle: "Սեսիաներ դեռ տեսանելի են արգելափակված IP-ներից",
	securityClientsSignalManyDevicesDescription:
		"Տեսանելի է {count} տարբեր սարքում ակտիվ մոնիտորինգի պատուհանի ներսում։",
	securityClientsSignalManyDevicesTitle: "{user}-ը ունի շատ սարքեր",
	securityClientsSignalMultiCountryDescription:
		"Վերջին 24 ժամում ակտիվությունը ընդգրկում է {count} երկիր։",
	securityClientsSignalMultiCountryTitle: "{user}-ը ակտիվ է մի քանի երկրներում",
	securityClientsSignalSeverityCritical: "Կրիտիկական",
	securityClientsSignalSeverityInfo: "Տեղեկատվական",
	securityClientsSignalSeverityWarning: "Նախազգուշացում",
	securityClientsSearchPlaceholder: "Որոնել օգտատիրոջ, էլ. փոստի, IP հասցեի կամ սարքի անունով",
	securityClientsSecurityActionFailed: "Անվտանգության գործողությունը չհաջողվեց",
	securityClientsSecurityCenter: "Անվտանգության կենտրոն",
	securityClientsSecurityUpdated: "Անվտանգությունը թարմացվել է",
	securityClientsSessionDisconnected: "Սեսիան անջատված է։",
	securityClientsSessions: "Սեսիաներ",
	securityClientsSetEnvToEnableMapPrefix: "Սահմանեք",
	securityClientsSetEnvToEnableMapSuffix: "կենդանի աշխարհագրական տեսքը միացնելու համար։",
	securityClientsSharedDevice: "Կիսվող սարք",
	securityClientsShowing: "Ցուցադրված է",
	securityClientsStatus: "Կարգավիճակ",
	securityClientsStatusActive: "Ակտիվ",
	securityClientsStatusConnected: "Միացված",
	securityClientsStatusRecent: "Վերջին",
	securityClientsStatusRevoked: "Հետ կանչված",
	securityClientsStatusStale: "Հնացած",
	securityClientsSubtitle:
		"Վերահսկեք բոլոր միացված և վերջերս ակտիվ հաճախորդի սեսիաները, տեսեք դրանց աղբյուրը, վաղ հայտնաբերեք ռիսկային օրինաչափությունները և անմիջապես գործեք անվտանգության մոդուլից դուրս չգալով։",
	securityClientsSuspicious: "Կասկածելի",
	securityClientsSuspiciousSessions: "Կասկածելի սեսիաներ",
	securityClientsSyncingLiveChanges: "Կենդանի փոփոխությունների համաժամեցում...",
	securityClientsTitle: "Անվտանգության հաճախորդներ",
	securityClientsTopBrowsers: "Թոփ բրաուզերներ",
	securityClientsTopCountries: "Թոփ երկրներ",
	securityClientsTopOperatingSystems: "Թոփ օպերացիոն համակարգեր",
	securityClientsUnableToDisconnectSelectedSession: "Չհաջողվեց անջատել ընտրված սեսիան։",
	securityClientsUnableToDisconnectUserSessions: "Չհաջողվեց անջատել օգտատիրոջ սեսիաները։",
	securityClientsUnableToLoadDashboard: "Չհաջողվեց բեռնել Security Clients վահանակը։",
	securityClientsUnableToLoadGoogleMaps: "Այս պահին Google Maps-ը չի բեռնվում։",
	securityClientsUnknownBrowser: "Անհայտ բրաուզեր",
	securityClientsUnknownDevice: "Անհայտ սարք",
	securityClientsUnknownIp: "Անհայտ IP",
	securityClientsUnknownOs: "Անհայտ ՕՀ",
	securityClientsUnknownUser: "Անհայտ օգտատեր",
	securityClientsUnknownUserInitial: "Օ",
	securityClientsUpdated: "Թարմացվել է",
	securityClientsUser: "Օգտատեր",
	securityClientsUserSessionsDisconnected: "Օգտատիրոջ սեսիաներն անջատվել են։",
	securityClientsUsers: "Օգտատերեր",
	securityClientsUsersSeenOnDevice: "օգտատեր այս սարքի վրա",
	securityClientsUsersWithMultipleDevices: "Մի քանի սարք ունեցող օգտատերեր",
	securityClientsViewUserSecurity: "Բացել օգտատիրոջ անվտանգությունը",
	securityClipWord: "Հատված",
	securityConnectedDevices: "Միացված սարքեր",
	securityCreated: "Ստեղծված",
	securityDeleteDevice: "Ջնջել սարքը",
	securityDeleteDeviceConfirm: "Դուք վստա՞հ եք, որ ուզում եք ջնջել սա",
	securityDeleteDeviceNote:
		"Սա կջնջի միայն անվտանգության սարքի գրառումը: IT-ում PC-ի պրոֆիլը չի փոխվի:",
	securityDeleteDeviceTitle: "Ջնջել անվտանգության սարքը",
	securityDeleteMedia: "Ջնջել մեդիան",
	securityDeletePolicyConfirm: "Ջնջե՞լ այս քաղաքականությունը",
	securityDevice: "Սարք",
	securityDeviceFallback: "Սարք",
	securityDeviceIdLabel: "Սարքի ID",
	securityDeviceNotFound: "Սարքը չի գտնվել",
	securityDeviceSettings: "Սարքի կարգավորումներ",
	securityDeviceSettingsHint:
		"Գերակայում է ակտիվ քաղաքականությունը այս սարքի համար։ Եթե դաշտը դատարկ է՝ ժառանգվում է քաղաքականությունից։",
	securityDevicesBreadcrumb: "Սարքեր",
	securityDevicesTitle: "Անվտանգության սարքեր",
	securityDevicesWithAlerts: "Սարքեր՝ ծանուցումներով",
	securityDividerCapture: "Ֆիքսում",
	securityDividerNotes: "Նշումներ",
	securityDividerTracking: "Հետևում",
	securityDuration: "Տևողություն",
	securityEg15: "օր. 15",
	securityEg30: "օր. 30",
	securityEg300: "օր. 300",
	securityEg5: "օր. 5",
	securityEg60: "օր. 60",
	securityEnabled: "Միացված",
	securityEnd: "Ավարտ",
	securityEventFlushSeconds: "Իրադարձությունների դատարկում (վրկ)",
	securityEventsCount: "իրադարձություն",
	securityEventsCountPlural: "իրադարձություններ",
	securityEvtAppProcess: "Ծրագիր / Գործընթաց",
	securityEvtAppUsage: "Ծրագրի օգտագործում",
	securityEvtFileEvent: "Ֆայլային իրադարձություն",
	securityEvtHeartbeat: "Ագենտի հարցում (Heartbeat)",
	securityEvtInputActivity: "Մուտքի ակտիվություն",
	securityEvtKeystroke: "Ստեղնահպում",
	securityEvtMouseClick: "Մկնիկի սեղմում",
	securityEvtSessionEnd: "Սեսիայի ավարտ",
	securityEvtSessionStart: "Սեսիայի սկիզբ",
	securityEvtSystemBoot: "Համակարգի բեռնում",
	securityEvtSystemShutdown: "Համակարգի անջատում",
	securityEvtUsb: "USB իրադարձություն",
	securityEvtUserLogin: "Օգտատիրոջ մուտք",
	securityEvtUserLogout: "Օգտատիրոջ ելք",
	securityEvtWebVisit: "Վեբ այցելություն",
	securityEvtWorkstationLock: "Էկրանը կողպված է",
	securityEvtWorkstationUnlock: "Էկրանը ապակողպված է",
	securityFailedLoadOverview: "Չհաջողվեց բեռնել անվտանգության ամփոփագիրը",
	securityFailedSavePolicy: "Քաղաքականությունը պահպանել չհաջողվեց",
	securityFalsePositiveBtn: "Կեղծ ազդանշան",
	securityFileEventTracking: "Ֆայլային իրադարձություններ",
	securityFilterByDate: "Զտել ըստ ամսաթվի",
	securityFilterDateRange: "Զտել ամսաթվերի միջակայքով",
	securityFilteredSuffix: "(զտված)",
	securityFps: "FPS",
	securityHostname: "Հոսթի անուն (Hostname)",
	securityInputActivityCounts: "Մուտքի ակտիվություն (հաշվիչներ)",
	securityInputKeystrokeClickTracking: "Մուտքի ստեղնի/սեղմման հետևում",
	securityInputModeActivityCountsShort: "Միայն ակտիվություն — ստեղն/սեղմ հաշվիչներ",
	securityInputModeActivityOnly: "Միայն ակտիվություն (հաշվիչներ)",
	securityInputModeDisabled: "Անջատված",
	securityInputModeDisabledShort: "Անջատված — մուտքի մետրիկա չկա",
	securityInputModeEventsOnly: "Միայն իրադարձություններ",
	securityInputModeEventsStream: "Միայն իրադարձություններ — հոսք",
	securityInputModeFullDetail: "Լրիվ մանրամասնություն (ստեղներ + սեղմումներ)",
	securityInputModeFullKeystrokes: "Լրիվ մանրամասնություն — ստեղներ և սեղմման կետեր",
	securityInputModeShort: "Մուտքի ռեժիմ",
	securityInputTrackingMode: "Մուտքի հետևման ռեժիմ",
	securityInternalNotesPlaceholder: "Ներքին նշումներ...",
	securityIpPolicyActions: "Գործողություններ",
	securityIpPolicyActive: "Ակտիվ",
	securityIpPolicyAllow: "Թույլատրել",
	securityIpPolicyAppliesToAllIps:
		"Մուտքի այս թույլատրող պատուհանը կիրառել բոլոր IP հասցեների համար",
	securityIpPolicyAllowRuleSaved: "Թույլատրող կանոնը պահպանվել է",
	securityIpPolicyAllowRuleSavedMessage: "Թույլատրող կանոնը պահպանվել է։",
	securityIpPolicyBlock: "Արգելափակել",
	securityIpPolicyBlockIp: "Արգելափակել IP-ն",
	securityIpPolicyCreatedBy: "Ստեղծող",
	securityIpPolicyCurrentEntries: "Ընթացիկ գրառումներ",
	securityIpPolicyDeactivate: "Ապաակտիվացնել",
	securityIpPolicyDeactivateAllowRuleText:
		"Այս IP հասցեն այլևս չի շրջանցի համապատասխան արգելափակման կանոնները։",
	securityIpPolicyDeactivateAllowRuleTitle: "Ապաակտիվացնե՞լ այս թույլատրող կանոնը",
	securityIpPolicyEntryDeactivatedMessage: "IP քաղաքականության գրառումը ապաակտիվացվել է։",
	securityIpPolicyExpires: "Լրանում է",
	securityIpPolicyExpiresAt: "Լրանում է",
	securityIpPolicyExpiresAtPlaceholder: "Ըստ ցանկության ժամանակավոր ավարտ",
	securityIpPolicyFailedToLoadTitle: "Չհաջողվեց բեռնել IP քաղաքականությունը",
	securityIpPolicyFailedToSaveTitle: "Չհաջողվեց պահպանել IP քաղաքականությունը",
	securityIpPolicyFailedToUnblockTitle: "Չհաջողվեց ապաարգելափակել IP-ն",
	securityIpPolicyGlobalApiEnforcement: "Գլոբալ կիրառում API-ում",
	securityIpPolicyInactive: "Ոչ ակտիվ",
	securityIpPolicyIntroText:
		"Գրառումները համադրվում են նորմալացված հաճախորդի IP հասցեի հետ։ Հարթակի մյուս հատվածներում տեղակայման տվյալները միտումնավոր մոտավոր են և չպետք է դիտվեն որպես ճշգրիտ։",
	securityIpPolicyIp: "IP",
	securityIpPolicyIpAddress: "IP հասցե",
	securityIpPolicyIpAddressBlocked: "IP հասցեն արգելափակվել է։",
	securityIpPolicyIpAddressUnblocked: "IP հասցեն ապաարգելափակվել է։",
	securityIpPolicyIpBlocked: "IP-ն արգելափակվել է",
	securityIpPolicyIpBlockedMessage: "IP հասցեն ավելացվել է արգելափակման քաղաքականությանը։",
	securityIpPolicyIpUnblocked: "IP-ն ապաարգելափակվել է",
	securityIpPolicyLastMatched: "Վերջին համընկնում",
	securityIpPolicyMatches: "Համընկնումներ",
	securityIpPolicyNewEntry: "Քաղաքականության նոր գրառում",
	securityIpPolicyNoEntriesFound: "IP քաղաքականության գրառումներ չեն գտնվել։",
	securityIpPolicyNotes: "Նշումներ",
	securityIpPolicyNotesPlaceholder: "Օպերացիոն նշումներ ադմինների համար",
	securityIpPolicyOperationalNotesOptional: "Օպերացիոն նշումներ (ըստ ցանկության)",
	securityIpPolicyReason: "Պատճառ",
	securityIpPolicyReasonOptional: "Պատճառ (ըստ ցանկության)",
	securityIpPolicyReasonPlaceholder: "Կրկնվող կասկածելի մուտքի փորձեր",
	securityIpPolicyRemoveIpBlockText: "Այս IP հասցեն այլևս չի արգելափակվի հարթակի քաղաքականությամբ։",
	securityIpPolicyRemoveIpBlockTitle: "Հեռացնե՞լ այս IP արգելափակումը",
	securityIpPolicyRuleType: "Կանոնի տեսակ",
	securityIpPolicySaveEntry: "Պահպանել քաղաքականության գրառումը",
	securityIpPolicyShowInactive: "Ցուցադրել ոչ ակտիվները",
	securityIpPolicyScope: "Շրջանակ",
	securityIpPolicyScopeApi: "Ամբողջ API",
	securityIpPolicyScopeLogin: "Միայն մուտք",
	securityIpPolicyStatus: "Կարգավիճակ",
	securityIpPolicyStarts: "Սկսվում է",
	securityIpPolicyStartsAt: "Սկսվում է",
	securityIpPolicyStartsAtPlaceholder: "Կանոնի կամընտիր մեկնարկի ժամ",
	securityIpPolicyTitle: "IP արգելափակման և թույլատրության քաղաքականություն",
	securityIpPolicyLockdownTitle: "Արգելափակել բոլոր արտաքին մուտքերը",
	securityIpPolicyLockdownDesc:
		"Միացված լինելու դեպքում մուտքի թույլատրման կանոնի հետ չկապված օգտատերերը կարող են մուտք գործել միայն կարգավորված գրասենյակային IP-ից։ Ավելացրեք գրասենյակային IP-երը ստորև կամ օգտագործեք մուտքի թույլատրման կանոններ առանց օգտատերերի կապման։",
	securityIpPolicyLockdownOn: "Միացված է",
	securityIpPolicyLockdownOff: "Անջատված է",
	securityIpPolicyLockdownSavedTitle: "Արգելափակումը թարմացվեց",
	securityIpPolicyLockdownOnMessage:
		"Արտաքին մուտքերն այժմ սահմանափակված են հաստատված գրասենյակային IP-երով։",
	securityIpPolicyLockdownOffMessage:
		"Չսահմանափակված օգտատերերն այժմ կարող են մուտք գործել ցանկացած տեղից։",
	securityIpPolicyOfficeIpsTitle: "Գրասենյակային IP-եր",
	securityIpPolicyOfficeIpsDesc:
		"Ցանցային հասցեներ, որոնք համարվում են գրասենյակ։ Արգելափակման ռեժիմում այս IP-երից մուտքերը թույլատրվում են, մնացած IP-երը արգելափակվում են, եթե օգտատերը վստահելի օգտատերերի ցանկում չէ։",
	securityIpPolicyOfficeIpsPh: "Մուտքագրեք գրասենյակային IP-ն և սեղմեք Enter",
	securityIpPolicyOfficeIpsSave: "Պահպանել գրասենյակային IP-երը",
	securityIpPolicyOfficeIpsSavedTitle: "Գրասենյակային IP-երը թարմացվեցին",
	securityIpPolicyOfficeIpsSavedMessage:
		"Գրասենյակային ցանցային հասցեները պահպանվել են։ Արգելափակումը դրանք կհամարի գրասենյակային տեղեր։",
	securityIpPolicyTrustedUsersTitle: "Գրասենյակից և դրսից մուտք ունեցող օգտատերեր",
	securityIpPolicyTrustedUsersDesc:
		"Այս օգտատերերը կարող են մուտք գործել ցանկացած տեղից՝ գրասենյակից կամ դրսից, նույնիսկ արգելափակման ռեժիմի դեպքում։ IP-ի կոշտ արգելափակումները շարունակում են գործել։",
	securityIpPolicyTrustedUsersPh: "Ընտրեք վստահելի օգտատերերին",
	securityIpPolicyTrustedUsersSave: "Պահպանել վստահելի օգտատերերին",
	securityIpPolicyTrustedUsersSavedTitle: "Վստահելի օգտատերերը թարմացվեցին",
	securityIpPolicyTrustedUsersSavedMessage:
		"Այս օգտատերերն այժմ կարող են մուտք գործել գրասենյակից և դրսից։",
	securityIpPolicyOfficeBindingTitle: "Գրասենյակային մուտքի կապ",
	securityIpPolicyOfficeBindingDesc:
		"Կապեք ընտրված օգտատերերին այս IP-ի(ների) և ընտրովի ժամային պատուհանի հետ։ Այդ օգտատերերը կարող են մուտք գործել միայն այստեղից՝ այս ժամերին։",
	securityIpPolicyAdditionalIps: "Լրացուցիչ IP-եր",
	securityIpPolicyAdditionalIpsDesc:
		"Այս կանոնի համար լրացուցիչ հաստատված IP-եր՝ ի լրումն վերևի հիմնական IP-ի։",
	securityIpPolicyAdditionalIpsPh: "Մուտքագրեք IP և սեղմեք Enter",
	securityIpPolicyAddIp: "Ավելացնել IP",
	securityIpPolicyAppliesToAllUsers: "Կիրառել բոլոր օգտատերերի համար",
	securityIpPolicyAppliesToAllUsersDesc:
		"Յուրաքանչյուր օգտատեր պետք է մուտք գործի այս կանոնի IP-ից և պատուհանից։ Համարժեք է ողջ գրասենյակի սահմանափակմանը։",
	securityIpPolicySelectedUsers: "Ընտրված օգտատերեր",
	securityIpPolicySelectedUsersDesc:
		"Այս օգտատերերը կարող են մուտք գործել միայն այս կանոնի IP-ից՝ թույլատրված պատուհանում։",
	securityIpPolicySelectedUsersPh: "Ընտրեք օգտատերերին",
	securityIpPolicyRecurringWindowTitle: "Թույլատրված ժամային պատուհան (ընտրովի)",
	securityIpPolicyDaysOfWeek: "Թույլատրված օրեր",
	securityIpPolicyDaysOfWeekDesc: "Թողեք դատարկ՝ բոլոր օրերը թույլատրելու համար։",
	securityIpPolicyDaysOfWeekPh: "Ցանկացած օր",
	securityIpPolicyDailyStart: "Սկսած (ԺԺ:ՐՐ)",
	securityIpPolicyDailyEnd: "Մինչև (ԺԺ:ՐՐ)",
	securityIpPolicyTimezone: "Ժամային գոտի",
	securityIpPolicyDayMon: "Երկ",
	securityIpPolicyDayTue: "Երք",
	securityIpPolicyDayWed: "Չրք",
	securityIpPolicyDayThu: "Հնգ",
	securityIpPolicyDayFri: "Ուր",
	securityIpPolicyDaySat: "Շբթ",
	securityIpPolicyDaySun: "Կրկ",
	securityIpPolicyUsersColumn: "Օգտատերեր",
	securityIpPolicyWindowColumn: "Ժամային պատուհան",
	securityIpPolicyAllUsers: "Բոլոր օգտատերերը",
	securityIpPolicyAllIps: "Բոլոր IP-երը",
	securityIpPolicyInvalidTimeWindow: "Ժամերը պետք է լինեն ԺԺ:ՐՐ ձևաչափով։",
	securityIpPolicyTimeWindowBothRequired: "Նշեք և՛ սկիզբ, և՛ ավարտ, կամ թողեք երկուսն էլ դատարկ։",
	securityIpPolicyType: "Տեսակ",
	securityIpPolicyUnableToBlockIpAddress: "Չհաջողվեց արգելափակել այս IP հասցեն։",
	securityIpPolicyUnableToLoadEntries: "Չհաջողվեց բեռնել IP քաղաքականության գրառումները։",
	securityIpPolicyUnableToSaveEntry: "Չհաջողվեց պահպանել IP քաղաքականության գրառումը։",
	securityIpPolicyUnableToUnblockIpAddress: "Չհաջողվեց ապաարգելափակել այս IP հասցեն։",
	securityIpPolicyUnableToUpdateEntry: "Չհաջողվեց թարմացնել IP քաղաքականության գրառումը։",
	securityIpPolicyUnblock: "Ապաարգելափակել",
	securityIpPolicyUnblockIp: "Ապաարգելափակել IP-ն",
	securityIpPolicyUnblockThisIpText:
		"Համապատասխան արգելափակման կանոնը կանջատվի, և IP-ն այլևս չի մերժվի քաղաքականությամբ։",
	securityIpPolicyUnblockThisIpTitle: "Ապաարգելափակե՞լ այս IP-ն",
	securityIpPolicyWarningText:
		"Արգելափակված IP գրառումները արգելում են մուտքը ամբողջ API-ում, ոչ միայն մուտքագրման պահին։ Օգտագործեք ժամանակավոր ավարտ, երբ կարճաժամկետ արգելափակումը ավելի անվտանգ է, քան մշտականը։",
	securityKeyCharPrefix: "Ստեղն՝",
	securityLastSeen: "Վերջին կապ",
	securityLatestClip: "Վերջին հատվածը",
	securityLinkedItPc: "Կապակցված IT համակարգիչ (PC)՝",
	securityLiveLoadingSub: "Կապ ենք հաստատում ագենտի հետ — էկրանի նախադիտումը կհայտնվի մի պահից։",
	securityLiveOfflineHint: "Սարքը անցանց է՝ կենդանի դիտումը պահանջում է միացված ագենտ։",
	securityLivePressStart: "Սեղմեք «Միացնել կենդանի»՝ հոսքը բացելու համար։",
	securityLiveScreenAlt: "Կենդանի էկրան",
	securityLiveStatusLive: "Կենդանի",
	securityLiveStatusStandby: "Սպասում",
	securityLiveStreamHint:
		"Հոսքը՝ կադրի բնական լայնության և բարձրության կեսը, մինչև 10 կադր/վրկ։ Ագենտը v1.4.0+ jimp-ով։",
	securityLiveWaitingFrames: "Կենդանի հոսքի բեռնում…",
	securityLoggedInSince: "Մուտք գործած է սկսած՝",
	securityLoggedOutSince: "Վերջին ելք՝",
	securityMediaPrefix: "Մեդիա",
	securityMediaTitle: "Անվտանգության մեդիա",
	securityMiddleClick: "Միջին սեղմում",
	securityModuleErrorTitle: "Անվտանգության մոդուլի սխալ",
	securityName: "Անուն",
	securityNearbyScreenshots: "Մոտակա էկրանապատկերներ",
	securityNever: "Երբեք",
	securityNewMediaBadge: "Նոր",
	securityNewPolicy: "Նոր քաղաքականություն",
	securityNoActivityEvents: "Գործունեության իրադարձություններ չկան",
	securityNoAlertRecordingsPage: "Այս էջում ծանուցման ձայնագրություններ չկան",
	securityNoAlertsForDevice: "Այս սարքի համար ծանուցումներ չկան",
	securityNoAlertsFound: "Ծանուցումներ չեն գտնվել",
	securityNoDevicesFound: "Սարքեր չեն գտնվել",
	securityNoEventsMatchFilter: "Այս զտիչին համապատասխան իրադարձություններ չկան",
	securityNoOpenAlerts: "Բաց ծանուցումներ չկան",
	securityNoPoliciesConfigured:
		"Քաղաքականություններ չեն կարգավորվել։ Ստեղծեք՝ հսկողություն սկսելու համար։",
	securityNoPreview: "Նախադիտում չկա",
	securityNoRiskyDevices: "Ռիսկային սարքեր չկան",
	securityNoScreenshotsFound: "Էկրանապատկերներ չեն գտնվել",
	securityNoScreenshotsYet: "Էկրանապատկերներ դեռ չկան",
	securityNoSessionsFound: "Սեսիաներ չեն գտնվել",
	securityNoSessionsRecorded: "Սեսիաներ չեն գրանցվել",
	securityNoUserSession: "Մուտք չկա",
	securityNoUserSessionLiveHint:
		"ԱՀ միացված է, բայց օգտատերը մուտք չի գործել։ Ուղիղ հեռարձակումն ու սքրինշոթերն անհասանելի են։",
	securityNoUserSessionTitle: "Օգտատեր չի մուտք գործել",
	securityNoVideoSegmentsFound: "Տեսանյութի հատվածներ չեն գտնվել",
	securityNoVideosYet: "Տեսանյութի հատվածներ դեռ չկան",
	securityOS: "Օպերացիոն համակարգ (ՕՀ)",
	securityOnlineDevices: "Առցանց սարքեր",
	securityOpenAlerts: "Բաց ծանուցումներ",
	securityOpenPcRecord: "Բացել համակարգչի (PC) գրառումը",
	securityOverrideOff: "Անջատված",
	securityOverrideOn: "Միացված",
	securityOverridePrefix: "Գերակայում՝",
	securityOverviewTitle: "Անվտանգության ամփոփագիր",
	securityPageOf: "էջ",
	securityPolActivityTrackingDivider: "Գործունեության հետևում",
	securityPolAfterHoursStart: "Աշխատանքային ժամերից դուրս սկիզբ",
	securityPolAlertClipLength: "Տեսահատվածի երկարություն (վրկ)",
	securityPolAlertScore: "Ծանուցման միավոր (0–100)",
	securityPolAlertSeverity: "Ծանուցման կարևորություն",
	securityPolAlertVideoDivider: "Տեսագրություն ծանուցման դեպքում",
	securityPolAlertVideoInfo:
		"Կանոնի աշխատելիս ագենտը գրում է մեկ աշխատասեղանի տեսահատված՝ ստորև կարգավորումներով։ Երկարությունն ու որակը նույնն են բոլոր կանոնների համար։",
	securityPolAllowedHoursDivider: "Թույլատրելի ֆիքսման ժամեր",
	securityPolBadgeAlert: "Ծանուցում",
	securityPolBlockedApps: "Արգելված ծրագրեր",
	securityPolBlockedAppsPh: "օր. telegram, discord, torrent",
	securityPolBlockedDomains: "Արգելված դոմեններ",
	securityPolBlockedDomainsPh: "օր. torrent-site.com, telegram.org",
	securityPolBreadcrumbPolicies: "Քաղաքականություններ",
	securityPolBulkThreshold:
		"Զանգվածային ֆայլային իրադարձությունների շեմ (իրադարձություն/խմբաքանակ)",
	securityPolBulkThresholdDesc:
		"Մեկ վերբեռնման խմբաքանակում քայքայիչ ֆայլային իրադարձությունների թիվը",
	securityPolCollectInputMetrics: "Հավաքել մուտքի ակտիվության մետրիկա",
	securityPolCollectInputMetricsDesc:
		"Միայն մկնիկ/ստեղ իրադարձությունների հաշվիչներ (առանց բովանդակության)",
	securityPolCreateAlert: "Ստեղծել ծանուցում",
	securityPolCreateAlertDesc:
		"Կանոնի համընկնելիս բացվում է անվտանգության ծանուցում (տեսագրությունը՝ «Ֆիքսում» ներդիրի կարգավորումներով)",
	securityPolDescription: "Նկարագրություն",
	securityPolEditPolicy: "Խմբագրել քաղաքականությունը",
	securityPolEnableRule: "Միացնել կանոնը",
	securityPolEventsRetention: "Իրադարձությունների պահպանում (օրեր)",
	securityPolEventsRetentionDesc: "Այս ժամկետից հին գործունեության գրառումները կմաքրվեն",
	securityPolExcludedDomains: "Բացառված դոմեններ",
	securityPolExcludedDomainsPh: "օր. online-banking.com",
	securityPolExcludedProcesses: "Բացառված գործընթացների անուններ",
	securityPolExcludedProcessesPh: "օր. 1Password, Bitwarden",
	securityPolIgnoredAlertDevices: "Անտեսված սարքեր ահազանգերի համար",
	securityPolIgnoredAlertDevicesDesc:
		"Ընտրված սարքերը շարունակում են ուղարկել ակտիվություն, սակայն քաղաքականության կանոնները նրանց համար անվտանգային ահազանգ կամ ձայնագրություն չեն ստեղծի։",
	securityPolIgnoredAlertDevicesPh: "Որոնել և ընտրել սարքեր՝ ահազանգներից բացառելու համար...",
	securityPolInputActivityCounts: "Միայն ակտիվություն — մկնիկ/ստեղ հաշվիչներ",
	securityPolInputDisabledNoTrack: "Անջատված — մուտքին չհետևել",
	securityPolInputEventsCount: "Միայն իրադարձություններ — միայն ստեղների հաշվիչներ",
	securityPolInputFullDetail: "Լրիվ մանրամասնություն — ստեղներ և սեղմման կետեր",
	securityPolInputModeLabel: "Մուտքի հետևման ռեժիմ",
	securityPolInputTrackingDivider: "Մուտքի հետևում",
	securityPolMaskSensitive: "Թաքցնել զգայուն պատուհանները (գաղտնաբառերի կառավարիչներ, բանկ)",
	securityPolMaskSensitiveDesc: "Չգրանցել էկրանապատկերներ բացառված ծրագրերի/պատուհանների համար",
	securityPolMaxFps: "Մաքս. FPS",
	securityPolMediaRetention: "Մեդիայի պահպանում (օրեր)",
	securityPolMediaRetentionDesc: "Այս ժամկետից հին էկրանապատկերները և տեսահատվածները կջնջվեն",
	securityPolNewSecurityPolicy: "Նոր անվտանգության քաղաքականություն",
	securityPolNotifyUsersDesc:
		"Ընտրված օգտատերերը կստանան ծանուցում հավելվածում, երբ այս քաղաքականության ցանկացած կանոն ակտիվանա։",
	securityPolNotifyUsersLabel: "Ծանուցել ադմինիստրատորներին քաղաքականության ակտիվացման դեպքում",
	securityPolNotifyUsersPh: "Փնտրեք և ընտրեք ծանուցվող օգտատերերին…",
	securityPolPolicyName: "Քաղաքականության անուն",
	securityPolPolicyNamePh: "օր. Ծրագրավորողների քաղաքականություն",
	securityPolPriority: "Առաջնահերթություն",
	securityPolPriorityDesc: "Ավելի մեծ թիվ = առաջնահերթ գնահատում",
	securityPolRecordVideoOnAlert: "Տեսագրել ծանուցման դեպքում",
	securityPolRecordVideoOnAlertDesc:
		"Եթե անջատված է՝ ծանուցումները ստեղծվում են, բայց տեսանյութ չի գրանցվում",
	securityPolRuleAfterHoursDesc:
		"Աշխատում է, երբ գործունեություն է հայտնաբերվում սահմանված աշխատանքային ժամերից դուրս։",
	securityPolRuleAfterHoursLabel: "Գործունեություն աշխատանքային ժամերից դուրս",
	securityPolRuleBlockedAppDesc: "Աշխատում է, երբ օգտվողը բացում է արգելված ցանկի ծրագիր։",
	securityPolRuleBlockedAppLabel: "Արգելված ծրագիր",
	securityPolRuleBlockedDomainDesc: "Աշխատում է, երբ օգտվողը այցելում է արգելված դոմեն։",
	securityPolRuleBlockedDomainLabel: "Արգելված դոմեն",
	securityPolRuleBulkFileDesc:
		"Աշխատում է, երբ մեկ խմբաքանակում շատ ֆայլերի ջնջում, վերանվանում կամ տեղափոխում է տեղի ունենում։",
	securityPolRuleBulkFileLabel: "Ֆայլերի զանգվածային գործողություններ",
	securityPolRuleUsbDesc: "Աշխատում է, երբ USB սարքը միացվում է վերահսկվող սարքին։",
	securityPolRuleUsbLabel: "USB կրիչ հայտնաբերվել է",
	securityPolRulesIntro:
		"Կանոնները սահմանում են խախտումը և ծանուցման միավորումը։ «Ստեղծել ծանուցում» միացված լինելիս՝ անվտանգության ծանուցում է ստեղծվում, տեսագրությունը՝ «Ֆիքսում» ներդիրի կարգավորումներով (նույնն է բոլոր կանոնների համար)։",
	securityPolSavePolicy: "Պահպանել քաղաքականությունը",
	securityPolScope: "Շրջանակ",
	securityPolScopeDepartment: "Բաժին",
	securityPolScopeDevice: "Նշված սարքեր",
	securityPolScopeGlobal: "Գլոբալ — բոլոր սարքերի համար",
	securityPolScopeUser: "Նշված օգտվողներ",
	securityPolTabCapture: "Ֆիքսում",
	securityPolTabPrivacy: "Գաղտնիություն և բացառություններ",
	securityPolTabRetention: "Պահպանում",
	securityPolTabRules: "Կանոններ",
	securityPolTrackApps: "Հետևել ակտիվ ծրագրերին",
	securityPolTrackFiles: "Հետևել ֆայլային գործունեությանը",
	securityPolTrackWebsites: "Հետևել կայքերի այցելություններին",
	securityPolTrackingMaster: "Հետևումը միացված է (Գլխավոր անջատիչ)",
	securityPolTrackingMasterDesc:
		"Անջատված լինելիս՝ ծրագրերի, վեբի, ֆայլերի և մուտքի հետևումը կանջատվի",
	securityPolVisibleNotice: "Ցուցադրել աշխատակիցներին մոնիտորինգի ծանուցում",
	securityPolVisibleNoticeDesc:
		"Ցուցադրում է վահանակ՝ աշխատակցին տեղեկացնելով, որ մոնիտորինգը ակտիվ է",
	securityPolWorkDayStart: "Աշխատանքային օրվա սկիզբ (վերջ աշխատանքային ժամերից դուրս)",
	securityPolWorkingHours: "Աշխատանքային ժամեր (ըստ ցանկության)",
	securityPolWorkingHoursDesc:
		"Ֆիքսել միայն այս պատուհանում։ Ձևաչափ՝ ժժ:րր-ժժ:րր, օր. 09:00-18:00։ Դատարկ = միշտ։",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"Նշանները ցույց են տալիս, թե ինչն է միացված: Սքրինշոթները, վիդեոն, հավելվածները, վեբը կամ ֆայլերը միացնելու/անջատելու համար բացեք քաղաքականությունը (մատիտ) → «Ֆիքսում» ներդիր:",
	securityPoliciesTitle: "Անվտանգության քաղաքականություններ",
	securityPolicyDefaultBadge: "Լռելյայն քաղաքականություն",
	securityPriority: "Առաջնահերթություն",
	securityQueued: "Հերթագրված է",
	securityRecentOpenAlerts: "Վերջին բաց ծանուցումները",
	securityRecentScreenshots: "Վերջին էկրանապատկերները",
	securityRecordEverySeconds: "Գրառում ամեն (վրկ)",
	securityRecordVideo30s: "Տեսագրել (30 վրկ)",
	securityRefresh: "Թարմացնել",
	securityResolution: "Լուծաչափ (Resolution)",
	securityResolutionNotePlaceholder: "Լուծման նշում (ըստ ցանկության)",
	securityResolve: "Լուծել",
	securityRightClick: "Աջ սեղմում",
	securityRule: "Կանոն",
	securityRuleCode_AFTER_HOURS: "Աշխատանքային ժամերից դուրս",
	securityRuleCode_BLOCKED_APP: "Արգելված ծրագիր",
	securityRuleCode_BLOCKED_DOMAIN: "Արգելված դոմեն",
	securityRuleCode_BULK_FILE_EVENTS: "Ֆայլերի զանգվածային գործողություններ",
	securityRuleCode_USB_DETECTED: "USB կրիչ հայտնաբերվել է",
	securitySaveSettings: "Պահպանել կարգավորումները",
	securitySaved: "Պահպանված է",
	securityScope: "Շրջանակ",
	securityScopeType_department: "Բաժին",
	securityScopeType_device: "Սարք",
	securityScopeType_global: "Գլոբալ",
	securityScopeType_user: "Օգտվող",
	securityScreenshotAlt: "Էկրանապատկեր",
	securityScreenshotOptionsBlank: "Էկրանապատկերի ընտրանքներ (դատարկ = քաղաքականության լռելյայն)",
	securityScreenshots: "Էկրանապատկերներ",
	securityScreenshotsCount: "Էկրանապատկերներ",
	securityScreenshotsLabel: "Էկրանապատկերներ",
	securityScreenshotsToday: "Էկրանապատկերներ այսօր",
	securitySearch: "Որոնում",
	securitySearchDevicesPlaceholder: "Որոնում՝ հոսթ, ID, օգտվող...",
	securitySegmentLengthSeconds: "Հատվածի երկարություն (վրկ)",
	securitySelectedCount: "ընտրված",
	securitySessionActive: "Ակտիվ",
	securitySessionIdle: "Անգործության մեջ",
	securitySessionLocked: "Էկրանը կողպված է",
	securitySessionLockedCaptureHint:
		"Էկրանը կողպված է — էկրանապատկերները և տեսագրությունները դադարեցված են էկրանի կողպման ընթացքում։",
	securitySessionLockedLiveHint:
		"Օգտվողը կողպել է էկրանը։ Ուղիղ հեռարձակումը, էկրանապատկերները և տեսագրությունները հասանելի չեն էկրանի կողպման ընթացքում։",
	securitySessionLockedSince: "Կողպված է սկսած՝",
	securitySessionLockedTitle: "Էկրանը կողպված է",
	securitySessionNotFound: "Սեսիան չի գտնվել",
	securitySessionTimeline: "Սեսիայի ժամանակագիծ",
	securitySessionWord: "Սեսիա",
	securitySessionsTitle: "Սեսիաներ",
	securitySettingsDrawerTitle: "Կարգավորումներ",
	securitySettingsOverrideHint:
		"Գերակայում են քաղաքականությունը միայն այս սարքի համար։ Թողեք ինչպես կա՝ ժառանգելու համար։",
	securitySev_critical: "կրիտիկական",
	securitySev_high: "բարձր",
	securitySev_low: "ցածր",
	securitySev_medium: "միջին",
	securitySeverity: "Կարևորություն",
	securityShowAllVideos: "Ցուցադրել բոլոր տեսանյութերը",
	securitySourceEvents: "Աղբյուրի իրադարձություններ",
	securitySpeedSec: "Արագություն (վրկ)՝",
	securityStart: "Սկիզբ",
	securityStartLive: "Միացնել կենդանի դիտումը",
	securityStatOf: "-ից",
	securityStatus: "Կարգավիճակ",
	securityStatus_error: "Սխալ",
	securityStatus_offline: "Անցանց",
	securityStatus_online: "Առցանց",
	securityStatus_pending: "Սպասման մեջ",
	securityStatus_unknown: "Անհայտ",
	securityStopLive: "Կանգնեցնել",
	securityTabActivity: "Գործունեություն",
	securityTabAlerts: "Ծանուցումներ",
	securityTabLive: "Կենդանի միացում",
	securityTabScreenshots: "Էկրանապատկերներ",
	securityTabSessions: "Սեսիաներ",
	securityTabSettings: "Կարգավորումներ",
	securityTabVideos: "Տեսանյութեր",
	securityTakeScreenshot: "Վերցնել էկրանապատկեր",
	securityTitle: "Վերնագիր",
	securityTooltipAppTrack: "Ծրագրերի հետևում",
	securityTooltipCaptureMaster: "Միացնել/անջատել էկրանի և մեդիայի ֆիքսումը (Գլխավոր)",
	securityTooltipScreenshot: "Էկրանապատկերի ֆիքսում",
	securityTooltipTrackingMaster: "Ծրագրերի, վեբի, ֆայլերի և մուտքի հետևման գլխավոր անջատիչ",
	securityTooltipWebTrack: "Դոմենների հետևում",
	securityTopRiskyDevices: "Ամենառիսկային սարքերը",
	securityTracking: "Հետևում",
	securityTrackingEnabledMaster: "Հետևումը միացված է (Գլխավոր)",
	securityTrackingMasterSwitch: "Հետևումը միացված է (Գլխավոր)",
	securityTrackingOffAlertBody:
		"Գործունեության հետևումը հստակ անջատված է սարքի մակարդակում՝ գերակայելով քաղաքականությունը։",
	securityTrackingOffAlertTitle: "Հետևման գերակայում՝ ԱՆՋԱՏՎԱԾ",
	securityTrackingWhenOffDesc:
		"Անջատված լինելիս՝ ծրագրերի, վեբի, ֆայլերի և մուտքի հետևումը կանջատվի",
	securityUnassigned: "Չնշանակված",
	securityUnknown: "Անհայտ",
	securityUnknownDevice: "Անհայտ սարք",
	securityUsePolicyDefault: "Օգտագործել լռելյայն քաղաքականությունը",
	securityUser: "Օգտվող",
	securityUserLoggedIn: "Օգտատերը մուտք է գործել",
	securityVideoOffAlertBody:
		"Տեսագրությունը հստակ անջատված է սարքի մակարդակում։ Ծանուցման ձայնագրությունները չեն կատարվի, նույնիսկ եթե քաղաքականությունը թույլ է տալիս։",
	securityVideoOffAlertTitle: "Տեսագրության գերակայում՝ ԱՆՋԱՏՎԱԾ",
	securityVideoOptionsBlank: "Տեսագրության ընտրանքներ (դատարկ = քաղաքականություն)",
	securityVideoPlayAllHint:
		"Նվագարկել բոլորը՝ ընտրված հատվածից մինչև ավելի հինները. Էջի վերջում բեռնվում է հաջորդը։",
	securityVideoRecording: "Տեսագրում",
	securityVideoSegments: "Տեսանյութի հատվածներ",
	securityVideoSegmentsCount: "Տեսանյութի հատվածներ",
	securityViewDetail: "Մանրամասն դիտում",
	securityWebDomainTracking: "Վեբ դոմենների հետևում",
	securityWebPollSeconds: "Վեբ պատմության հարցում (վրկ)",
	securityWebTracking: "Վեբ հետևում",
	securityWebsiteVisitsToday: "Կայքերի այցելություններ այսօր",
	securityWhen: "Երբ",
	selectAlbum: "Ընտրեք ալբոմ",
	selectAll: "Նշել բոլորը",
	selectArtist: "Ընտրեք կատարողին",
	selectBoard: "Ընտրեք տախտակը",
	selectCategory: "Ընտրեք կատեգորիան",
	selectChatPartner: "Ընտրեք զրուցակցին",
	selectClosedDate: "Ընտրեք փակման ամսաթիվը",
	selectDate: "Ընտրեք ամսաթիվը",
	selectDays: "Ընտրեք օրերը",
	selectDomain: "Ընտրել բնագավառը",
	selectEmployee: "Ընտրեք աշխատակցին",
	selectFiles: "Ընտրեք ֆայլերը",
	selectGroup: "Ընտրել խումբը",
	selectOpenedDate: "Ընտրեք ստեղծման ամսաթիվը",
	selectParentDepartment: "Ընտրեք գլխավոր բաժինը",
	selectParentUser: "Ընտրեք գլխավոր օգտատիրոջը",
	selectPeriod: "Ընտրել ժամանակահատված",
	selectPlatformToManageAndNavigate: "Ընտրեք հարթակը (պլատֆորմը)",
	selectPlaylist: "Ընտրեք երգացանկը",
	selectProduct: "Ընտրեք ապրանքը",
	selectSomething: "Ընտրեք որևէ բան",
	selectUsers: "Ընտրել օգտատերերին",
	selectedSteps: "Ընտրված քայլեր",
	selectedUsers: "Ընտրված օգտատերեր",
	seleteSelected: "Նշել ընտրվածները",
	send: "Ուղարկել",
	sent: "Ուղարկված է",
	seoDesc: "SEO Նկարագրություն",
	servicesAndPrices: "Ծառայություններ և գներ",
	setCostOfBuildingPermit: "Սահմանել շինարարության թույլտվության արժեքը",
	setDayOff: "Նշել հանգստյան օր",
	settings: "Կարգավորումներ",
	shiftSchedule: "Հերթափոխի ժամանակացույց",
	showAllSteps: "Ցուցադրել բոլոր քայլերը",
	showHistory: "Ցուցադրել պատմությունը",
	showProjectDetails: "Ցուցադրել նախագծի մանրամասները",
	showTableColumnFilters: "Ցուցադրել սյունակների ֆիլտրերը",
	showTimeline: "Ցուցադրել ժամանակացույցը",
	showing: "Ցուցադրվում է",
	shuffle: "Խառնել",
	shuffleEnabled: "Խառնելը միացված է",
	shuffleOverride: "Ծածկագրման կանոններ",
	shuffleOverrideDesc: "Ծածկագրման կանոններ",
	shuffleOverrideValue: "Ծածկագրման կանոններ",
	sickLeave: "Անաշխատունակության թերթիկ (Բյուլետեն)",
	sickLeaveDays: "Հիվանդության արձակուրդի օրեր",
	signIn: "Մուտք գործել",
	signUp: "Գրանցվել",
	size: "Չափ",
	slider: "Սլայդեր",
	small: "Փոքր",
	smb: "SMB սերվերի պանակ",
	socialAmount: "Սոցիալական վճարի գումար",
	socialCardImages: "Սոցիալական քարտի նկարներ",
	socialCart: "Սոցիալական քարտ",
	socialNetworkLink: "Սոցիալական ցանցի հղումը",
	socialRate: "Սոցիալական վճարի դրույք",
	software: "Ծրագրային ապահովում",
	softwareSkills: "Ծրագրային հմտություններ",
	somethingWentWrong: "Ինչ-որ բան սխալ գնաց",
	somethingWentWrongInCreatingSteps:
		"Ինչ-որ բան սխալ գնաց քայլերը ստեղծելիս։ Խնդրում ենք կրկին փորձել",
	sortBy: "Տեսակավորել ըստ",
	source: "Աղբյուր",
	sourceTypeEntity: "Տվյալների բազայից",
	sourceTypeManual: "Ձեռքով ստեղծված ցուցակ",
	special: "Հատուկ",
	specialItems: "Հատուկ ապրանքներ",
	speed: "Արագություն",
	starred: "Աստղանշված / Ֆավորիտ",
	starredMessages: "Նշված հաղորդագրություններ",
	start: "Սկսել",
	startCall: "Սկսել զանգ",
	startDate: "Մեկնարկի ամսաթիվ",
	startDateShort: "Մեկնարկ",
	startRecording: "Սկսել ձայնագրությունը",
	startTime: "Սկզբնաժամ",
	startVideoCall: "Սկսել տեսազանգ",
	starts: "Սկսվում է",
	state: "Մարզ / Կարգավիճակ",
	states: "Մարզեր / Պետություններ",
	status: "Կարգավիճակ (Status)",
	statusUpdate: "Կարգավիճակի թարմացում",
	stayAnonymous: "Մնալ անանուն",
	step: "Քայլ",
	stepIsNotStartedYet: "Քայլը դեռ սկսված չէ",
	stepStatus: "Քայլի կարգավիճակ",
	stepStatusChangedByUser: "Քայլի կարգավիճակը փոխվել է օգտատիրոջ կողմից",
	steps: "Քայլեր",
	stepsLeft: "Մնացած քայլերի քանակը",
	stillInOffice: "Դեռ գրասենյակում է",
	stockAndProductOverview: "Պահեստի և ապրանքների ակնարկ",
	stop: "Կանգնեցնել",
	stopRecording: "Կանգնեցնել ձայնագրությունը",
	stopped: "Կանգնեցված է",
	streamDJ: "Ռադիո DJ",
	streamStatistics: "Հոսքերի վիճակագրություն",
	streaming: "Հեռարձակում (Streaming)",
	streamsWithShuffle: "հոսքեր խառնելով",
	street: "Փողոց",
	subDesc: "Ենթանկարագրություն",
	submit: "Ուղարկել / Հաստատել",
	submittedProjects: "Ներկայացված նախագծեր",
	subscription: "Բաժանորդագրություն",
	subscriptions: "Բաժանորդագրություններ",
	substation: "Ենթակայան / Սնման կետ",
	substationNumber: "Ենթակայանի համարը",
	subtasks: "Ենթաառաջադրանքներ",
	subtasksPlaceholder: "Ավելացնել ենթաառաջադրանք...",
	subtitle: "Ենթավերնագիր",
	success: "Հաջողությամբ կատարվեց",
	suffix: "Սուֆիքս",
	sun: "Կիրակի",
	support: "Աջակցություն",
	supportText: "Բոլոր հարցերի համար գրեք մեզ",
	switch: "Անջատիչ (Switch)",
	switchers: "Փոխանցիչներ / Անջատիչներ",
	switches: "Անջատիչներ (Switches)",
	syncedFromGoogleContacts: "Համաժամացված Google Contacts-ից",
	systemSettings: "Համակարգի կարգավորումներ",
	table: "Աղյուսակ",
	tag: "Պիտակ (Tag)",
	tags: "Պիտակներ (Tags)",
	takeMeHome: "Գնալ գլխավոր էջ",
	taskCreatedSuccessfully: "Առաջադրանքը հաջողությամբ ստեղծվել է",
	taskCreatedSuccessfullyDescription: "Առաջադրանքը հաջողությամբ ստեղծվել է",
	taskDescription: "Առաջադրանքի նկարագրություն",
	taskMoved: "Առաջադրանքը տեղափոխվել է",
	taskMovedDescription: "Առաջադրանքը տեղափոխվել է նոր կատեգորիա",
	taskStatusDistribution: "Պահանջների կարգավիճակի բաշխում",
	taskTitle: "Առաջադրանքի վերնագիր",
	tasksAssigned: "Հանձնված առաջադրանքներ",
	taxCode: "Հարկային կոդ (ՀՎՀՀ)",
	taxNote: "Հարկային նշում",
	taxes: "Հարկեր",
	technicalFilesUrl: "Տեխնիկական ֆայլերի հղում (URL)",
	telegram: "Տելեգրամ",
	text: "Տեքստ",
	theConstructionDepPrice: "Շինարարական բաժնի արժեքը",
	theNumberOfAct: "Ակտի համարը / Նախահաշիվ",
	thePriceOfProject: "Նախագծի արժեքը",
	themePickerLabel: "Թեմա",
	thereIsNoResponsible: "Պատասխանատու անձ նշանակված չէ",
	thisMonth: "Այս ամիս",
	thu: "Հինգշաբթի",
	ticket: "Տոմս (Ticket)",
	ticketClosed: "Տոմսը փակված է",
	ticketCreateSaveDisabledHint:
		"Ընտրեք դոմենը, խնդրի խումբը (եթե կա), խնդիրը, ապա լրացրեք պարտադիր կապակցված դաշտերը պահպանելուց առաջ։",
	ticketDashboard: "Տոմսերի վահանակ",
	ticketDomain: "Բնագավառ / Դոմեն",
	ticketDomainsMenu: "Տոմսերի դոմեններ",
	ticketHierarchyAddProblem: "Ավելացնել խնդիր",
	ticketHierarchyAddProblemGroup: "Ավելացնել խնդիրների խումբ",
	ticketHierarchyAddRelatedList: "Ավելացնել կապակցված ցուցակ",
	ticketHierarchyAddTicket: "Ավելացնել տոմս",
	ticketHierarchyAddTicketDomain: "Ավելացնել բնագավառ",
	ticketHierarchyAddTicketHint: "Կբացվի նոր տոմսի ստեղծումը՝ այս բնագավառը ընտրված.",
	ticketHierarchyGroupsInDomain: "Այս բնագավառի խնդիրների խմբերը",
	ticketHierarchyNoneYet: "Դեռ չկան — ավելացրեք վերևի կոճակով։",
	ticketHierarchyProblemsInGroup: "Այս խմբի խնդիրները",
	ticketHierarchyProblemsLinkedToList: "Այս կապակցված ցուցակն օգտագործող խնդիրներ",
	ticketRelatedLists: "Կապակցված ցուցակներ",
	ticketRelatedListsMenu: "Կապակցված ցուցակների սահմանումներ",
	ticketSystemOverview: "Տոմսերի համակարգի արտադրողականության և մետրիկաների ակնարկ",
	ticketTitle: "Վերնագիր",
	ticketType: "Տեսակ",
	ticketTypeDomainsHint:
		"Թողնել դատարկ՝ այս տեսակը բոլոր դոմեններում հասանելի դարձնելու համար։ Ընտրեք մեկ կամ մի քանի դոմեններ՝ տեսակը միայն այնտեղ ցուցադրելու համար։",
	ticketTypeDomainsListAll: "Բոլոր դոմենները",
	ticketNoResponsibleUsers: "Պատասխանատու օգտատերեր չկան",
	ticketReminderLeadMinutes: "Հիշեցման ժամանակը (րոպե)",
	ticketReminderLeadMinutesPlaceholder: "Վերջնաժամկետից առաջ րոպեներ",
	deadlineTime: "Վերջնաժամկետի ժամ",
	remindBefore: "Հիշեցնել առաջ",
	ticketAutoClose: "Ինքնափակում",
	ticketAutoCloseAfter: "Ինքնափակում",
	ticketAutoCloseAfterHours: "Լուծված տոմսերը ինքնափակել նշված ժամերից հետո",
	ticketAutoCloseAfterHoursHint: "Նշեք 0՝ լուծված տոմսերի ավտոմատ փակումը անջատելու համար։",
	ticketSettingsLoadFailed: "Չհաջողվեց բեռնել տոմսերի կարգավորումները",
	ticketSettingsPageSubtitle: "Կառավարեք տոմսերի աշխատանքային հոսքի գլոբալ կարգավորումները։",
	ticketSettingsPageTitle: "Տոմսերի կարգավորումներ",
	ticketSettingsReadOnly:
		"Կարող եք դիտել այս կարգավորումը, բայց փոխել կարող են միայն տոմսերի ադմինները։",
	ticketSettingsSaveFailed: "Չհաջողվեց պահպանել տոմսերի կարգավորումները",
	ticketSettingsSaved: "Տոմսերի կարգավորումները պահպանվել են",
	ticketStatus_sent: "Ուղարկված",
	ticketStatus_in_process: "Ընթացքում",
	ticketStatus_resolved_rejected: "Մերժված",
	ticketStatus_resolved_approved: "Հաստատված",
	ticketStatus_moved_next: "Փոխանցված հաջորդին",
	ticketStatus_moved_prev: "Վերադարձված նախորդին",
	ticketStatus_closed: "Փակված",
	ticketStatus_not_accepted: "Չընդունված",
	ticketAction_start: "Սկսել գործընթացը",
	ticketAction_next: "Հաջորդ քայլ",
	ticketAction_prev: "Նախորդ քայլ",
	ticketAction_approve: "Հաստատել",
	ticketAction_reject: "Մերժել",
	ticketAction_close: "Փակել տոմսը",
	ticketAction_cancel: "Չեղարկել տոմսը",
	ticketAction_comment: "Մեկնաբանություն",
	cancelTicket: "Չեղարկել տոմսը",
	ticketCancelReason: "Չեղարկման պատճառ",
	ticketCancelComment: "Լրացուցիչ մեկնաբանություն",
	ticketCancelCommentPlaceholder: "Անհրաժեշտության դեպքում ավելացրեք մանրամասներ բացողի համար",
	ticketCancelWarning:
		"Տոմսը կնշվի որպես չընդունված և կփակվի։ Եթե օգտատերը դեռ օգնության կարիք ունի, պետք է բացի նոր տոմս։",
	ticketNotAccepted: "Տոմսը չի ընդունվել",
	ticketStepStatus_pending: "Սպասման",
	ticketStepStatus_active: "Ակտիվ",
	ticketStepStatus_completed: "Ավարտված",
	ticketStepStatus_approved: "Հաստատված",
	ticketStepStatus_rejected: "Մերժված",
	ticketStepStatus_closed: "Փակված",
	ticketStepStatus_cancelled: "Չեղարկված",
	ticketFieldVisibility: "Տոմսի դաշտերի տեսանելիություն",
	dateMode: "Ամսաթվի ռեժիմ",
	dateModesSingle: "Մեկ ամսաթիվ",
	dateModesInterval: "Ամսաթվի միջակայք",
	tickets: "Տոմսեր",
	ticketsByDepartment: "Տոմսեր ըստ բաժնի",
	ticketsByImportance: "Տոմսեր ըստ առաջնահերթության",
	ticketsByProblem: "Տոմսեր ըստ խնդրի տեսակի",
	ticketsByStatus: "Տոմսեր ըստ կարգավիճակի",
	ticketsOverTime: "Տոմսեր ժամանակի ընթացքում",
	timAgreement: "ՏԻՄ համաձայնեցում",
	timDelays: "ՏԻՄ ուշացումներ",
	timSentProjects: "ՏԻՄ ուղարկված նախագծեր",
	time: "Ժամ / Ժամանակ",
	timeBasedScheduling: "Ժամանակային ծածկագրում",
	timeOff: "Արձակուրդ / Հանգիստ",
	timeRange: "Ժամային միջակայք",
	timeToClose: "Տոմսը փակելու ժամանակը",
	timeToFirstResponse: "Առաջին պատասխանի ժամանակը",
	timeline: "Ժամանակացույց (Timeline)",
	timestamp: "Ժամանակի նշում (Timestamp)",
	timezone: "Ժամային գոտի",
	title: "Վերնագիր",
	to: "Մինչև",
	toChat: "Գնալ չատ",
	toDo: "Կատարելու առաջադրանքներ",
	today: "Այսօր",
	todaysSales: "Այսօրվա վաճառքներ",
	todo: "Առաջադրանքներ",
	todoBoard: "Տախտակ",
	todoBoards: "Տախտակներ",
	todoCategories: "Կատեգորիաներ",
	todoCategory: "Կատեգորիա",
	todoLabel: "Պիտակ",
	todoLabels: "Պիտակներ",
	todoTag: "Նիշ / Թեգ",
	todoTags: "Նիշեր / Թեգեր",
	todoTask: "Առաջադրանք",
	todoTasks: "Առաջադրանքներ",
	toggles: "Փոխանցիչներ (Toggles)",
	top: "Լավագույն",
	topCustomers: "Լավագույն հաճախորդներ",
	topProducts: "Լավագույն ապրանքներ",
	total: "Ընդամենը",
	totalActiveTasks: "Ընդհանուր ակտիվ առաջադրանքներ",
	totalArtists: "Ընդամենը արտիստներ",
	totalChats: "Ընդհանուր զրույցներ",
	totalClients: "Ընդամենը հաճախորդներ",
	totalCoins: "Ընդամենը մետաղադրամներ",
	totalContent: "Ընդամենը բովանդակություն",
	totalCustomers: "Ընդամենը հաճախորդներ",
	totalDeductions: "Ընդհանուր պահումներ",
	totalDuration: "Ընդհանուր տևողություն",
	totalGroups: "Ընդամենը խմբեր",
	totalHours: "Ընդհանուր ժամեր",
	missingDays: "Բացակայող օրեր",
	missingHours: "Բացակայող ժամեր",
	scheduled: "Ըստ գրաֆիկի",
	totalHoursWorked: "Ընդհանուր աշխատած ժամեր",
	totalInTrash: "Աղբամանում առկա ընդհանուր քանակ",
	totalMessages: "Ընդհանուր հաղորդագրություններ",
	totalOTHours: "Արտաժամյա ժամերի ընդհանուր քանակ (OT)",
	totalOrders: "Ընդամենը պատվերներ",
	totalOvertime: "Ընդհանուր լրացուցիչ/արտաժամյա ժամեր",
	totalPlaylists: "Ընդամենը նվագարկիչներ",
	totalPrice: "Ընդհանուր գինը",
	totalProducts: "Ընդամենը ապրանքներ",
	totalRevenue: "Ընդամենը եկամուտ",
	totalTickets: "Ընդամենը տոմսեր",
	totalTracks: "Ընդամենը երաժշտական գործեր",
	totalUses: "Ընդամենը օգտագործումներ",
	totalValue: "Ընդամենը արժեք",
	track: "Երգ / Թրեք",
	trackPlaylist: "Երգացանկ",
	tracks: "Երգեր / Թրեքեր",
	tracksByArtist: "Երաժշտական գործեր ըստ արտիստների",
	transportAllowance: "Տրանսպորտի նպաստ",
	trash: "Աղբաման",
	trashAutoDeleteWarning: "Աղբամանի ավտոմատ ջնջման վահանակ",
	trashEmptied: "Աղբամանը մաքրվել է",
	trashedOn: "Ջնջված է՝",
	tryAgain: "Փորձել նորից",
	tue: "Երեքշաբթի",
	type: "Տեսակ",
	uncoveredInterval: "Չծածկված միջակայք",
	undefined: " - ",
	undo: "Հետարկել (Undo)",
	university: "Համալսարան",
	universityDegree: "Բարձրագույն կրթություն / Գիտական աստիճան",
	universityDepartment: "Համալսարանի ֆակուլտետ",
	unjustifiedAbsence: "Անհարգելի բացակայություն",
	unknown: "Անհայտ",
	unknownArtist: "Անհայտ արտիստ",
	unnamed: "Անանուն",
	unnamedClient: "Անանուն հաճախորդ",
	unnamedTrack: "Անանուն երաժշտական գործ",
	unpaid: "Չվճարվող արձակուրդ",
	unreadMessages: "Չկարդացված հաղորդագրություններ",
	unresolvedMissingIntervals: "Անորոշ բացակայությունների միջակայքեր",
	upcomingBirthdays: "Առաջիկա ծննդյան օրեր",
	update: "Թարմացնել",
	updatedAt: "Թարմացված է՝",
	updates: "Թարմացումներ",
	upload: "Վերբեռնել",
	uploadDate: "Վերբեռնման ամսաթիվ",
	cancelUpload: "Չեղարկել վերբեռնումը",
	uploadCancelled: "Վերբեռնումը չեղարկված է",
	uploadCancelledMessage: "Վերբեռնումը կանգնեցվել է։",
	uploading: "Վերբեռնում...",
	uploads: "Վերբեռնումներ",
	uptime: "Անխափան աշխատանքի տևողություն (Uptime)",
	urgent: "Հրատապ",
	used: "Օգտագործված",
	usedCount: "Օգտագործված անգամների քանակ",
	usedVacation: "Օգտագործված արձակուրդ",
	user: "Օգտատեր",
	userArchive: "Օգտատերերի արխիվ",
	userDashboard: "Օգտատիրոջ վահանակ",
	userDeleted: "Ջնջված է",
	userEntered: "Օգտատերը մուտք գործեց",
	userProfile: "Օգտատիրոջ պրոֆիլ",
	userPageAccrued: "Հասանելի",
	userPageAvailableVacationDays: "Հասանելի արձակուրդային օրեր",
	userPageCurrentBalance: "Ընդհանուր հաշվեկշիռ",
	userPageDays: "օր",
	userPageNote: "Մեկնաբանություն",
	userPagePayroll: "Աշխատավարձ",
	userPayrollSubtitle: "Հաշվարկել հաշվարկային և վճարային աշխատավարձերը և գրանցել վճարումները:",
	userPayrollGross: "Հաշվարկային աշխատավարձ (Gross)",
	userPayrollNetPayable: "Վճարային աշխատավարձ (Net)",
	userPayrollAlreadyPaid: "Արդեն վճարված է",
	userPayrollRemaining: "Մնացորդ",
	userPayrollBasis: "Գրանցված աշխատավարձ",
	userPayrollFixedMonthly: "Ամսական ֆիքսված",
	userPayrollHourly: "Ժամավճարով",
	userPayrollPerTask: "Գործավարձային",
	userPayrollFixedSalary: "Ֆիքսված աշխատավարձ",
	userPayrollCalcUsesAttendance:
		"Այս հաշվիչն օգտագործում է {monthKey} թվականների հաճախումների և արձակուրդների ամփոփ տվյալները, այնուհետև կիրառում է գործող կանոնները մարդկային ռեսուրսների (HR) կարգավորումներից։",
	userPayrollAttendanceLeaveImpact: "Հաճախումների և արձակուրդի ազդեցություն",
	userPayrollWorkedTime: "Աշխատած ժամերի քանակ",
	userPayrollOvertime: "Հավելյալ/արտաժամյա աշխատաժամեր",
	userPayrollLeaveCoveredTime: "Հարգելի բացակայությունների լրացված ժամեր",
	userPayrollVacationAccrued: "Առաջացած արձակուրդային օրեր",
	userPayrollVacationBalance: "Արձակուրդային օրերի մնացորդ",
	userPayrollMissingUncovered: "Բացակայություններ",
	userPayrollTaxBreakdown: "Հարկերի մանրամասներ",
	userPayrollTax: "Հարկ",
	userPayrollRate: "Դրույք",
	userPayrollAmount: "Գումար",
	userPayrollNoTaxLines: "Այս ժամանակահատվածի համար հարկային տողեր չեն ձևավորվել։",
	userPayrollRecordPayment: "Գրանցել աշխատավարձի վճարում",
	userPayrollRemainingBadge: "Մնացորդ՝ {amount}",
	userPayrollCalculateFirst: "Նախ հաշվարկեք աշխատավարձը",
	userPayrollTotalPaid: "Ընդամենը վճարված",
	userPayrollCashAmount: "Կանխիկ գումար",
	userPayrollTransferAmount: "Փոխանցման գումար",
	userPayrollSavePaymentEvent: "Պահպանել վճարման իրադարձությունը",
	userPayrollPaymentHistory: "Վճարումների պատմություն",
	userPayrollDate: "Ամսաթիվ",
	userPayrollPaid: "Վճարված է",
	userPayrollCash: "Կանխիկ",
	userPayrollTransfer: "Փոխանցում",
	userPayrollBy: "Կատարող",
	userPayrollNoPaymentEvents:
		"Այս ժամանակահատվածի համար աշխատավարձի վճարման իրադարձություններ դեռ չեն գրանցվել։",
	userPayrollAuditLog: "Աշխատավարձի աուդիտի մատյան",
	userPayrollAllHistory: "Աշխատավարձի ամբողջական պատմություն",
	userPayrollGrossShort: "Հաշվարկային",
	userPayrollNetShort: "Վճարային",
	userPayrollPaidShort: "Վճարված",
	userPayrollStatus: "Կարգավիճակ",
	userPayrollActions: "Գործողություններ",
	userPayrollNoRecords: "Այս աշխատակցի համար աշխատավարձի գրառումներ չեն գտնվել։",
	userPayrollCalculatedTitle: "Աշխատավարձը հաշվարկվել է",
	userPayrollCalculatedMessage:
		"Աշխատավարձի պատկերը թարմացվել է հաճախումներից, արձակուրդից և հարկային կարգավորումներից։",
	userPayrollCalcFailedTitle: "Աշխատավարձի հաշվարկը ձախողվեց",
	userPayrollPaymentRecordedTitle: "Վճարումը գրանցվել է",
	userPayrollPaymentRecordedMessage:
		"Աշխատավարձի վճարման իրադարձությունը պահպանվել է և արտացոլվել է ֆինանսական հաշվետվությունում։",
	userPayrollPaymentFailedTitle: "Վճարումը ձախողվեց",
	userPayrollSelectMonth: "Ընտրել ամիսը",
	userPageSecurity: "Անվտանգություն",
	userPageSetRemainingVacationDays: "Լրացնել հասանելի արձակուրդային օրերը այս աշխատակցի համար",
	userPageUsed: "Օգտագործված",
	userUpdated: "Թարմացվել է",
	userVisited: "Օգտատերը այցելեց",
	username: "Օգտանուն",
	users: "Անձնակազմ / Օգտատերեր",
	vacationBalance: "Արձակուրդի մնացորդ",
	vacationDaysForPeriod: "Արձակուրդի օրերի քանակը ժամանակաշրջանի համար",
	vacationInterval: "Արձակուրդի միջակայք",
	vacationPay: "Արձակուրդային վճար",
	value: "Արժեք",
	version: "Տարբերակ",
	viber: "Վայբեր",
	video: "Տեսանյութ",
	view: "Դիտել",
	viewAll: "Դիտել բոլորը",
	viewDetails: "Տեսնել մանրամասները",
	viewMore: "Տեսնել ավելին",
	viewProject: "Դիտել նախագիծը",
	viewSteps: "Դիտել քայլերը",
	viewTrash: "Դիտել աղբամանը",
	village: "Գյուղ",
	villages: "Վայրերի ցանկ (Գյուղեր)",
	visitation: "Այցելություն / Տեղազննում",
	visitationDeadline: "Տեղազննման վերջնաժամկետ",
	visitationDelays: "Տեղազննման ուշացումներ",
	voltage: "Լարում",
	voltageLevel: "Լարման մակարդակ",
	volumes: "Ծավալներ",
	voluntaryPensionAmount: "Կամավոր թոշակի գումար",
	voluntaryPensionRate: "Կամավոր թոշակի դրույք (%)",
	vsPreviousPeriod: "նախորդ ժամանակաշրջանի համեմատ",
	warning: "Զգուշացում",
	warrantyDesc: "Երաշխիքի նկարագրություն",
	warrantyEnd: "Երաշխիքի ավարտ",
	warrantyProvider: "Երաշխիքի մատակարար",
	warrantyStart: "Երաշխիքի սկիզբ",
	watchers: "Դիտորդներ / Հետևորդներ",
	weatherAriaYerevanForecast: "Երևանի եղանակի կանխատեսում",
	weatherCityYerevan: "Երևան",
	weatherClear: "Պարզ / Ամպազերծ",
	weatherCloudy: "Ամպամած",
	weatherDrizzle: "Մաղող անձրև",
	weatherFog: "Մառախուղ",
	weatherForecastUnavailable: "Կանխատեսումը հասանելի չէ",
	weatherHeadingYerevan: "Եղանակը Երևանում",
	weatherHumidity: "Խոնավություն",
	weatherLoadingShort: "Եղանակ",
	weatherNextHours: "Հաջորդ ժամերին",
	weatherPartlyCloudy: "Փոփոխական ամպամած",
	weatherPrecipUnit: "մմ",
	weatherRain: "Անձրև",
	weatherSnow: "Ձյուն",
	weatherTempUnit: "°C",
	weatherThunderstorm: "Ամպրոպ",
	weatherUnknown: "Եղանակի կանխատեսում",
	weatherWind: "Քամի",
	weatherWindUnit: "կմ/ժ",
	wed: "Չորեքշաբթի",
	weekly: "Շաբաթական",
	whatToDo: "Ինչ անել",
	whatToDoLink: "Ինչ անելու հղում",
	whatsapp: "WhatsApp",
	withAttachments: "Կցված ֆայլերով",
	withCoins: "Մետաղադրամներով",
	withFavorites: "Նախընտրածներով",
	workDays: "Աշխատանքային օրեր",
	workInformation: "Աշխատանքային տեղեկատվություն",
	workTime: "Աշխատանքային ժամանակ",
	workedDays: "Աշխատած օրեր",
	workedHours: "Աշխատած ժամեր",
	working: "Աշխատում է",
	workingDays: "Աշխատանքային օրեր",
	workingHoursByDay: "Աշխատանքային ժամեր ըստ օրվա",
	workingMinutes: "Աշխատանքային րոպեներ",
	workingState: "Աշխատանքային վիճակ",
	workingStatus: "Աշխատակցի կարգավիճակ",
	write: "Գրել",
	writeUsIfThereAreAnyQuestions: "Գրեք մեզ, եթե հարցեր ունեք",
	writingContent: "Գրության բովանդակություն",
	writingNumber: "Գրության համար",
	yes: "Այո",
	yesNextStep: "Այո, անցնել հաջորդ քայլին",
	yesPreviousStep: "Այո, վերադառնալ նախորդ քայլին",
	youCannotRevertThisAction: "Դուք չեք կարող հետարկել այս գործողությունը հետագայում:",
	youWontBeAbleToRevert: "Դուք չեք կարողանա վերականգնել սա:",
	yourFileHasBeenDeleted: "Ձեր ֆայլը ջնջվել է",
	yourFileHasBeenNotSaved: "Ձեր ֆայլը չի պահպանվել",
	yourFileHasBeenSaved: "Ձեր ֆայլը պահպանված է",
	zipCode: "Փոստային ինդեքս",
	zipCodes: "Փոստային ինդեքսներ",
	vacationIntervalNoDeduction: "Արձակուրդը չի նվազեցվում ոչ աշխատանքային օրերին",
	knowledgeDashboardLoadFailed: "Չհաջողվեց բեռնել վահանակը",
	knowledgeArticlesLoadFailed: "Չհաջողվեց բեռնել հոդվածները",
	knowledgeBase: "Գիտելիքների բազա",
	knowledgeCreate: "Ստեղծել",
	knowledgeRunAutoDocs: "Գործարկել ավտոփաստաթղթերը",
	knowledgeTotalArticles: "Ընդամենը հոդվածներ",
	knowledgePublished: "Հրապարակված",
	knowledgeDrafts: "Սևագրեր",
	knowledgeAutoGenerated: "Ինքնաստեղծ",
	knowledgeLatestUpdatedArticles: "Վերջին թարմացված հոդվածները",
	knowledgeArticles: "Հոդվածներ",
	knowledgeNewArticle: "Նոր հոդված",
	knowledgeFilterArticles: "Զտել հոդվածները",
	knowledgeCategories: "Կատեգորիաներ",
	knowledgeParentCategory: "Ծնող կատեգորիա",
	knowledgeIcon: "Պատկերակ",
	knowledgeColor: "Գույն",
	knowledgeSortOrder: "Դասավորման կարգ",
	knowledgeCategorySaved: "Կատեգորիան պահպանվեց",
	knowledgeCategoryDeleted: "Կատեգորիան ջնջվեց",
	knowledgeSearch: "Որոնում",
	knowledgeSearchArticles: "Որոնել հոդվածներ",
	knowledgePath: "Ուղի",
	knowledgeAutoGeneratedDocs: "Ինքնաստեղծ փաստաթղթեր",
	knowledgeSingleRoute: "Մեկ երթուղի",
	knowledgeNoScreenshots: "Առանց սքրինշոթերի",
	knowledgeGenerateDocumentation: "Ստեղծել փաստաթղթավորում",
	knowledgeImportGeneratedDocs: "Ներմուծել ստեղծված փաստաթղթերը",
	knowledgeDocumentationGenerationStarted: "Փաստաթղթավորման ստեղծումը սկսվեց",
	knowledgeImported: "Ներմուծված է",
	knowledgeGeneratedDocsImported: "Ներմուծվել է {count} ստեղծված փաստաթուղթ",
	knowledgeStarted: "Սկսված",
	knowledgeFinished: "Ավարտված",
	knowledgeRun: "Գործարկում",
	knowledgeOutput: "Արդյունք",
	knowledgeStatus_draft: "Սևագիր",
	knowledgeStatus_published: "Հրապարակված",
	knowledgeStatus_archived: "Արխիվացված",
	knowledgeVisibility_public: "Հանրային",
	knowledgeVisibility_private: "Մասնավոր",
	knowledgeVisibility_company: "Ընկերություն",
	knowledgeRunStatus_idle: "Սպասում",
	knowledgeRunStatus_running: "Ընթացքի մեջ",
	knowledgeRunStatus_completed: "Ավարտված",
	knowledgeRunStatus_failed: "Ձախողված",
	meetings: "Հանդիպումներ",
	meetingsListSubtitle: "Պլանավորված սենյակներ՝ APIT չատով և օրացույցով։",
	meetingsCreateMeeting: "Ստեղծել հանդիպում",
	meetingsEditMeeting: "Խմբագրել հանդիպումը",
	meetingsCreateSubtitle: "Հանդիպում = օրացույցի իրադարձություն + չատի խումբ + վիդեո սենյակ։",
	meetingsMeetingType: "Հանդիպման տեսակ",
	meetingsDate: "Ամսաթիվ",
	meetingsStartTime: "Սկսման ժամ",
	meetingsEndTime: "Ավարտի ժամ",
	meetingsTimezone: "Ժամային գոտի",
	meetingsVisibility: "Տեսանելիություն",
	meetingsParticipants: "Մասնակիցներ",
	meetingsGroupsDepartments: "Խմբեր/բաժիններ",
	meetingsOptionalGroupIds: "Խմբերի ոչ պարտադիր ID-ներ",
	meetingsLocation: "Վայր",
	meetingsReminderTime: "Հիշեցման ժամանակ",
	meetingsMinutesShort: "րոպ",
	meetingsAgenda: "Օրակարգ",
	meetingsAgendaPlaceholder: "Մեկնարկ\nԴիզայնի դիտարկում\nՀաջորդ քայլեր",
	meetingsRecordingEnabled: "Ձայնագրումը միացված է",
	meetingsAllowJoinBeforeHost: "Թույլ տալ միանալ մինչ հոսթի գալը",
	meetingsMuteUsersOnEntry: "Մուտք գործելիս անջատել խոսափողը",
	meetingsAllowScreenSharing: "Թույլ տալ էկրանի կիսում",
	meetingsSaveAsDraft: "Պահպանել որպես սևագիր",
	meetingsSaveMeeting: "Պահպանել հանդիպումը",
	meetingsCreateAndNotifyUsers: "Ստեղծել և ծանուցել օգտատերերին",
	meetingsSaved: "Հանդիպումը պահպանվեց",
	meetingsSaveFailed: "Չհաջողվեց պահպանել հանդիպումը",
	meetingsJoin: "Միանալ",
	meetingsOpenChat: "Բացել չաթը",
	meetingsParticipantsCount: "{count} մասնակից",
	meetingsType_video: "Վիդեո",
	meetingsType_audio: "Աուդիո",
	meetingsType_in_person: "Առկա",
	meetingsType_hybrid: "Հիբրիդ",
	meetingsVisibility_private: "Մասնավոր",
	meetingsVisibility_company: "Ընկերություն",
	meetingsVisibility_department: "Բաժին",
	meetingsStatus_draft: "Սևագիր",
	meetingsStatus_scheduled: "Պլանավորված",
	meetingsStatus_live: "Ուղիղ միացում",
	meetingsStatus_ended: "Ավարտված",
	meetingsStatus_cancelled: "Չեղարկված",
	aiSettingsAction: "Գործողություն",
	aiSettingsAllowedModules: "Թույլատրված մոդուլներ",
	aiSettingsApprove: "Հաստատել",
	aiSettingsApprovalFailed: "Հաստատումը ձախողվեց",
	aiSettingsDisabled: "Անջատված",
	aiSettingsEnabled: "Միացված",
	aiSettingsEvent: "Իրադարձություն",
	aiSettingsLogs: "Մատյաններ",
	aiSettingsLoadFailed: "Չհաջողվեց բեռնել AI կարգավորումները",
	aiSettingsNoGateway: "Դարպասը կազմաձևված չէ",
	aiSettingsNoPendingApprovals: "Չունի սպասող հաստատումներ",
	aiSettingsNoLogs: "Մատյաններ չկան",
	aiSettingsNoPermission: "Բացակայում է AI ադմինի թույլտվությունը:",
	aiSettingsPendingApprovals: "Սպասող հաստատումներ",
	aiSettingsReject: "Մերժել",
	aiSettingsRejectFailed: "Մերժումը ձախողվեց",
	aiSettingsRefresh: "Թարմացնել",
	aiSettingsRequireApproval: "Պահանջել հաստատում",
	aiSettingsStatus: "Վիճակ / Կարգավիճակ",
	aiSettingsTime: "Ժամանակ",
	aiSettingsTitle: "AI Կարգավորումներ",
	aiSettingsTool: "Գործիք",
	aiSettingsUser: "Օգտագործող",
	aiSettingsUpdateFailed: "Կարգավորների թարմացումը ձախողվեց",
	aiSettingsDefaultMode: "Լռելյայն ռեժիմ",
	aiSettingsReadOnly: "Միայն ընթերցանելի",
	aiSettingsApprovalRequired: "Պահանջվում է հաստատում",
	aiSettingsAdminOnly: "Միայն ադմինիստրատորի համար",
	financeActiveCurrencies: "{count} ակտիվ արժույթներ",
	financeAddCurrency: "Ավելացնել արժույթ",
	financeCurrencyCode: "Կոդ",
	financeCurrencyCoefficient: "Գործակից",
	financeCurrencyDefault: "Լռելյայն",
	financeCurrencyName: "Անուն",
	financeCurrencySymbol: "Խորհրդանիշ",
	financeCurrencyUse: "Օգտագործել",
	financeLoadFailed: "Չհաջողվեց բեռնել ֆինանսական կարգավորումները",
	financeSaveSettings: "Պահպանել կարգավորումները",
	financeSavedMessage: "Ֆինանսական կարգավորումները պահպանված են",
	financeSaveFailed: "Չհաջողվեց պահպանել ֆինանսական կարգավորումները",
	financeSelectedDefault: "Ընտրված լռելյայն՝",
	financeSettingsSubtitle:
		"Այստեղ արժույթները վերահսկում են լռելյայն գումարի ցուցադրումը ֆինանսական և պատվերների էջերում:",
	financeSettingsTitle: "Ֆինանսական կարգավորումներ",
	hrAccrualCoeffPreview: "Գործակցի նախադիտում",
	hrAccrualCoeffPreviewLine1:
		"{accrualWorkedHours} աշխատած ժամեր → {accrualVacationHours} արձակուրդային ժամեր",
	hrAccrualCoeffPreviewLine2:
		"Արձակուրդային ժամեր, որոնք ստացվում են մեկ աշխատած ժամի համար՝ {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"Համակարգը պահում է այս կուտակումը րոպեներով, որպեսզի payroll-ը և ժամանակավճարի մնացորդները կարողանան օգտագործել մասնակի օրերի արժեքներ՝ առանց կլորացման շեղման:",
	hrAccrualFixedYearly: "Հաստատուն տարեկան արձակուրդային օրեր",
	hrAccrualFixedYearlyDesc:
		"Կուտակել կազմաձևված թվով արձակուրդային օրեր տարվա ընթացքում՝ օգտագործելով գոյություն ունեցող օրական կամ ամսական ժամանակացույց:",
	hrAccrualModelChoice:
		"Ընտրել մեկ ակտիվ կուտակման մոդել: Տարեկան օրերը և աշխատած ժամերի գործակիցը OR տրամաբանություն են, ոչ թե միասին:",
	hrAccrualSuffixMin: "րոպե",
	hrAccrualVacationMinutesEarned: "Ստացված արձակուրդային րոպեներ",
	hrAccrualVacationMinutesEarnedDesc:
		"Քանի՞ արձակուրդային րոպե է կուտակվում աշխատած ժամանակային միավորի համար:",
	hrAccrualWorkBreak: "Աշխատանքային ընդմիջում",
	hrAccrualWorkBreakDesc: "Օրական չծածկված րոպեներ, որոնք դասակարգվում են որպես ընդմիջումներ:",
	hrAccrualWorkedHoursModel: "Աշխատած ժամեր արձակուրդային ժամերի դիմաց",
	hrAccrualWorkedHoursModelDesc:
		"Կուտակել արձակուրդ իրական աշխատած ժամանակից՝ օգտագործելով կազմաձևելի աշխատած ժամերի գործակիցը:",
	hrAccrualWorkedMinutesUnit: "Աշխատած րոպեների միավոր",
	hrAccrualWorkedMinutesUnitDesc:
		"Քանի՞ աշխատած րոպե է անհրաժեշտ կուտակման միավոր ստեղծելու համար:",
	hrWeekdayFri: "Ուրբ",
	hrWeekdayMon: "Երկ",
	hrWeekdaySat: "Շաբ",
	hrWeekdaySun: "Կիր",
	hrWeekdayThu: "Հնգ",
	hrWeekdayTue: "Երեք",
	hrWeekdayWed: "Չոր",
	knowledgeSettingsAiEnabled: "AI միացված է",
	knowledgeSettingsAiModel: "AI մոդել",
	knowledgeSettingsAiProvider: "AI մատակարար",
	knowledgeSettingsEnableAutoDocs: "Միացնել ավտոփաստաթղթերը",
	knowledgeSettingsLanguage: "Լռելյայն լեզու",
	knowledgeSettingsMaxSizeMb: "Հոդվածի առավելագույն չափ (MB)",
	knowledgeSettingsRootCategory: "Ավտոփաստաթղթերի արմատային կատեգորիա",
	knowledgeSettingsSaveSettings: "Պահպանել կարգավորումները",
	knowledgeSettingsSaved: "Գիտելիքների բազայի կարգավորումները թարմացվել են",
	knowledgeSettingsTitle: "Կարգավորումներ",
	knowledgeSettingsUploadExt: "Թույլատրված վերբեռնման ընդլայնումներ",
	knowledgeSettingsVisibility: "Լռելյայն տեսանելիություն",
	nvrAddFromList: "Ավելացնել տեսախցիկներ ցանկից",
	nvrCamerasList: "Տեսախցիկների ցանկ",
	nvrChannel: "Ալիք",
	nvrChannelId: "ID",
	nvrChannelName: "Անուն",
	nvrChannelsTitle: "Այս NVR-ից գրանցված ալիքներ",
	nvrConnectionDesc:
		"Մուտքագրեք IP, պորտ և ուղու ձևանմուշ (միայն /.../{channel}... — ինչպես VLC-ում, առանց rtsp:// մասի): Ավելացրեք RTSP օգտանուն և գաղտնաբառ (որն անհրաժեշտ է NVR-ների մեծ մասի համար): Կտտացրեք Պահպանել՝ ինքնաբերական ցանցային սկանավորում գործարկելու համար, կամ օգտագործեք «Ավելացնել տեսախցիկներ ուղիներից» բաժինը՝ առանց ալիքները գրանցելու սկանավորելու համար։",
	nvrConnectionTitle: "NVR — մեկ միացում բոլոր ալիքների համար",
	nvrDiscoveryFailed: "Հայտնաբերումը ձախողվեց",
	nvrEnterPaths: "Մուտքագրեք առնվազն մեկ ալիք կամ ուղի:",
	nvrFoundChannels: "Գտնվել է {n} ալիք(ներ):",
	nvrFullUrl: "Ամբողջական URL (ալիք 101 — ավտոմատ ձևավորված վերևի դաշտերից)",
	nvrInitError: "NVR-ն չի կարող ինիցիալացվել: Վերաթարմացրեք էջը:",
	nvrIp: "NVR IP հասցե",
	nvrIpPasswordRequired:
		"NVR IP և գաղտնաբառը պարտադիր են: Մուտքագրեք գաղտնաբառը, պահպանեք, և մենք կսկանավորենք ալիքները հաջորդ պահպանման ժամանակ:",
	nvrLoadFailed: "Չհաջողվեց բեռնել NVR-ը",
	nvrLiveStatus: "Ուղիղ միացման կարգավիճակ",
	nvrManualDesc:
		"Երբ ինքնաբերական սկանավորումը ձախողվում է (օր.՝ API-ն չի կարողանում հասնել NVR-ին), թվարկեք ալիքներն այստեղ (մեկ տողում մեկ ալիք): Մուտքագրեք ալիքի համարները (օր.՝ 101, 201), ուղին (օր.՝ /Streaming/Channels/102) կամ ամբողջական rtsp:// URL-ը: Պահպանեք NVR-ը նախքան IP-ն կամ ձևանմուշը փոխելը։",
	nvrManualTitle: "Ավելացնել տեսախցիկներ RTSP ուղիներից (առանց սկանավորման)",
	nvrNotReady: "NVR-ը պատրաստ չէ: Վերաթարմացրեք էջը:",
	nvrNotReadyShort: "NVR-ը պատրաստ չէ:",
	nvrNotWorking: "Չի գործում",
	nvrOfficeMap: "Գրասենյակի քարտեզ",
	nvrOffline: "Անցանց",
	nvrOnline: "Միացված է",
	nvrPasswordChangeNote: "Փոխեք և պահպանեք՝ գաղտնաբառը թարմացնելու համար:",
	nvrPasswordLeaveBlank: "Թողեք դատարկ՝ ընթացիկ գաղտնաբառը պահպանելու համար",
	nvrPasswordRequired:
		"Պահանջվում է NVR-ների մեծ մասի համար՝ ալիքները և հոսքերը հայտնաբերելու նպատակով:",
	nvrPasswordStoredLeaveBlank:
		"Գաղտնաբառը պահպանված է. թողեք դատարկ այն պահելու համար, կամ մուտքագրեք նորը:",
	nvrRegisterFailed: "Չհաջողվեց գրանցել ուղիները",
	nvrRegisteredCameras: "Գրանցված է {n} տեսախցիկ(ներ):",
	nvrRtspPassword: "RTSP գաղտնաբառ",
	nvrRtspPathTemplate: "RTSP ուղու ձևանմուշ (Template)",
	nvrRtspPathTemplateHint:
		"Մուտքագրեք միայն ուղին {channel}-ով։ Այստեղ մի մուտքագրեք ամբողջ rtsp:// տողը:",
	nvrRtspUsername: "RTSP օգտանուն",
	nvrScanChannels: "Կրկին սկանավորել ալիքները",
	nvrScanHint: "Սա կպահպանի ընթացիկ միացման դաշտերը, ապա կսկսի սկանավորումը:",
	nvrWorkingState: "Գործառնական վիճակ",
	nvrWorking: "Գործում է",
	nvrGridEmpty: "Այս NVR-ին դեռ ոչ մի ալիք կցված չէ: Կատարեք հայտնաբերում NVR էջում:",
	nvrGridLoadFailed: "Չհաջողվեց բեռնել ալիքները",
	nvrGridLoading: "Ալիքների բեռնում…",
	nvrGridStreamFailed: "Չհաջողվեց սկսել հոսքը",
	nvrGridStreamStopped: "Հոսքը դադարեցվեց",
	nvrGridTitle: "Բոլոր NVR ալիքները",
	securityRecordingActiveDays: "Ակտիվ օրեր",
	securityRecordingDesc:
		"Թույլատրել սերվերային ձայնագրում այն տեսախցիկների համար, որոնցում միացված է ձայնագրման ֆունկցիան: Յուրաքանչյուր տեսախցիկ կարող է ունենալ նաև իր անհատական ժամանակացույցը ստորև:",
	securityRecordingEndTime: "Ավարտի ժամանակ",
	securityRecordingGlobalEnable: "Միացնել ձայնագրումը համընդհանուր",
	securityRecordingGlobalEnableDesc:
		"Գլխավոր վերահսկիչ — սրա անջատումը կանգնեցնում է բոլոր ձայնագրությունները՝ անկախ առանձին տեսախցիկների կարգավորումներից:",
	securityRecordingLoadFailed: "Չհաջողվեց բեռնել անվտանգության կարգավորումները",
	securityRecordingLocalFs: "Տեղական ֆայլային համակարգ",
	securityRecordingLocalPathNote:
		"Տեղական ուղին կազմաձևված է սերվերի SECURITY_RECORDING_LOCAL_PATH միջավայրի փոփոխականի միջոցով:",
	securityRecordingNoScheduleNote:
		"Ժամանակացույց սահմանված չէ — տեսախցիկները կձայնագրեն 24/7 ռեժիմով, եթե ձայնագրման ֆունկցիան միացված է:",
	securityRecordingRetentionDays: "Պահպանում (օրեր)",
	securityRecordingRetentionDesc: "Նշված օրերից հին հատվածները կջնջվեն ինքնաբերաբար:",
	securityRecordingS3: "S3 / Համատեղելի առարկայական պահոց",
	securityRecordingS3Note:
		"S3-ը կազմաձևված է սերվերի միջավայրի փոփոխականների միջոցով (AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY և այլն):",
	securityRecordingSaveSettings: "Պահպանել կարգավորումները",
	securityRecordingSaved: "Անվտանգության կարգավորումները պահպանված են:",
	securityRecordingSaveFailed: "Չհաջողվեց պահպանել կարգավորումները",
	securityRecordingScheduleDesc:
		"Այս ժամանակացույցը կիրառվում է բոլոր այն տեսախցիկների վրա, որոնք չունեն անհատական սահմանված ժամանակացույց:",
	securityRecordingScheduleEnable:
		"Միացնել լռելյայն ժամանակացույցը (ձայնագրել միայն սահմանված ժամերին)",
	securityRecordingScheduleNote:
		"Ձայնագրումը կգործի ընտրված օրերին՝ այս ժամերի միջակայքում: Դրանից դուրս ձայնագրումը կդադարեցվի ինքնաբերաբար:",
	securityRecordingScheduleTitle: "Լռելյայն ձայնագրման ժամանակացուցակ",
	securityRecordingSegmentLength: "Հատվածի երկարություն (րոպե)",
	securityRecordingSegmentLengthDesc:
		"Այս արժեքը վերահսկում է, թե որքան հաճախ է նոր տեսանյութ հայտնվում յուրաքանչյուր տեսախցիկի էջում:",
	securityRecordingStartTime: "Սկզբի ժամանակ",
	securityRecordingStorage: "Պահոց",
	securityRecordingStorageBackend: "Պահոցի տեսակը (Backend)",
	securityRecordingTitle: "Տեսախցիկների ձայնագրում սերվերում",
	securitySurveillanceCameraMedia: "Տեսախցիկի մեդիա",
	securitySurveillanceDashboard: "Հսկողության վահանակ",
	securitySurveillanceNoCameras: "Տեսախցիկներ չեն գտնվել:",
	securitySurveillanceOffline: "Անցանց",
	securitySurveillanceOnline: "Միացված է",
	teamWorkload: "Թիմի ծանրաբեռնվածություն",
	workloadTasks: "Առաջադրանքներ",
	workloadTickets: "Տոմսեր",
	workloadSteps: "Քայլեր",
	assignedEmployee: "Կցված աշխատակից",
	boughtDate: "Գնման ամսաթիվ",
	broken: "Խափանված",
	depreciation: "Մաշվածություն",
	deviceStatus: "Սարքի կարգավիճակ",
	handoverDocument: "Հանձնման փաստաթուղթ",
	maintenanceSchedule: "Սպասարկման ժամանակացույց",
	qrCode: "QR կոդ",
	repair: "Վերանորոգում",
	repairHistory: "Վերանորոգման պատմություն",
	replacementDate: "Փոխարինման ամսաթիվ",
	retired: "Դուրս գրված",
	returnDocument: "Վերադարձի փաստաթուղթ",
	warrantyDate: "Երաշխիքի ամսաթիվ",
	noOpenWorkload: "Բաց ծանրաբեռնվածություն չկա",
	attendanceTable: "Հաճախելիության աղյուսակ",
	filteredFrom: "զտված է ընդհանուր",
	weekend: "Հանգստյան օր",
	attendanceNextRefresh: "Հաջորդ թարմացումը",
	refreshAttendanceDevices: "Թարմացնել տվյալները հաճախելիության սարքերից",
	attendanceSyncSuccess: "Հաճախելիության սարքերը համաժամացվեցին",
	attendanceSyncFailed: "Հաճախելիության սարքերի համաժամացումը ձախողվեց",
	// User account security / profile
	contactInformation: "Կոնտակտային տեղեկություն",
	accountSecurity: "Հաշվի անվտանգություն",
	accountStatus: "Հաշվի կարգավիճակ",
	accountStatusActive: "Ակտիվ",
	accountStatusLocked: "Կողպված",
	mustChangePassword: "Պետք է փոխել գաղտնաբառը",
	lockedAt: "Կողպված է",
	passwordLastChanged: "Գաղտնաբառը վերջին անգամ փոխվել է",
	accountSecurityDesc: "Ընթացիկ գաղտնաբառերը երբեք չեն երևում։ Օգտագործեք ժամանակավոր գաղտնաբառ կամ անվտանգ վերակայման հղում, երբ անհրաժեշտ է փոխել մուտքի տվյալները։",
	accountSecurityHint: "Օգտագործեք «Վերակայել գաղտնաբառը», երբ անհրաժեշտ է անմիջապես փոխել մուտքի տվյալները։ Օգտագործեք «Ուղարկել վերակայման հղում», երբ օգտատերը պետք է ինքը ընտրի նոր գաղտնաբառ՝ առանց ադմինիստրատորին գաղտնիք ցույց տալու։",
	lockAccount: "Կողպել հաշիվը",
	unlockAccount: "Ապակողպել հաշիվը",
	forcePasswordChangeAction: "Պարտադիր փոխել գաղտնաբառը",
	clearForcedPasswordChange: "Հանել պարտադիր գաղտնաբառի փոփոխությունը",
	resetPassword: "Վերակայել գաղտնաբառը",
	sendResetLink: "Ուղարկել վերակայման հղում",
	sessionVisibilityRequiresPermission: "Նիստերի և սարքերի տեսանելիության համար անհրաժեշտ է լրացուցիչ թույլտվություն։",
	resetPasswordConfirmTitle: "Վերակայե՞լ այս գաղտնաբառը։",
	resetPasswordConfirmText: "Կստեղծվի ժամանակավոր գաղտնաբառ, և օգտատերը պետք է փոխի այն հաջորդ մուտքի ժամանակ։",
	temporaryPasswordGenerated: "Ժամանակավոր գաղտնաբառը ստեղծված է",
	temporaryPasswordShareHint: "Կիսվեք սրանով միայն անվտանգ ալիքով։",
	sendResetLinkConfirmTitle: "Ուղարկե՞լ գաղտնաբառի վերակայման հղում։",
	sendResetLinkConfirmText: "Օգտատիրոջը կուղարկվի մեկանգամյա անվտանգ վերակայման հղում։",
	passwordResetLinkSent: "Գաղտնաբառի վերակայման հղումը ուղարկված է։",
	lockAccountConfirmTitle: "Կողպե՞լ այս հաշիվը։",
	unlockAccountConfirmTitle: "Ապակողպե՞լ այս հաշիվը։",
	lockAccountConfirmText: "Օգտատերը չի կարողանա մտնել մինչև հաշիվը ապակողպվի։",
	unlockAccountConfirmText: "Օգտատերը կկարողանա անմիջապես նորից մտնել։",
	accountLockedMsg: "Հաշիվը կողպված է։",
	accountUnlockedMsg: "Հաշիվը ապակողպված է։",
	forcePasswordChangeConfirmTitle: "Պարտադրե՞լ գաղտնաբառի փոփոխություն հաջորդ մուտքին։",
	removeForcedPasswordChangeConfirmTitle: "Հանե՞լ պարտադիր գաղտնաբառի փոփոխությունը։",
	forcePasswordChangeConfirmText: "Օգտատերը կկարողանա մտնել միայն գաղտնաբառը փոխելու համար՝ նախքան հարթակից օգտվելը։",
	removeForcedPasswordChangeConfirmText: "Օգտատերը կկարողանա շարունակել սովորական մուտքը։",
	forcedPasswordChangeEnabled: "Պարտադիր գաղտնաբառի փոփոխությունը միացված է։",
	forcedPasswordChangeRemoved: "Պարտադիր գաղտնաբառի փոփոխությունը հանված է։",
	securityUpdated: "Անվտանգությունը թարմացված է",
	securityActionFailed: "Անվտանգության գործողությունը ձախողվեց",
	knownDevicesAndSessions: "Հայտնի սարքեր և բաց նիստեր",
	knownDevicesAndSessionsDesc: "Գտնվելու վայրերը մոտավոր են և սովորաբար ներկայացնում են IP ծագում, ISP, VPN կամ գրասենյակային դարպաս՝ ոչ թե սարքի ճշգրիտ ֆիզիկական դիրքը։",
	openSessionsBadge: "{count} բաց",
	revokeOtherSessions: "Չեղարկել այլ նիստերը",
	registeredDevices: "Գրանցված սարքեր",
	unknownDevice: "Անհայտ սարք",
	unknownBrowser: "Անհայտ զննարկիչ",
	unknownOs: "Անհայտ ՕՀ",
	browserOnOs: "{browser}՝ {os}-ում",
	firstSeen: "Առաջին անգամ տեսնվել է",
	sessionsBadge: "{count} նիստ",
	currentDevice: "Ընթացիկ սարք",
	noKnownDevices: "Հայտնի սարքեր դեռ չկան։",
	approximateLoginOrigins: "Մուտքի մոտավոր ծագումներ",
	sessionDetails: "Նիստերի մանրամասներ",
	device: "Սարք",
	network: "Ցանց",
	lastActive: "Վերջին ակտիվություն",
	approximateLocationUnavailable: "Մոտավոր գտնվելու վայրը հասանելի չէ",
	revoke: "Չեղարկել",
	noAuthSessions: "Մուտքի նիստեր դեռ չկան։",
	sessionOriginApproximateNote: "Նիստի ծագման տվյալները մոտավոր են։ IP աշխարհագրությունը մի՛ ընդունեք որպես սարքի ճշգրիտ դիրք։",
	connectedMeansNote: "«Միացված» նշանակում է, որ զննարկիչը/հավելվածը դեռ ունի կենդանի socket։ «Անջատված» նշանակում է, որ զննարկիչը փակվել է կամ անցանց է, բայց պահված մուտքի նիստը կարող է վավեր մնալ մինչև ելք, չեղարկում կամ ժամկետի ավարտ։",
	revokeThisSessionTitle: "Չեղարկե՞լ այս նիստը։",
	revokeThisSessionText: "Ընտրված սարքը/նիստը կստիպվի նորից մտնել։",
	revokeSession: "Չեղարկել նիստը",
	sessionRevoked: "Նիստը չեղարկված է",
	sessionRevokedSuccess: "Ընտրված նիստը հաջողությամբ չեղարկվել է։",
	failedToRevokeSession: "Չհաջողվեց չեղարկել նիստը",
	unableToRevokeSession: "Չհաջողվեց չեղարկել ընտրված նիստը։",
	revokeOtherSessionsTitle: "Չեղարկե՞լ այլ նիստերը։",
	revokeOtherSessionsText: "Այս օգտատիրոջ բոլոր նիստերը կչեղարկվեն՝ բացառությամբ ընթացիկի, երբ օգտատերը չեղարկում է սեփական սարքերը։",
	revokeSessions: "Չեղարկել նիստերը",
	sessionsRevoked: "Նիստերը չեղարկված են",
	revokedSessionsCount: "Չեղարկվել է {count} նիստ։",
	failedToRevokeSessions: "Չհաջողվեց չեղարկել նիստերը",
	unableToRevokeSessions: "Չհաջողվեց չեղարկել ընտրված նիստերը։",
	failedToLoadSessions: "Չհաջողվեց բեռնել նիստերը",
	unableToLoadUserSessions: "Չհաջողվեց բեռնել օգտատիրոջ նիստերը։",
	sessionStatusRevoked: "Չեղարկված",
	sessionStatusConnected: "Միացված",
	sessionStatusDisconnected: "Անջատված",
	currentSession: "Ընթացիկ",
	passwordChangeOnly: "Միայն գաղտնաբառի փոփոխություն",
	faceId: "Face ID",
	passwordsNeverShownHint: "Գաղտնաբառերը այստեղ չեն ցուցադրվում։ Օգտագործեք «Անվտանգություն» ներդիրը՝ հաշիվը կողպելու կամ ապակողպելու, գաղտնաբառի փոփոխություն պարտադրելու, ժամանակավոր գաղտնաբառ ստեղծելու կամ վերակայման հղում ուղարկելու համար։",
	sharedFolders: "Կիսված թղթապանակներ",
	flexId: "Flex Id",
	emailNotProvided: "Էլ․ փոստը նշված չէ",
	anonymousUser: "Անանուն օգտատեր",
	noMapPointsYet: "Քարտեզի կետեր դեռ չկան",
	noMapPointsYetDesc: "Մոտավոր կոորդինատներով նիստերի գտնվելու վայրեր դեռ հասանելի չեն։ Backend-ը կարող է հետևել սարքերին և նիստերին առանց աշխարհագրական մատակարարի։",
	googleMapsKeyNotConfigured: "Google Maps բանալին կարգավորված չէ",
	googleMapsKeyNotConfiguredDesc: "Սահմանեք REACT_APP_GOOGLE_MAPS_API_KEY՝ մոտավոր նիստերի քարտեզը ցուցադրելու համար։",
	mapFailedToLoad: "Քարտեզը չհաջողվեց բեռնել",
	mapFailedToLoadDesc: "Այժմ չհաջողվեց բեռնել Google Maps։",
	approximateLocation: "Մոտավոր գտնվելու վայր",
	officeInventory: "Գրասենյակային գույք",
	officeInventoryDescription: "Հաշվառեք ընկերությանը պատկանող ոչ ՏՏ գույքն ու սպառվող նյութերը։",
	infrastructure: "Ենթակառուցվածք",
	inventory: "Գույքագրում",
	fixedAssets: "Հիմնական միջոցներ",
	consumables: "Սպառվող նյութեր",
	storageStock: "Պահեստ / Պաշար",
	maintenance: "Սպասարկում",
	reservations: "Ամրագրումներ",
	receivePurchase: "Ընդունել գնումը",
	responsiblePerson: "Պատասխանատու անձ",
	storageLocation: "Պահպանման վայր",
	lowStock: "Քիչ պաշար",
	expiringSoon: "Ժամկետը շուտով լրանում է",
	underMaintenance: "Սպասարկման մեջ",
	assetNumber: "Գույքային համար",
	inventoryTransaction: "Գույքի գործարք",
	allItems: "Բոլոր գույքերը",
	addItem: "Ավելացնել գույք",
	importExcel: "Ներմուծել Excel",
	exportExcel: "Արտահանել Excel",
	printQrLabels: "Տպել QR պիտակները",
	advancedFilters: "Ընդլայնված զտիչներ",
	recentlyReceived: "Վերջերս ստացված",
	unassigned: "Չնշանակված",
	damaged: "Վնասված",
	inventoryType: "Գույքի տեսակ",
	availableQuantity: "Հասանելի քանակ",
	condition: "Վիճակ",
	location: "Տեղադրություն",
	noInventoryItems: "Գույք չի գտնվել",
	inventoryEmptyDesc: "Ավելացրեք գույքը ձեռքով կամ ընդունեք հաստատված գրասենյակային գնումը։",
	productPurpose: "Ապրանքի նպատակը / Օգտագործման համատեքստը",
	generalProduct: "Ընդհանուր ապրանք",
	officeInventoryProduct: "Գրասենյակային գույք",
	itAssetProduct: "ՏՏ ակտիվ",
	serviceProduct: "Ծառայություն",
	officeClassification: "Գրասենյակային դասակարգում",
	inventoryCreationRules: "Գույքի ստեղծման կանոններ",
	defaultDestination: "Լռելյայն նշանակման վայր",
	trackingMode: "Հաշվառման եղանակ",
	individuallyTracked: "Անհատական հաշվառում",
	batchTracked: "Խմբաքանակային հաշվառում",
	autoCreateOnReceipt: "Ընդունումից հետո ինքնաշխատ ստեղծել գույքը",
	autoGenerateAssetNumber: "Ինքնաշխատ ստեղծել գույքային համարը",
	autoGenerateQrCode: "Ինքնաշխատ ստեղծել QR կոդը",
	requireSerialNumber: "Պահանջել սերիական համար",
	requireWarranty: "Պահանջել երաշխիքային տվյալներ",
	requireExpirationDate: "Պահանջել պիտանելիության ժամկետ",
	requireInspection: "Պահանջել ստուգման ժամանակացույց",
	canBecomeBookable: "Կարող է դառնալ ամրագրվող ռեսուրս",
	totalActiveRooms: "Ակտիվ սենյակներ",
	bookingsToday: "Այսօրվա ամրագրումներ",
	activeNow: "Այժմ ակտիվ",
	pendingApprovals: "Հաստատման սպասող",
	officeMaintenanceDescription: "Գրասենյակային գույքի նորոգումներ, ստուգումներ և պլանային սպասարկում։",
	noMaintenanceRecords: "Սպասարկման գրառումներ չեն գտնվել։",
	settingsDescription: "Կարգավորեք կատեգորիաները, համարակալումը, ծանուցումները և պահեստային վայրերը։",
	rulesNumbering: "Կանոններ և համարակալում",
	requirements: "Պահանջներ",
	assetNumberFormat: "Գույքային համարի ձևաչափ",
	assetNumberTokens: "Նշիչներ՝ {YEAR}, {SEQUENCE}, {OFFICE_CODE}, {CATEGORY_CODE}",
	qrValueFormat: "QR արժեքի ձևաչափ",
	warrantyWarningDays: "Երաշխիքի զգուշացում՝ օրերով",
	expirationWarningDays: "Պիտանելիության զգուշացում՝ օրերով",
	inspectionWarningDays: "Ստուգման զգուշացում՝ օրերով",
	autoCreateBookableResources: "Ապրանքի կանոնով ինքնաշխատ ստեղծել ամրագրվող ռեսուրսներ",
	permanentInventoryLink: "Գույքի մշտական հղում",
	showQr: "Ցուցադրել QR-ը",
	downloadSvg: "Ներբեռնել SVG",
	reservedQuantity: "Ամրագրված քանակ",
	noBookableResource: "Այս գույքը ամրագրվող ռեսուրս չէ։",
	noMovements: "Դեռ շարժեր չկան։",
	disposalWarning: "Գնումների և շարժերի պատմությունը կպահպանվի, հասանելի մնացորդը կզրոյացվի, իսկ կապված ռեսուրսը կանջատվի։",
	quantityChange: "Քանակի փոփոխություն (+ կամ −)",
	issueDescription: "Խնդրի նկարագրություն",
	auditReasonHelp: "Նախորդ և նոր արժեքները, օգտատերը և ժամանակը կգրանցվեն մատյանում։",
	downloadTemplate: "Ներբեռնել ձևանմուշը",
	validatePreview: "Ստուգել և նախադիտել",
	validation: "Ստուգում",
	valid: "Վավեր",
	selectInventoryLine: "Ընտրեք առնվազն մեկ գրասենյակային գույքի տող",
	noReceivableOfficeProducts: "Այս գնման մեջ ընդունելի գրասենյակային գույքի ապրանքներ չկան։",
	serialNumbersHelp: "Մեկ սերիական համար յուրաքանչյուր տողում (կամ ստորակետով)",
	nextInspection: "Հաջորդ ստուգում",
	leaveBlankGenerate: "Ինքնաշխատ ստեղծելու համար թողեք դատարկ",
	expectedMonthlyUsage: "Սպասվող ամսական սպառում",
	expectedUsefulLifeMonths: "Սպասվող ծառայության ժամկետ (ամիս)",
	warrantyDurationMonths: "Երաշխիքի տևողություն (ամիս)",
	maintenanceIntervalDays: "Սպասարկման միջակայք (օր)",
	inspectionIntervalDays: "Ստուգման միջակայք (օր)",
	productPurposeHelp: "Ապրանքը այն է, ինչ ընկերությունը կարող է գնել․ գույքը ստեղծվում է միայն գնման ընդունումից հետո։",
	safetyCompliance: "Անվտանգություն / համապատասխանություն",
	adjust: "Ճշգրտել",
	assign: "Նշանակել",
	available: "Հասանելի",
	bookable: "Ամրագրվող",
	desk: "Աշխատատեղ",
	dispose: "Դուրս գրել",
	documents: "Փաստաթղթեր",
	expirationDate: "Պիտանելիության ժամկետ",
	floor: "Հարկ",
	inspection: "Ստուգում",
	minimumQuantity: "Նվազագույն քանակ",
	no: "Ոչ",
	notFound: "Չի գտնվել",
	notes: "Նշումներ",
	office: "Գրասենյակ",
	purchase: "Գնում",
	purchaseDate: "Գնման ամսաթիվ",
	reason: "Պատճառ",
	receivedDate: "Ընդունման ամսաթիվ",
	reorderQuantity: "Վերապատվիրման քանակ",
	resources: "Ռեսուրսներ",
	select: "Ընտրել",
	serialNumber: "Սերիական համար",
	shopPurchase: "Գնում",
	stock: "Պաշար",
	subcategory: "Ենթակատեգորիա",
	transfer: "Տեղափոխել",
	unit: "Միավոր",
	viewPurchase: "Դիտել գնումը",
	warranty: "Երաշխիք",
	print: "Տպել",
	selectAllInventory: "Ընտրել ամբողջ գույքը",
	chooseXlsxFile: "Ընտրեք .xlsx ֆայլ",
	importPreviewSummary: "Ընդամենը՝ {total} տող, վավեր՝ {valid}, սխալներով՝ {invalid}։ Անվավեր տողերը չեն ներմուծվի։",
	importValidRows: "Ներմուծել {count} վավեր տող",
	receiptReplay: "Այս ընդունումն արդեն ավարտվել է․ ցուցադրվում է սկզբնական արդյունքը։",
	inventoryRecordsCreated: "Ստեղծվել կամ թարմացվել է {count} գույքային գրառում։",
	remaining: "մնացորդ",
	assetNumbersHelp: "Մեկ գույքային համար յուրաքանչյուր տողում (կամ ստորակետով)",
	fieldIsRequired: "{field} դաշտը պարտադիր է",
	actualVacation: "Արձակուրդ",
	vacationPlanning: "Արձակուրդի պլանավորում",
	vacationPlanningPresentationHint: "Միայն պլանավորման համար․ այս ժամանակահատվածը չի փոխում հաճախումները, աշխատավարձը կամ արձակուրդի մնացորդը։",
	vacationPlanningSaved: "Արձակուրդի պլանը պահպանված է",
	vacationPlanningRemoved: "Արձակուրդի պլանը հեռացված է",
	attendanceLastRefreshed: "Վերջին թարմացումը",
	quarter: "Եռամսյակ",
	year: "Տարի",
	currentQuarter: "Ընթացիկ եռամսյակ",
	currentYear: "Ընթացիկ տարի",
	chatBlockedSection: "Արգելափակված կոնտակտներ",
	chatBlockUserConfirm: "Արգելափակե՞լ այս օգտատիրոջը։ Նա չի կարողանա գրել ձեզ այս չատում։",
};
